export default {
  about_page: {
    aim: "בוויזנט, אנו שואפים:",
    aim_1: "לפשט את תהליך בקשת הוויזה.",
    aim_2: "להבטיח את הרמות הגבוהות ביותר של אבטחה ותאימות.",
    aim_3: "לספק ערך יוצא דופן ושביעות רצון לקוחות.",
    choose: "למה <span class='text-primary'> לבחור בוי </span> זנט?",
    company_name: "חברת איוויסנט בע\"מ",
    connect: "התחבר איתנו",
    contact_us: "יש לך שאלות או זקוק לעזרה? צור איתנו קשר באמצעות:",
    customer_support_1: "סיוע 24/7 באמצעות צ'אט, דוא\"ל וטלפון.",
    customer_support_2: "תמיכה רב לשונית לקהל עולמי.",
    customer_support_title: "תמיכת לקוחות ללא תחרות",
    experience: "עם ניסיון של שנים בתהליכי תיירות ושגרירות, זיהינו את הצורך בדרך פשוטה ובטוחה יותר להגיש בקשה לויזה מהנוחות של הבית. Visanet נולדה כדי לגשר על פער זה, ומציעה שירותי eVisa ו-ETA חלקים למטיילים ברחבי העולם.",
    fast_and_secure_1: "הגש בקשה מהבית - אין צורך בביקורי שגרירות.",
    fast_and_secure_2: "אשרות שאושרו על ידי הממשלה נמסרות ישירות לדוא\"ל שלך.",
    fast_and_secure_title: "שירות מהיר ומאובטח",
    follow_us: "עקבו אחרינו ב:",
    founded: "הקמנו את Visanet במטרה לספק פתרון מהיר, בטוח ובמחיר סביר לאתגרים הנפוצים של קבלת אשרות אלקטרוניות.",
    global_presence: "הנוכחות הגלובלית שלנו:",
    img_checkmark_shield: "סימן ביקורת ירוק בתוך סמל מגן",
    img_doc_with_checkmark: "מסמך עם סמל סימן ביקורת ירוק",
    img_fast_online_service: "רקטה מהירה יוצאת מאייקון מחשב נייד",
    img_gem: "סמל פנינה כחולה",
    img_globe: "אייקון גלובוס",
    img_magnifying_glass: "זכוכית מגדלת מעל סמל המסמך",
    img_man_at_table: "איש מתוסכל יושב ליד אייקון שולחן",
    img_rocking_chair_with_cat_and_laptop: "כסא נדנדה עם חתול על שולחן עם איור 3D למחשב נייד",
    img_support_headphones: "נניח אוזניות עם סמל כתר ירוק",
    legal: "מידע משפטי",
    licensed: "Visanet הינה חברה בעלת רישיון מלא:",
    location: "מיקום",
    operate_body: "Visanet משרתת נוסעים במספר אזורים, ומציעה שירותי eVisa ו-ETA מותאמים אישית למדינות כמו הודו, ארה\"ב, וייטנאם, קנדה ועוד.",
    operate_title: "היכן אנו פו <span class='text-primary'> עלים </span>",
    our_mission: "<span class='text-primary'>המשימה שלנו </span>",
    our_story_1: "Visanet התחילה ברעיון פשוט: להפוך את בקשות הוויזה ללא מתח. התפתחנו לספק שירותים מוביל, המסייע למטיילים ברחבי העולם להשיג ויזות אלקטרוניות במהירות, בצורה מאובטחת ובמחיר סביר.",
    our_story_2: "אנו עובדים ישירות עם רשויות ההגירה כדי להבטיח ציות ולספק מסמכי נסיעה רשמיים שאושרו על ידי הממשלה. המחויבות שלנו לשקיפות ושביעות רצון הלקוחות הפכה אותנו לשם מהימן בענף.",
    our_story_title: "<span class='text-primary'>הסיפור שלנו </span>",
    registered: "רשום בבריטניה באישור ממשלתי לפעולות גלובליות.",
    successfully_processed: "מאז הקמתנו, עיבדנו בהצלחה <span class='text-primary'> מאות אלפי ויזות</span>, והעצמתנו למטיילים שירות אמין <span class='text-primary'> ונטול מתח. </span>",
    title: "על ויזנט",
    trust_1: "ניסיון של {yearsActive} שנים בענף הוויזה.",
    trust_2: "מאות אלפי יישומים מוצלחים ברחבי העולם.",
    trust_title: "מומחיות שאפשר לסמוך עליה"
  },
  about_us: "על אודות",
  academic: "אקדמי",
  accompanying_children: {
    add: "הוסף ילד מלווה",
    country_of_birth: "ארץ לידתו של הילד",
    dob: "תאריך הלידה של הילד",
    index: "ילד # {n}",
    label: "מידע ליווי ילדים",
    name: "שמו המלא של הילד"
  },
  according_to_passport: "על פי דרכון",
  aerial_only: "הויזה תקפה לכניסה <strong> אווירית (טיסה) בלבד</strong>.",
  agree_terms: "אני מסכים לתנאי השימוש של <a href=\"/terms\" target=\"_blank\"> Visanet. </a>",
  airport: "שדה תעופה",
  all_vaccinated: "כל האנשים באפליקציה חוסנו נגד COVID",
  and_connector: "ו",
  applicant: "המועמד",
  applicant_info: {
    family: "משפחה",
    occupation: "עיסוק",
    passport: "דרכון",
    pastTravels: "ביקורים קודמים",
    personal: "מידע אישי"
  },
  applicant_photos: {
    address_proof: "הוכחת כתובת",
    address_proof_desc: "מסמך שמוכיח את כתובתך (כמו חשבון שירות, הצהרת בנק, רישיון נהיגה וכו ')",
    address_proof_upload_hint: "העלה מסמך שמוכיח את כתובתך (חשבון שירות, הצהרת בנק, רישיון נהיגה וכו ')",
    bank: "הצהרת בנק",
    bank_desc: "הצהרת בנק אישית עם סכום מינימלי של 2000$ (או שווה ערך) משלושת החודשים האחרונים (כולל שם, תאריך ויתרת חשבון)",
    bank_upload_hint: "העלה הצהרת בנק אישית עם סכום מינימלי של $2000 (או שווה ערך) משלושת החודשים האחרונים",
    booking: "הזמנת מלון",
    booking_desc: "עותק של הזמנת המלון שלך, או עותק של תדפיס קורא תעודות הזהות של המארח שלך",
    booking_upload_hint: "העלה עותק של הזמנת המלון שלך או עותק של תדפיס קורא תעודות הזהות של המארח שלך",
    card: "כרטיס ביקור",
    card_desc: "כרטיס ביקור עם שמך, עמדתך, שם העסק, הכתובת ופרטי הקשר שלך כתובים עליו.",
    card_upload_hint: "מסמך עם שמך, שם העסק, המיקום, הכתובת ואמצעי הקשר שלך",
    face: "תמונת פנים",
    face_desc: "תמונה ברורה ועדכנית של הפנים שלך, השתמש ברקע לבן או בהיר (בדומה לתמונת סלפי או דרכון).",
    face_upload_hint: "תמונה ברורה של הפנים שלך עם רקע בהיר (כמו סלפי)",
    invitation: "מכתב הזמנה",
    invitation_desc: "מכתב הזמנה עם שמך, עמדתך, סיבת הביקור, הכתובת ופרטי הקשר שלך כתובים עליו.",
    invitation_upload_hint: "מכתב הזמנה עם שמך, עמדתך, סיבת הביקור, הכתובת ופרטי הקשר שלך.",
    occupation: "הוכחת עיסוק",
    occupation_desc: "מסמך המוכיח את עיסוקך, כמו רישיון עסק, חוזה עבודה, הצהרת פנסיה, כרטיס סטודנט, תעודת פרישה וכו '.",
    occupation_upload_hint: "העלה מסמך עיסוק (רישיון עסק, חוזה עבודה, הצהרת פנסיה, כרטיס סטודנט, תעודת פרישה וכו ')",
    passport: "תמונת דרכון",
    passport_desc: "תמונה ברורה ועדכנית של דף הנתונים של הדרכון שלך.",
    passport_upload_hint: "תמונה ברורה של דף הנתונים של הדרכון שלך",
    return_ticket: "כרטיס חזרה",
    return_ticket_desc: "עותק של הזמנת הטיסה חזרה לכרטיס",
    return_ticket_upload_hint: "העלה עותק של הזמנת הטיסה שלך לכרטיס חזרה",
    travel_ticket: "הזמנת נסיעות",
    travel_ticket_desc: "עותק של הזמנת הנסיעה שלך",
    travel_ticket_upload_hint: "העלה את הזמנת הנסיעות שלך"
  },
  application_id: "מזהה יישום",
  application_received: "קיבלנו את בקשת הוויזה האלקטרונית שלך",
  apply_coupon: "להגיש בקשה",
  assumed_passport_expiry: "הערכנו אוטומטית את תאריך התפוגה של הדרכון שלך",
  authority: "סמכות",
  autocompleted: "השלמה אוטומטית",
  back_to_form_bahrain: "טופס ויזה",
  back_to_form_cambodia: "טופס ויזה",
  back_to_form_canada: "טופס eTA",
  back_to_form_india: "טופס ויזה",
  back_to_form_indonesia: "טופס ויזה",
  back_to_form_israel: "טופס ETA-IL",
  back_to_form_korea: "טופס K-ETA",
  back_to_form_morocco: "טופס ויזה",
  back_to_form_new_zealand: "טופס NZeta",
  back_to_form_saudi_arabia: "טופס ויזה",
  back_to_form_sri_lanka: "טופס ויזה",
  back_to_form_thailand: "טופס ויזה",
  back_to_form_togo: "טופס ויזה",
  back_to_form_uk: "טופס eTA",
  back_to_form_usa: "טופס ESTA",
  back_to_form_vietnam: "טופס ויזה",
  bahrain: "בחריין",
  bahrain_evisa: "ויזה אלקטרונית בחריין",
  bahrain_page: {
    faq: [
      {
        a: "ויזה אלקטרונית בחריין היא אישור נסיעה אלקטרוני המאפשר לאזרחים זרים, כולל אזרחים מארה\"ב, להיכנס לבחריין לתקופה מסוימת. זה מחליף את חותמת הוויזה או המדבקה הישנה בדרכון שלך שהיית צריך לקבל מהשגרירות. עכשיו, התהליך הרבה יותר פשוט - אתה יכול בקלות לקבל את הוויזה האלקטרונית שלך בחריין ממש <a href=\"/\"> כאן באתר האינטרנט שלנו. </a>",
        q: "מהי ויזה אלקטרונית בחריין?"
      },
      {
        a: "אזרחי מדינות זכאות יכולים להגיש בקשה לויזה אלקטרונית בחריין באופן מקוון. תוכל לבדוק את רשימת המדינות הזכאות <a data-eligibility-list-opener> כאן</a>.",
        q: "מי זכאי להגיש בקשה לויזה אלקטרונית בחריין?"
      },
      {
        a: "הגשת בקשה לויזה אלקטרונית בחריין היא פשוטה. פשוט מלא את טופס <a href=\"#form\"> הוויזה המקוון</a>, העלה את המסמכים הדרושים ושלם את דמי הויזה. פשוט ככה!",
        q: "כיצד אוכל להגיש בקשה לויזה אלקטרונית בחריין?"
      },
      {
        a: "הנה מה שתצטרך: עו <ul> <li> תק של הדרכון שלך (כולל דף המשפחה, אם רלוונטי, וכל דפי מידע נוספים). </li><li>עותק של כרטיס הטיסה חזרה שאושר. </li><li>עותק של הזמנת המלון שלך בבחריין. אם אתה שוהה עם קרוב משפחה או חבר, תצטרך לספק עותק של תדפיס קורא תעודת הזהות שלהם בבחריין. </li><li>עבור ויזה ל-5 שנים (לא זמינה לכל הלאומים), הצהרת בנק המציגה יתרה מינימלית של 1000$. </li></ul>",
        q: "אילו מסמכים נדרשים לבקשת ויזה אלקטרונית בחריין?"
      },
      {
        a: "זמני העיבוד עשויים להשתנות, אך רוב הוויזות האלקטרוניות בחריין מוכנות תוך 3 עד 5 ימי עסקים. אנו ממליצים להגיש בקשה הרבה לפני תאריך הנסיעה שלך כדי להימנע מכל לחץ ברגע האחרון.",
        q: "כמה זמן לוקח לעבד ויזה אלקטרונית בחריין?"
      },
      {
        a: "העלות תלויה בסוג הוויזה שאליה אתה מגיש בקשה - בין אם זו אשרת תייר, עסקים או מעבר. אתה יכול למצוא את העמלות המפורטות בטו <a href=\"#form\"> פס שלנו כאן</a>.",
        q: "כמה עולה ויזה אלקטרונית בחריין?"
      },
      {
        a: "אנו מציעים מספר סוגים של ויזות אלקטרוניות בחריין, כולל: ויזה <ul> <li> <strong> לשבועיים: שהייה של </strong> שבועיים, כניסה יחידה. </li><li><strong>ויזה לשלושה חודשים: </strong> שהייה של חודש אחד, כניסות מרובות. </li><li><strong>ויזה לשנה: שהי </strong> יה של 3 חודשים, כניסות מרובות. </li></ul>",
        q: "אילו סוגים של ויזות אלקטרוניות בחריין זמינות?"
      },
      {
        a: "במקרים מסוימים, כן! ייתכן שתוכל להאריך את הוויזה האלקטרונית שלך לבחריין, אך תצטרך להגיש בקשה להארכה לפני שתוקף הוויזה הנוכחית שלך יפוג. האישור הוא לפי שיקול דעתן של הרשויות. לפרטים נוספים, אל תהסס <a href=\"/contact\"> לפנות אלינו</a>.",
        q: "האם אוכל להאריך את הוויזה האלקטרונית שלי לבחריין?"
      },
      {
        a: "אם הבקשה שלך נדחתה, תקבל הודעה המסבירה מדוע. ייתכן שתוכל להגיש בקשה מחדש לאחר טיפול בבעיות. אם זה קורה, פנה אלינו - אנחנו כאן כדי לעזור לך להבין את הצעדים הבאים.",
        q: "מה עלי לעשות אם בקשת הוויזה האלקטרונית שלי לבחריין נדחית?"
      },
      {
        a: "זה תלוי בסוג הויזה האלקטרונית שאליה אתה מגיש בקשה. חלקם תקפים לכניסה יחידה, בעוד שאחרים מאפשרים כניסות מרובות. הקפד לבחור את האפשרות המתאימה לצרכי הנסיעה שלך.",
        q: "האם אוכל להשתמש בויזה אלקטרונית בחריין לכניסות מרובות?"
      },
      {
        a: "משך השהייה שלך משתנה בהתאם לסוג הויזה האלקטרונית שתקבל. משך הזמן הנפוץ כולל 14 יום, 30 יום או 90 יום, כך שתוכל לבחור מה מתאים ביותר לביקור שלך.",
        q: "כמה זמן אוכל להישאר בבחריין עם ויזה אלקטרונית?"
      },
      {
        a: "שהייה מופרזת בויזה האלקטרונית שלך בחריין עלולה להוביל לקנסות, גירוש או בעיות בבקשות ויזה עתידיות. חשוב לכבד את תוקף הויזה ולוודא שאתה עוזב לפני שתוקפו.",
        q: "מה קורה אם אשאר מעבר לויזה האלקטרונית שלי לבחריין?"
      },
      {
        a: "כן, מומלץ להדפיס עותק של אישור הוויזה האלקטרונית שלך לבחריין ולשאת אותו איתך בעת נסיעה. ייתכן שתצטרך להראות את זה לפקידי ההגירה כשתגיע.",
        q: "האם עלי להדפיס את הוויזה האלקטרונית שלי לבחריין לפני הנסיעה?"
      },
      {
        a: "כן, הדרכון שלך צריך להיות בתוקף לפחות שישה חודשים מיום הכניסה לבחריין כדי להיות זכאי לוויזה אלקטרונית.",
        q: "האם הדרכון שלי נדרש להיות בעל תוקף מסוים כדי להגיש בקשה לויזה אלקטרונית בחריין?"
      },
      {
        a: "לא, הוויזה האלקטרונית בחריין אינה מאפשרת לך לעבוד. אם אתה מתכנן לעבוד בבחריין, תצטרך להגיש בקשה לויזת עבודה דרך הערוצים המתאימים, כגון השגרירות.",
        q: "האם אוכל לעבוד בבחריין עם ויזה אלקטרונית?"
      },
      {
        a: "ביטוח בריאות אינו חובה לכניסה לבחריין עם ויזה אלקטרונית, אך תמיד כדאי לקבל כיסוי בזמן נסיעה.",
        q: "האם ביטוח בריאות נדרש כדי להיכנס לבחריין עם ויזה אלקטרונית?"
      }
    ],
    meta_desc: "הגש בקשה לויזה אלקטרונית לבחריין באנגלית. קבל ויזה מבלי לבקר בשגרירות, תהליך מהיר ונוח",
    title: "ויזה אלקטרונית לבחריין - יישום מקוון קל Visanet {currentYear} {'|'}"
  },
  bill_payment: "תשלום על ידי חשבון",
  birth_city: "עיר/עיר לידה",
  birth_country: "ארץ לידה",
  birth_date: "תאריך לידה",
  blog: {
    author: "מחבר",
    blog: "בלוג",
    categories: "קטגוריות",
    description: "חקור את החדשות האחרונות, טיפים למומחים ומדריכי הדרכה לנסיעות קלות יותר. בין אם אתה זקוק לעזרה בויזה, רעיונות ליעד או עדכוני הגירה, אנחנו דואגים לך.",
    find_articles: "חפש מאמרים",
    header: "בלוג ויזנט <span class='text-primary'> </span>",
    hero_img: "אדם קורא עיתון ויושב על כיסא חוף",
    meta_desc: "חדשות, מדריכים, עדכונים ומידע חיוני על אשרות אלקטרוניות והיתרי כניסה למטיילים בחו\"ל.",
    overview_img: "איור עיתון",
    overview_title: "חדשות אחרונות",
    published_on: "פורסם ב:",
    read_more: "המשך קריאה",
    recent: "מאמרים אחרונים",
    search: "חיפוש",
    subheader: "המדריך האולטימטיבי שלך לוויזות ותובנות נסיעות",
    table_of_contents: "תוכן העניינים",
    title: "בלוג Visanet - אשרות אלקטרוניות, חדשות ועדכונים",
    updated_on: "עודכן בתאריך:",
    written_by: "נכתב על ידי"
  },
  brand: {
    name: "ויזנט"
  },
  business_address: "כתובת עסק",
  business_details: "פרטים עסקיים",
  business_name: "שם העסק",
  business_name_hint: "שם העסק באנגלית",
  cambodia: "קמבודיה",
  cambodia_evisa: "ויזה אלקטרונית בקמבודיה",
  cambodia_page: {
    faq: [
      {
        a: "אין צורך לבקר בשגרירות. אתה יכול להציג ולהדפיס את הוויזה שלך בכל מקום בעולם. דלג על התור בשדה התעופה. בסך הכל, תהליך מהיר וקל משמעותית.",
        q: "מהם היתרונות של ויזה אלקטרונית לקמבודיה?"
      },
      {
        a: "בהחלט לא נדרש. ניתן להנפיק ויזה באתר האינטרנט שלנו גם אם טרם רכשת כרטיס טיסה.",
        q: "האם עלי לקנות כרטיס טיסה לפני שליחת הבקשה?"
      },
      {
        a: "להלן שדות התעופה ומעברי הגבול היחידים המכבדים ויזה אלקטרונית לקמבודיה: נמל התעופה הבינלאומי פנו </li> <li> ם <ul> <li> פן נמל התעופה הבינלאומי סיאם ריפ צ'אם ים (קו קונג) פוי פט (בנטיאי מיאנ </li> <li> צ' </li> <li> י) באובט (סוואי ריאנג) תחנת הגבול טרופאנג קריאל (סטונג טרנג) </li> <li> שדה התעופה הבינלאומי סיהנוקוויל </li> <li> </li> <li> </li>",
        q: "האם ניתן להיכנס לקמבודיה משדה התעופה או גבול כלשהו?"
      },
      {
        a: "למרבה הצער, זה לא אפשרי. כדי לבצע שינוי בפרטים, עליך להנפיק ויזה אלקטרונית חדשה. מסיבה זו, וודא בעת מילוי הטופס שכל המידע שאתה מקליד תואם לחלוטין את הפרטים המצוינים בדרכון שלך.",
        q: "האם ניתן לבקש שינוי כלשהו בויזה לאחר שליחתה?"
      },
      {
        a: "ישנן מדינות ספציפיות שאזרחיהן אינם זקוקים לויזה: אינדונזיה, לאוס, וייטנאם, הפיליפינים, תאילנד, סינגפור ומלזיה. אם אתה אזרח בכל מדינה שאינה זו המפורטת כאן, אתה בהחלט צריך ויזה כדי להיכנס לקמבודיה.",
        q: "איך אני יודע אם אני צריך ויזה לקמבודיה?"
      },
      {
        a: "לא. המחיר והתשלום באתרים שלנו כוללים את כל העמלות, התשלום עבור ממשלת קמבודיה, כל המסים ודמי הבולים - התשלום באתרים שלנו הוא מלא וסופי, ועל כך תקבל חותמת רשמית בדרכון שלך.",
        q: "האם עלי לשלם אגרה עבור הויזה בקמבודיה?"
      },
      {
        a: "eVisa קמבודית היא תעודה אלקטרונית מהממשלה, המונפקת בפורמט PDF. ויזה זו מאפשרת כניסה לקמבודיה ותנועה בתוכה למטרות תיירותיות. הוויזה האלקטרונית משמשת תחליף נוח למסמך נייר המונפק פיזית בשגרירות לאחר המתנה ארוכה.",
        q: "מהי ויזה אלקטרונית לקמבודיה?"
      },
      {
        a: "מי שמעדיף את הדרך הנוחה והבטוחה לקבל ויזה להיכנס למדינה זרה. עם ויזה אלקטרונית לקמבודיה אתה לא צריך ללכת בפועל לשגרירות, אתה לא צריך לחכות בתור בשדה התעופה, ואתה אפילו נהנה מהחזר מלא במקרה הנדיר ביותר של דחייה.",
        q: "מי צריך ויזה אלקטרונית?"
      },
      {
        a: "בהחלט. הוויזה האלקטרונית הקמבודית תקפה למשך 90 יום. אתה יכול להיכנס לקמבודיה בכל עת שתבחר בתוך שלושת החודשים האלה.",
        q: "האם ניתן להיכנס לקמבודיה בזמן שונה מזה שצוין ב- eVisa?"
      },
      {
        a: "התשובה היא לא. במהלך שלושת החודשים שבהם הויזה שלך תקפה, אתה רשאי להיכנס לקמבודיה פעם אחת בלבד.",
        q: "האם ניתן להיכנס שוב לקמבודיה עם אותה ויזה?"
      },
      {
        a: "<p>אל תהסס לחקור את הב </a> לוג <a href=\"/blog\"> שלנו לקבלת החדשות האחרונות, עדכונים ומדריכים מקיפים לקבלת אשרות לקמבודיה. </p><p>בנוסף, הצוות שלנו מוכן להציע לך <a href=\"/contact\"> סיוע אנושי חי 24/7</a>. </p><p>תודה לך, צוות ויזנט. </p>",
        q: "יש לי שאלות נוספות"
      }
    ],
    meta_desc: "קבל ויזה אלקטרונית רשמית לקמבודיה באמצעות טופס מקוון באנגלית. הגש בקשה לויזה מבלי לבקר בשגרירות, בתהליך מהיר וקל",
    title: "ויזה אלקטרונית לקמבודיה - יישום מקוון מהיר Visanet {currentYear} {'|'}"
  },
  canada: "קנדה",
  canada_evisa: "קנדה eTA",
  canada_page: {
    faq: [
      {
        a: "eTA מייצג אישור נסיעה אלקטרוני. על מנת להיכנס למדינות מסוימות, כולל קנדה, המטיילים נדרשים לקבל אישור ממשלתי להיכנס ולהישאר במדינה. הרשאה זו נקראת אשרת כניסה, או ויזה. בעבר התהליך היה מסובך יחסית, ודרש התמודדות עם דואר פיזי. כיום בעידן הדיגיטלי, משרדי הגירה רבים מאפשרים לך להגיש בקשת ויזה באופן מקוון, ולקבל את הויזה ישירות לדוא\"ל שלך. זה נקרא ויזה אלקטרונית, ואנחנו נשמח להנפיק אותה עבורך.",
        q: "מה זה eTA?"
      },
      {
        a: "ממשלת קנדה מחייבת כל אדם שאינו אזרח קנדי לקבל ויזה לפני ההגעה לקנדה. כלומר, כמעט כל מי שנוסע לנסוע ולשהות בקנדה נדרש לקבל אשרת כניסה. למעשה, לא יורשו לעלות למטוס ללא ויזה סטנדרטית שפרטיה זהים לפרטים בדרכון.",
        q: "מי צריך ויזה אלקטרונית לקנדה?"
      },
      {
        a: "1-2 ימים לאחר הגשת הטופס המקוון באתר האינטרנט שלנו, ה- eTA של קנדה יישלח אליך כמסמך המצורף להודעת דוא\"ל בתיבת הדואר הנכנס שלך. בעזרתו תקבל חותמת רשמית בדרכון שלך כשתגיע לבקרת הגבול בכניסה לקנדה.",
        q: "איך התהליך עובד עם הויזה האלקטרונית?"
      },
      {
        a: "כן. מספר הכניסות לקנדה עם אותה ויזה הוא בלתי מוגבל. בהנחה, כמובן, שהדרכון שלך עדיין תקף ליותר משישה חודשים, וכי הוויזה שלך עדיין בתוקף",
        q: "האם אוכל להיכנס שוב לקנדה עם אותה ויזה?"
      },
      {
        a: "בכל כניסה לקנדה מותרת שהייה רציפה של עד 180 יום. לאחר היציאה מגבולות קנדה, וכניסה חוזרת, תוכלו להישאר עד 180 ימים נוספים וכן הלאה",
        q: "כמה זמן מותר לך להישאר בקנדה בכל כניסה?"
      },
      {
        a: "מרגע הוצאתו, אשרת הכניסה תקפה למשך 5 שנים. חשוב מאוד לזכור כי אשרת הכניסה מאבדת את תוקפה כאשר תוקף הדרכון שעבורו הונפקה הויזה פג",
        q: "כמה זמן תקפה אשרת קנדה?"
      },
      {
        a: "כן, בהחלט. כל אדם שאינו אזרח קנדי, ללא קשר לגיל, מחויב לקבל ויזה סטנדרטית שהונפקה עבורו.",
        q: "האם ילדים נדרשים לקבל ויזה אלקטרונית לקנדה?"
      },
      {
        a: "לא, זה לא נדרש. ניתן להנפיק אשרת כניסה גם אם טרם קנית כרטיס טיסה.",
        q: "האם עלי לרכוש כרטיס טיסה לפני הגשת בקשה?"
      },
      {
        a: "<p>-כן. אתה יכול אפילו לעשות את זה אלקטרונית <a href=\"https:/www.canada.ca/en/immigration-refugees-citizenship/services/visit-canada/extend-stay.html\" target=\"_blank\"> כאן</a>. העלות היא כ 100$ ועשויה להימשך מספר ימים. בנוסף, יש צורך לבקש הארכה לפחות חודש לפני תום הויזה, בהנחה שהנוסע שוהה בקנדה. בשל המחיר הגבוה במקצת, עדיף לעזוב את קנדה, לקבל ויזה חדשה ל -5 שנים ולהיכנס מחדש. </p>",
        q: "האם ניתן לבקש הארכה בזמן שהייתם בקנדה?"
      },
      {
        a: "לא. לאחר שליחת בקשת הוויזה למשרד ההגירה הקנדי, אין דרך לבקש שינוי בפרטי אותה בקשה. עם זאת, בהחלט ניתן להנפיק ויזה אלקטרונית נוספת.",
        q: "האם ניתן לבקש שינוי בויזה לאחר שאושרה?"
      },
      {
        a: "<p>אל תהסס לחקור את הב </a> לוג <a href=\"/blog\"> שלנו לקבלת החדשות האחרונות, העדכונים והמדריכים המקיפים להשגת ETA לקנדה. </p><p>בנוסף, הצוות שלנו מוכן להציע לך <a href=\"/contact\"> סיוע אנושי חי 24/7</a>. </p><p>תודה לך, צוות ויזנט. </p>",
        q: "יש לי שאלות נוספות"
      }
    ],
    meta_desc: "הגש בקשה לאישור נסיעה אלקטרוני לקנדה באנגלית וקבל אותו תוך יום אחד",
    title: "eTA לקנדה - ויזנט לבקשת ויזה מקו {currentYear} {'|'} ונת"
  },
  category_pages: {
    "e-visas": {
      meta_desc: "טיפים ומדריכים לטיולים למטיילים תכופים - הבלוג של Visanet מספק את המידע העדכני ביותר על נסיעות עולמיות, ויזות אלקטרוניות ו- ETA. הירשם כדי להישאר מעודכן!",
      title: "ויזות אלקטרוניות ו- ETA למטיילים תכופים • בלוג Visanet"
    },
    india: {
      meta_desc: "ויזות אלקטרוניות ואישורי נסיעה להודו - ETA להודו, אשרות שגרירות ומידע נוסף על אשרות הודיות, רק בבלוג Visanet",
      title: "הרשאות ETA ויזות אלקטרוניות להודו • בלוג Visanet"
    },
    israel: {
      meta_desc: "ויזות אלקטרוניות ואישורי נסיעה לישראל - ETA-IL לישראל, אשרות שגרירות ומידע נוסף על אשרות ישראליות, רק בבלוג Visanet",
      title: "הרשאות ויזות ETA-IL לישראל • Visanet Blog"
    },
    korea: {
      meta_desc: "ויזות אלקטרוניות ואישורי נסיעה לדרום קוריאה - K-etas לקוריאה הדרומית, אשרות שגרירות ומידע נוסף על אשרות קוריאניות, רק בבלוג Visanet",
      title: "הרשאות ויזות K-ETA לדרום קוריאה • בלוג Visanet"
    },
    news: {
      meta_desc: "חדשות תיירות למטיילים תכופים - הבלוג של Visanet מספק את המידע העדכני ביותר על ויזות אלקטרוניות, ETA והגבלות נסיעה ברחבי העולם. הירשם כדי להישאר מעודכן!",
      title: "חדשות ועדכונים למטיילים תכופים • בלוג Visanet"
    },
    travel: {
      meta_desc: "ויזות אלקטרוניות ואישורי נסיעה — מה הם מתכוונים? הבלוג של Visanet מסביר ומספק את המידע העדכני ביותר עבור נוסעים תכופים בויזות ברחבי העולם",
      title: "טיפים ומדריכים למטיילים תכופים • בלוג Visanet"
    },
    vietnam: {
      meta_desc: "ויזות אלקטרוניות ו- VOA (ויזה בהגעה) לווייטנאם - ETA לווייטנאם, אשרות שגרירות ומידע נוסף על ויזות וייטנאם, רק בבלוג Visanet",
      title: "הרשאות VOA וויזות אלקטרוניות לווייטנאם • בלוג Visanet"
    }
  },
  cc_validation_error: "פרטי הכרטיס אינם חוקיים",
  change_image: "שינוי תמונה",
  chat: "צ'אט",
  christianity: "נצרות",
  cities_or_locations: "שמות ערים או מיקומים",
  city: "עיר/עיר",
  click_drag_image: "לחץ או גרור תמונה כאן",
  click_here: "לחצו כאן",
  close: "סגור",
  collapse: "צמצם כרטיסיות",
  company_num: "מספר החברה",
  consulate_payment_note: "אם אתה בארה\"ב, התשלום אפשרי דרך הקונסוליה בלבד.",
  contact: "צור קשר",
  contact_on_pay_issue: "זקוק לעזרה? אם אתה נתקל בבעיות כלשהן במהלך התשלום, אל תהסס <a href=\"/contact\" target=\"_blank\"> לפנות אלינו</a>.",
  contact_page: {
    additional_support: "תמיכה נוספת",
    assist: "אנחנו כאן כדי לעזור בכל שאלה או בקשה. ב-Visanet, אנו מחויבים לתמיכה יוצאת דופן ולחוויה חלקה. אתה תמיד יכול להגיע אלינו באמצעות:",
    availability: "זמין בימים שני עד שישי, בין השעות 10:00-20:00.",
    available_247: "(זמין 24/7)",
    chat: "צ'אט חי",
    desk: "מחשב נייד וציוד משרדי על שולחן",
    email: "דוא\"ל",
    email_address: "כתובת דוא\"ל",
    get_in_touch: "צור איתנו קשר בכל עת דרך הערוצים הבאים:",
    header: "צור קשר עם <span class='text-primary'> ויזנט </span>",
    hours: "ראשון-חמישי, שעות{hours}, בטלפון + WhatsApp",
    meta_desc: "צור קשר עם שירות הלקוחות של Visanet בדרכים הבאות: טלפון, WhatsApp, צ'אט חי באתר ודוא\"ל. תוכל למצוא מידע נוסף בדף יצירת הקשר.",
    msg: "ההודעה שלך",
    msg_send: "שלח לנו הודעה",
    msg_send_body: "יש לך שאלה או בקשה ספציפית? מלא את הטופס למטה ואנו נחזור אליך בהקדם האפשרי.",
    msg_send_error: "שגיאה בשליחת ההודעה",
    msg_send_success: "ההודעה נשלחה בהצלחה",
    personalized_assistance: "לקבלת סיוע מותאם אישית יותר, פנה אלינו באמצעות:",
    send_msg: "שלח הודעה",
    support_247: "אפשרויות תמיכה 24/7",
    title: "צור קשר עם ויזנט {'|'} {year}"
  },
  contact_us: "צור קשר",
  continue_img_upload_later: "אתה יכול להמשיך. <br>עם הגשת הטופס, תקבל דואר אלקטרוני עם הוראות ואפשרויות להגשת התמונות שלך.",
  copy_link: "העתק קישור",
  countries_short: {
    GBR: "בריטניה"
  },
  country: "ארץ",
  coupon_applied: "קופון מוחל!",
  coupon_code: "קוד קופון",
  credit_card_charge_on_click: "על ידי לחיצה על כפתור \"שלם\", אמצעי התשלום שבחרת יחויב בסכום הסופי של:",
  credit_card_details: "🔐 הזן את פרטי כרטיס האשראי שלך:",
  crossing: {
    air: "אוויר",
    border: "שם גבול",
    flight: "מספר טיסה",
    land: "קרקע",
    radio_label: "איך אתם מתכננים לחצות את הגבול?",
    sea: "ים",
    ship: "שם הספינה"
  },
  customer_details: "פרטי לקוח",
  day: "יום",
  days: "{n}יום | {n} ימים",
  days_1: "יום אחד",
  days_10: "10 ימים",
  days_2: "2 ימים",
  days_21: "21 ימים",
  days_3: "3 ימים",
  days_4: "4 ימים",
  days_5: "5 ימים",
  days_7: "7 ימים",
  describe_incident: "תיאור קצר של המקרה",
  describe_rejection: "סיבה לדחייה",
  details: "פרטי דרכון",
  did_army: "האם שירתת בצבא?",
  did_visit_saarc: "האם ביקרת באף אחת ממדינות SAARC בשלוש השנים האחרונות?",
  discount: "הנחה",
  education: "חינוך",
  eligible_countries_title_bahrain: "מדינות זכאות ל- eVisa בבחריין",
  eligible_countries_title_cambodia: "מדינות זכאות ל- eVisa בקמבודיה",
  eligible_countries_title_canada: "מדינות זכאות ל- eTA של קנדה",
  eligible_countries_title_india: "מדינות זכאות ל- eVisa בהודו",
  eligible_countries_title_indonesia: "מדינות זכאות ל- eVisa באינדונזיה",
  eligible_countries_title_israel: "מדינות זכאות לישראל ETA-IL",
  eligible_countries_title_korea: "מדינות זכאות לקוריאה K-ETA",
  eligible_countries_title_morocco: "מדינות זכאות ל- eVisa במרוקו",
  eligible_countries_title_new_zealand: "מדינות זכאות ל- eTA של ניו זילנד",
  eligible_countries_title_saudi_arabia: "מדינות זכאות לביזה אלקטרונית של ערב הסעודית",
  eligible_countries_title_sri_lanka: "מדינות זכאות ל- eVisa בסרי לנקה",
  eligible_countries_title_thailand: "מדינות זכאות ל- eVisa בתאילנד",
  eligible_countries_title_togo: "מדינות זכאות לוויזה אלקטרונית של טוגו",
  eligible_countries_title_uk: "מדינות זכאות ל- ETA בבריטניה",
  eligible_countries_title_usa: "מדינות זכאות ל- ESTA בארה\"ב",
  eligible_countries_title_vietnam: "מדינות זכאות לוויזה אלקטרונית בווייטנאם",
  email: "דוא\"ל",
  email_images_continue: "אנא שלח את התמונות שלך לכתובת הדוא\"ל שלנו: <a href=\"mailto:{email}\" target=\"_blank\"> {email}</a>. <br>אתה יכול להמשיך לאחר מכן.",
  emails: {
    approved: {
      approval_confirmation_bahrain: "הוויזה האלקטרונית שלך לבחריין אושרה בהצלחה. עכשיו אתה מורשה לנסוע.",
      approval_confirmation_cambodia: "הוויזה האלקטרונית שלך לקמבודיה אושרה בהצלחה. עכשיו אתה מורשה לנסוע.",
      approval_confirmation_canada: "ה-eTA שלך לקנדה אושרה בהצלחה. עכשיו אתה מורשה לנסוע.",
      approval_confirmation_india: "הויזה האלקטרונית שלך להודו אושרה בהצלחה. עכשיו אתה מורשה לנסוע.",
      approval_confirmation_indonesia: "הוויזה האלקטרונית שלך לאינדונזיה אושרה בהצלחה. עכשיו אתה מורשה לנסוע.",
      approval_confirmation_israel: "ה- ETA-IL שלך לישראל אושר בהצלחה. עכשיו אתה מורשה לנסוע.",
      approval_confirmation_korea: "ה- K-ETA שלך לקוריאה אושר בהצלחה. עכשיו אתה מורשה לנסוע.",
      approval_confirmation_morocco: "הוויזה האלקטרונית שלך למרוקו אושרה בהצלחה. עכשיו אתה מורשה לנסוע.",
      approval_confirmation_new_zealand: "ה- NZeTA שלך לניו זילנד אושר בהצלחה. עכשיו אתה מורשה לנסוע.",
      approval_confirmation_saudi_arabia: "הוויזה האלקטרונית שלך לערב הסעודית אושרה בהצלחה. עכשיו אתה מורשה לנסוע.",
      approval_confirmation_sri_lanka: "הוויזה האלקטרונית שלך לסרי לנקה אושרה בהצלחה. עכשיו אתה מורשה לנסוע.",
      approval_confirmation_thailand: "הוויזה האלקטרונית שלך לתאילנד אושרה בהצלחה. עכשיו אתה מורשה לנסוע.",
      approval_confirmation_togo: "הוויזה האלקטרונית שלך לטוגו אושרה בהצלחה. עכשיו אתה מורשה לנסוע.",
      approval_confirmation_uk: "ה- ETA שלך בבריטניה לבריטניה אושר בהצלחה. עכשיו אתה מורשה לנסוע.",
      approval_confirmation_usa: "ה-ESTA שלך לארה\"ב אושרה בהצלחה. עכשיו אתה מורשה לנסוע.",
      approval_confirmation_vietnam: "הוויזה האלקטרונית שלך לווייטנאם אושרה בהצלחה. עכשיו אתה מורשה לנסוע.",
      available_via: "אם יש אי התאמה כלשהי, צור איתנו קשר מייד על ידי מענה לדוא\"ל זה או באמצעות טלפון/WhatsApp בכתובת. {phone}",
      calendar_stay_limit_bahrain: "השהייה בבחריין מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_cambodia: "השהייה בקמבודיה מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_canada: "השהייה בקנדה מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_india: "השהייה בהודו מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_indonesia: "השהייה באינדונזיה מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_israel: "השהייה בישראל מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_korea: "השהייה בקוריאה מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_morocco: "השהייה במרוקו מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_new_zealand: "השהייה בניו זילנד מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_saudi_arabia: "השהייה בערב הסעודית מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_sri_lanka: "השהייה בסרי לנקה מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_thailand: "השהייה בתאילנד מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_togo: "השהייה בטוגו מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_uk: "השהייה בבריטניה מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_usa: "השהייה בארה\"ב מוגבלת לי {days} מים בשנה קלנדרית.",
      calendar_stay_limit_vietnam: "השהייה בווייטנאם מוגבלת לי {days} מים בשנה קלנדרית.",
      canada_usa_link: "מתכננים לבקר בארה\"ב? עכשיו אתה יכול להגיש בקשה לו <a href='https://visanet.co/usa'> יזת ESTA לארצות הברית </a> 🇺🇸",
      days_to_use_bahrain: "הוויזה האלקטרונית שלך דורשת כניסה לבחריין בימים {days} הקרובים!",
      days_to_use_cambodia: "הוויזה האלקטרונית שלך דורשת כניסה לקמבודיה בימים {days} הקרובים!",
      days_to_use_canada: "ה- eTA שלך מחייב כניסה לקנדה בימים {days} הקרובים!",
      days_to_use_india: "הוויזה האלקטרונית שלך דורשת כניסה להודו בימים {days} הקרובים!",
      days_to_use_indonesia: "הוויזה האלקטרונית שלך דורשת כניסה לאינדונזיה בימים {days} הקרובים!",
      days_to_use_israel: "ה- ETA-IL שלך מחייב כניסה לישראל בימים הקרובים! {days}",
      days_to_use_korea: "ה- K-ETA שלך מחייב כניסה לקוריאה בימים {days} הקרובים!",
      days_to_use_morocco: "הוויזה האלקטרונית שלך דורשת כניסה למרוקו בימים {days} הקרובים!",
      days_to_use_new_zealand: "ה- NZeTA שלך מחייב כניסה לניו זילנד בי {days} מים הקרובים!",
      days_to_use_saudi_arabia: "הויזה האלקטרונית שלך דורשת כניסה לסעודיה בי {days} מים הקרובים!",
      days_to_use_sri_lanka: "הוויזה האלקטרונית שלך דורשת כניסה לסרי לנקה בי {days} מים הקרובים!",
      days_to_use_thailand: "הוויזה האלקטרונית שלך דורשת כניסה לתאילנד בימים {days} הקרובים!",
      days_to_use_togo: "הוויזה האלקטרונית שלך דורשת כניסה לטוגו בימים הקרובים! {days}",
      days_to_use_uk: "ה- ETA שלך בבריטניה מחייב כניסה לבריטניה בימים הקרובים! {days}",
      days_to_use_usa: "ה- ESTA שלך מחייב כניסה לארה\"ב בימים {days} הקרובים!",
      days_to_use_vietnam: "הוויזה האלקטרונית שלך דורשת כניסה לווייטנאם בי {days} מים הקרובים!",
      doc_ready_bahrain: "אנו שמחים להודיע לך שהוויזה האלקטרונית שלך לבחריין אושרה!",
      doc_ready_cambodia: "אנו שמחים להודיע לך שהוויזה האלקטרונית שלך לקמבודיה אושרה!",
      doc_ready_canada: "אנו שמחים להודיע לך שה-eTA שלך לקנדה אושרה!",
      doc_ready_india: "אנו שמחים להודיע לך שהוויזה האלקטרונית שלך להודו אושרה!",
      doc_ready_indonesia: "אנו שמחים להודיע לך שהאישור האלקטרוני שלך לאינדונזיה אושר!",
      doc_ready_israel: "אנו שמחים להודיע לך כי ה- ETA-IL שלך לישראל אושר!",
      doc_ready_korea: "אנו שמחים להודיע לך כי ה- K-ETA שלך לקוריאה אושר!",
      doc_ready_morocco: "אנו שמחים להודיע לך שהוויזה האלקטרונית שלך למרוקו אושרה!",
      doc_ready_new_zealand: "אנו שמחים להודיע לך כי ה- NZeTA שלך לניו זילנד אושר!",
      doc_ready_saudi_arabia: "אנו שמחים להודיע לך שהוויזה האלקטרונית שלך לסעודיה אושרה!",
      doc_ready_sri_lanka: "אנו שמחים להודיע לך שהוויזה האלקטרונית שלך לסרי לנקה אושרה!",
      doc_ready_thailand: "אנו שמחים להודיע לך שהאישור האלקטרוני שלך לתאילנד אושר!",
      doc_ready_togo: "אנו שמחים להודיע לך שהאישור האלקטרוני שלך לטוגו אושר!",
      doc_ready_uk: "אנו שמחים להודיע לך כי ה- ETA שלך בבריטניה עבור בריטניה אושר!",
      doc_ready_usa: "אנו שמחים להודיע לך שה-ESTA שלך לארה\"ב אושרה!",
      doc_ready_vietnam: "אנו שמחים להודיע לך שהאישור האלקטרוני שלך לווייטנאם אושר!",
      ensure_details_accurate: "אנא בדוק את כל הפרטים האישיים שלך בקפידה.",
      entries_double_bahrain: "ויזה אלקטרונית זו מאפשרת כניסה כפולה (2 כניסות) לבחריין כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_cambodia: "ויזה אלקטרונית זו מאפשרת כניסה כפולה (2 כניסות) לקמבודיה כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_canada: "eTA זה מאפשר כניסה כפולה (2 כניסות) לקנדה (כניסה כפולה) כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_india: "ויזה אלקטרונית זו מאפשרת כניסה כפולה (2 כניסות) להודו כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_indonesia: "eVisa זו מאפשרת כניסה כפולה (2 כניסות) לאינדונזיה כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_israel: "ETA-IL זה מאפשר כניסה כפולה (2 כניסות) לישראל (כניסה כפולה) כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_korea: "K-ETA זה מאפשר כניסה כפולה (2 כניסות) לקוריאה (כניסה כפולה) כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_morocco: "ויזה אלקטרונית זו מאפשרת כניסה כפולה (2 כניסות) למרוקו כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_new_zealand: "NZeTA זה מאפשר כניסה כפולה (2 כניסות) לניו זילנד כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_saudi_arabia: "ויזה אלקטרונית זו מאפשרת כניסה כפולה (2 כניסות) לסעודיה כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_sri_lanka: "eVisa זו מאפשרת כניסה כפולה (2 כניסות) לסרי לנקה כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_thailand: "eVisa זו מאפשרת כניסה כפולה (2 כניסות) לתאילנד כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_togo: "ויזה אלקטרונית זו מאפשרת כניסה כפולה (2 כניסות) לטוגו כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_uk: "ETA בבריטניה זה מאפשר כניסה כפולה (2 כניסות) לבריטניה (כניסה כפולה) כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_usa: "ESTA זה מאפשר כניסה כפולה (2 כניסות) לארה\"ב (כניסה כפולה) כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_double_vietnam: "ויזה אלקטרונית זו מאפשרת כניסה כפולה (2 כניסות) לווייטנאם כל עוד הויזה הפיזית (חותמת) נשארת בתוקף.",
      entries_multiple_bahrain: "אתה יכול להיכנס לבחריין מספר פעמים ללא הגבלות בזמן שהוויזה האלקטרונית שלך תישאר בתוקף.",
      entries_multiple_cambodia: "אתה יכול להיכנס לקמבודיה מספר פעמים ללא הגבלות בזמן שהוויזה האלקטרונית שלך תישאר בתוקף.",
      entries_multiple_canada: "אתה יכול להיכנס לקנדה מספר פעמים ללא הגבלות בזמן שה-eTA שלך נשאר בתוקף.",
      entries_multiple_india: "אתה יכול להיכנס להודו מספר פעמים ללא הגבלות בזמן שהאישור האלקטרוני שלך נשאר בתוקף.",
      entries_multiple_indonesia: "אתה יכול להיכנס לאינדונזיה מספר פעמים ללא הגבלות בזמן שהוויזה האלקטרונית שלך נשארת תקפה.",
      entries_multiple_israel: "אתה רשאי להיכנס לישראל מספר פעמים ללא הגבלות בזמן שה-ETA-IL שלך נשאר בתוקף.",
      entries_multiple_korea: "אתה יכול להיכנס לקוריאה מספר פעמים ללא הגבלות בזמן שה- K-ETA שלך נשאר בתוקף.",
      entries_multiple_morocco: "אתה יכול להיכנס למרוקו מספר פעמים ללא הגבלות בזמן שהוויזה האלקטרונית שלך תישאר בתוקף.",
      entries_multiple_new_zealand: "אתה יכול להיכנס לניו זילנד מספר פעמים ללא הגבלות בזמן ש- NZeTA שלך נשאר בתוקף.",
      entries_multiple_saudi_arabia: "אתה יכול להיכנס לסעודיה מספר פעמים ללא הגבלות בזמן שהוויזה האלקטרונית שלך תישאר בתוקף.",
      entries_multiple_sri_lanka: "אתה יכול להיכנס לסרי לנקה מספר פעמים ללא הגבלות בזמן שהוויזה האלקטרונית שלך נשארת תקפה.",
      entries_multiple_thailand: "אתה יכול להיכנס לתאילנד מספר פעמים ללא הגבלות בזמן שהוויזה האלקטרונית שלך תישאר בתוקף.",
      entries_multiple_togo: "אתה יכול להיכנס לטוגו מספר פעמים ללא הגבלות בזמן שהוויזה האלקטרונית שלך נשארת תקפה.",
      entries_multiple_uk: "אתה יכול להיכנס לבריטניה מספר פעמים ללא הגבלות בזמן שה-ETA שלך בבריטניה נשאר בתוקף.",
      entries_multiple_usa: "אתה יכול להיכנס לארה\"ב מספר פעמים ללא הגבלות בזמן שה-ESTA שלך תישאר בתוקף.",
      entries_multiple_vietnam: "אתה יכול להיכנס לווייטנאם מספר פעמים ללא הגבלות בזמן שהוויזה האלקטרונית שלך תישאר בתוקף.",
      entries_single_bahrain: "ויזה אלקטרונית זו מאפשרת כניסה יחידה לבחריין.",
      entries_single_cambodia: "eVisa זו מאפשרת כניסה יחידה לקמבודיה.",
      entries_single_canada: "eTA זה מאפשר כניסה יחידה לקנדה.",
      entries_single_india: "ויזה אלקטרונית זו מאפשרת כניסה יחידה להודו.",
      entries_single_indonesia: "eVisa זו מאפשרת כניסה יחידה לאינדונזיה.",
      entries_single_israel: "ETA-IL זה מאפשר כניסה יחידה לישראל.",
      entries_single_korea: "K-ETA זה מאפשר כניסה יחידה לקוריאה.",
      entries_single_morocco: "ויזה אלקטרונית זו מאפשרת כניסה יחידה למרוקו.",
      entries_single_new_zealand: "NZeTA זה מאפשר כניסה יחידה לניו זילנד.",
      entries_single_saudi_arabia: "ויזה אלקטרונית זו מאפשרת כניסה יחידה לסעודיה.",
      entries_single_sri_lanka: "eVisa זו מאפשרת כניסה יחידה לסרי לנקה.",
      entries_single_thailand: "eVisa זו מאפשרת כניסה יחידה לתאילנד.",
      entries_single_togo: "ויזה אלקטרונית זו מאפשרת כניסה יחידה לטוגו.",
      entries_single_uk: "ETA בבריטניה זה מאפשר כניסה יחידה לבריטניה.",
      entries_single_usa: "ESTA זה מאפשר כניסה יחידה לארה\"ב.",
      entries_single_vietnam: "ה-eVisa מאפשרת כניסה יחידה לווייטנאם.",
      eta_disclaimer_bahrain: "בעוד שה-eVisa שלך מאשרת נסיעות, הכניסה לבחריין היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה לבקרת הגבול. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלך, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_cambodia: "בעוד שהוויזה האלקטרונית שלך מאשרת נסיעות, הכניסה לקמבודיה היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה לבקרת הגבול. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלך, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_canada: "בעוד שה-eTA שלך מאשרת נסיעות, הכניסה לקנדה היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה לבקרת הגבול. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלך, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_india: "בעוד שה-eVisa שלך מאשרת נסיעות, הכניסה להודו היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה לבקרת הגבול. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלך, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_indonesia: "בעוד שהוויזה האלקטרונית שלך מאשרת נסיעות, הכניסה לאינדונזיה היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה לבקרת הגבול. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלך, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_israel: "בעוד ETA-IL שלך מאשר נסיעה, הכניסה לישראל היא בסופו של דבר על שיקול דעתם של קציני ההגירה לבקרת הגבול. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלך, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_korea: "בעוד ה- K-ETA שלך מאשר נסיעות, הכניסה לקוריאה היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה לבקרת הגבול. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלך, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_morocco: "בעוד שהוויזה האלקטרונית שלך מאשרת נסיעות, הכניסה למרוקו היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה לבקרת הגבול. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלך, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_new_zealand: "בעוד ש- NZeTA שלך מאשר נסיעות, הכניסה לניו זילנד היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה לבקרת הגבול. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלך, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_saudi_arabia: "בעוד שהוויזה האלקטרונית שלך מאשרת נסיעות, הכניסה לסעודיה היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה לבקרת הגבול. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלך, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_sri_lanka: "בעוד שה-eVisa שלך מאשרת נסיעות, הכניסה לסרי לנקה היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה לבקרת הגבול. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלך, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_thailand: "בעוד שהוויזה האלקטרונית שלך מאשרת נסיעות, הכניסה לתאילנד היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה לבקרת הגבול. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלך, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_togo: "בעוד שהוויזה האלקטרונית שלך מאשרת נסיעות, הכניסה לטוגו היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה לבקרת הגבול. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלך, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_uk: "בעוד ש-ETA שלך בבריטניה מאשרת נסיעות, הכניסה לבריטניה היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה לבקרת הגבול. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלך, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_usa: "בעוד שה-ESTA שלך מאשרת נסיעות, הכניסה לארה\"ב היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה לבקרת הגבול. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלך, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_disclaimer_vietnam: "בעוד שהוויזה האלקטרונית שלך מאשרת נסיעות, הכניסה לווייטנאם היא בסופו של דבר על פי שיקול דעתם של קציני ההגירה לבקרת הגבול. הם יקבלו את ההחלטה הסופית בהתבסס על מטרת הביקור שלך, מסלול הטיול ואנשי הקשר המקומיים.",
      eta_please_note: "שימו לב:",
      greeting: "שלום{name},",
      instruction_2_passport_pages: "עליך להחזיק לפחות 2 עמודים ריקים בדרכון שלך. עם ההגעה, הרשויות יחתמו דפים אלה.",
      instruction_dont_print_eta: "אין צורך להדפיס את זה{visaDocName}.",
      instruction_dont_print_evisa: "אין צורך להדפיס ויזה אלקטרונית זו.",
      instruction_dont_print_verification_eta: "צוות התחבורה ובקרת הגבולות יאמת אותך {visaDocName} באופן אלקטרוני. תוכל גם להציג את המכשיר {visaDocName} במכשיר הנייד שלך במידת הצורך.",
      instruction_dont_print_verification_evisa: "צוות התחבורה ובקרת הגבולות יאמת את ה- eVisa שלך באופן אלקטרוני. תוכל גם להציג את ה- eVisa במכשיר הנייד שלך במידת הצורך.",
      instruction_print_eta: "עליך להדפיס את האי {visaDocName} שור המצורף לדוא\"ל זה.",
      instruction_print_evisa: "עליך להדפיס את אישור ה- eVisa המצורף לדוא\"ל זה.",
      instruction_print_keep_handy_bahrain: "שמור את ה- eVisa המודפס בהישג יד בעת העלייה ו/או חציית הגבול בבחריין.",
      instruction_print_keep_handy_cambodia: "שמור את ה- eVisa המודפס בהישג יד בעת העלייה ו/או חציית הגבול בקמבודיה.",
      instruction_print_keep_handy_canada: "שמור את ה- eTA המודפס בהישג יד בעת העלייה ו/או חציית הגבול בקנדה.",
      instruction_print_keep_handy_india: "שמור את ה- eVisa המודפס בהישג יד בעת העלייה ו/או חציית הגבול בהודו.",
      instruction_print_keep_handy_indonesia: "שמור את ה- eVisa המודפס בהישג יד בעת העלייה ו/או חציית הגבול באינדונזיה.",
      instruction_print_keep_handy_israel: "שמור את ה- ETA-IL המודפס בהישג יד בעת העלייה ו/או חציית הגבול בישראל.",
      instruction_print_keep_handy_korea: "שמור את ה- K-ETA המודפס בהישג יד בעת העלייה ו/או חציית הגבול בקוריאה.",
      instruction_print_keep_handy_morocco: "שמור את ה- eVisa המודפס בהישג יד בעת העלייה ו/או חציית הגבול במרוקו.",
      instruction_print_keep_handy_new_zealand: "שמור את ה- NZeTA המודפס בהישג יד בעת עלייה ו/או חציית הגבול בניו זילנד.",
      instruction_print_keep_handy_saudi_arabia: "שמור את ה- eVisa המודפס בהישג יד בעת העלייה ו/או חציית הגבול בערב הסעודית.",
      instruction_print_keep_handy_sri_lanka: "שמור את ה- eVisa המודפס בהישג יד בעת העלייה ו/או חציית הגבול בסרי לנקה.",
      instruction_print_keep_handy_thailand: "שמור את ה- eVisa המודפס בהישג יד בעת העלייה ו/או חציית הגבול בתאילנד.",
      instruction_print_keep_handy_togo: "שמור את ה- eVisa המודפס בהישג יד בעת העלייה ו/או חציית הגבול בטוגו.",
      instruction_print_keep_handy_uk: "שמור את ה- ETA המודפס בבריטניה בהישג יד בעת העלייה ו/או חציית הגבול בבריטניה.",
      instruction_print_keep_handy_usa: "שמור את ה- ESTA המודפס בהישג יד בעת העלייה ו/או חציית הגבול בארה\"ב.",
      instruction_print_keep_handy_vietnam: "שמור את ה- eVisa המודפס בהישג יד בעת העלייה ו/או חציית הגבול בווייטנאם.",
      instruction_print_twice_eta: "עליך להדפיס שני עותקים של{visaDocName}.",
      instruction_print_twice_evisa: "עליך להדפיס שני עותקים של ה- eVisa.",
      instruction_print_twice_present: "הציגו עותק אחד במהלך הצ'ק-אין והשני בבדיקת הדרכונים עם ההגעה. תדפיסים בשחור לבן מקובלים.",
      instruction_return_ticket_and_accommodation_bahrain: "עם הכניסה לבחריין, עליך להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_cambodia: "עם הכניסה לקמבודיה, עליך להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_canada: "עם הכניסה לקנדה, עליך להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_india: "עם הכניסה להודו, עליך להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_indonesia: "עם הכניסה לאינדונזיה, עליך להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_israel: "עם הכניסה לישראל יש להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_korea: "עם הכניסה לקוריאה, עליך להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_morocco: "עם הכניסה למרוקו, עליכם להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_new_zealand: "עם הכניסה לניו זילנד, עליך להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_saudi_arabia: "עם הכניסה לסעודיה, עליך להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_sri_lanka: "עם הכניסה לסרי לנקה, עליך להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_thailand: "עם הכניסה לתאילנד, עליך להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_togo: "עם הכניסה לטוגו, עליך להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_uk: "עם הכניסה לבריטניה, עליך להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_usa: "עם הכניסה לארה\"ב, עליך להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_and_accommodation_vietnam: "עם הכניסה לווייטנאם, עליך להציג כרטיס טיסה חזרה או יציאה והזמנת לינה.",
      instruction_return_ticket_bahrain: "עם הכניסה לבחריין, עליך להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_cambodia: "עם הכניסה לקמבודיה, עליך להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_canada: "עם הכניסה לקנדה, עליך להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_india: "עם הכניסה להודו, עליך להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_indonesia: "עם הכניסה לאינדונזיה, עליך להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_israel: "עם הכניסה לישראל, עליך להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_korea: "עם הכניסה לקוריאה, עליך להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_morocco: "עם הכניסה למרוקו, עליך להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_new_zealand: "עם הכניסה לניו זילנד, עליך להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_saudi_arabia: "עם הכניסה לסעודיה, עליך להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_sri_lanka: "עם הכניסה לסרי לנקה, עליך להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_thailand: "עם הכניסה לתאילנד, עליך להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_togo: "עם הכניסה לטוגו, עליך להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_uk: "עם הכניסה לבריטניה, עליך להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_usa: "עם הכניסה לארה\"ב, עליך להציג כרטיס טיסה חזרה או יציאה.",
      instruction_return_ticket_vietnam: "עם הכניסה לווייטנאם, עליך להציג כרטיס טיסה חזרה או יציאה.",
      instruction_stay_reset_bahrain: "כל ביקור בבחריין מוגבל לי {days} מים רצופים.",
      instruction_stay_reset_cambodia: "כל ביקור בקמבודיה מוגבל לימים {days} רצופים.",
      instruction_stay_reset_canada: "כל ביקור בקנדה מוגבל לימים {days} רצופים.",
      instruction_stay_reset_extend: "כדי להאריך את שהותך באופן חוקי, צא והיכנס מחדש למדינה. עם הכניסה חוזרת, השהייה המותרת שלך מתאפסת לימים נוספים{days}.",
      instruction_stay_reset_extend_bahrain: "כדי להאריך את שהותך באופן חוקי, עליך לצאת מהארץ ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה מחדש, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים בבחריין.",
      instruction_stay_reset_extend_cambodia: "כדי להאריך את שהותך באופן חוקי, עליך לצאת מהארץ ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה חוזרת, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים בקמבודיה.",
      instruction_stay_reset_extend_canada: "כדי להאריך את שהותך באופן חוקי, עליך לצאת מהארץ ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה חוזרת, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים בקנדה.",
      instruction_stay_reset_extend_india: "כדי להאריך את שהותך באופן חוקי, עליך לצאת מהארץ ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה חוזרת, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים בהודו.",
      instruction_stay_reset_extend_indonesia: "כדי להאריך את שהותך באופן חוקי, עליך לצאת מהארץ ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה חוזרת, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים באינדונזיה.",
      instruction_stay_reset_extend_israel: "כדי להאריך את שהותך באופן חוקי, עליך לצאת מהארץ ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה חוזרת, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים בישראל.",
      instruction_stay_reset_extend_korea: "כדי להאריך את שהותך באופן חוקי, עליך לצאת מהארץ ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה חוזרת, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים בקוריאה.",
      instruction_stay_reset_extend_morocco: "כדי להאריך את שהותך באופן חוקי, עליך לצאת מהארץ ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה חוזרת, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים במרוקו.",
      instruction_stay_reset_extend_new_zealand: "כדי להאריך את שהותך באופן חוקי, עליך לצאת מהארץ ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה חוזרת, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים בניו זילנד.",
      instruction_stay_reset_extend_saudi_arabia: "כדי להאריך את שהותך באופן חוקי, עליך לצאת מהארץ ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה חוזרת, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים בערב הסעודית.",
      instruction_stay_reset_extend_sri_lanka: "כדי להאריך את שהותך באופן חוקי, עליך לצאת מהארץ ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה חוזרת, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים בסרי לנקה.",
      instruction_stay_reset_extend_thailand: "כדי להאריך את שהותך באופן חוקי, עליך לצאת מהארץ ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה חוזרת, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים בתאילנד.",
      instruction_stay_reset_extend_togo: "כדי להאריך את שהותך באופן חוקי, עליך לצאת מהארץ ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה חוזרת, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים בטוגו.",
      instruction_stay_reset_extend_uk: "כדי להאריך את שהותך באופן חוקי, עליך לצאת מהארץ ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה חוזרת, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים בבריטניה.",
      instruction_stay_reset_extend_usa: "כדי להאריך את שהותך באופן חוקי, עליך לצאת מהארץ ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה חוזרת, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים בארה\"ב.",
      instruction_stay_reset_extend_vietnam: "כדי להאריך את שהותך באופן חוקי, עליך לצאת מהארץ ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה חוזרת, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים בווייטנאם.",
      instruction_stay_reset_india: "כל ביקור בהודו מוגבל לימים {days} רצופים.",
      instruction_stay_reset_indonesia: "כל ביקור באינדונזיה מוגבל לימים {days} רצופים.",
      instruction_stay_reset_israel: "כל ביקור בישראל מוגבל לימים {days} רצופים.",
      instruction_stay_reset_korea: "כל ביקור בקוריאה מוגבל לימים {days} רצופים.",
      instruction_stay_reset_morocco: "כל ביקור במרוקו מוגבל לימים {days} רצופים.",
      instruction_stay_reset_new_zealand: "כל ביקור בניו זילנד מוגבל לימים {days} רצופים.",
      instruction_stay_reset_saudi_arabia: "כל ביקור בערב הסעודית מוגבל לימים {days} רצופים.",
      instruction_stay_reset_sri_lanka: "כל ביקור בסרי לנקה מוגבל לימים {days} רצופים.",
      instruction_stay_reset_thailand: "כל ביקור בתאילנד מוגבל לימים {days} רצופים.",
      instruction_stay_reset_togo: "כל ביקור בטוגו מוגבל לימים {days} רצופים.",
      instruction_stay_reset_uk: "כל ביקור בבריטניה מוגבל לימים {days} רצופים.",
      instruction_stay_reset_usa: "כל ביקור בארה\"ב מוגבל לימים {days} רצופים.",
      instruction_stay_reset_vietnam: "כל ביקור בווייטנאם מוגבל לי {days} מים רצופים.",
      instruction_travel_documents: "ייתכן שתתבקש להציג הוכחת לינה (הזמנת מלון או דירה), אמצעים כספיים לשהותך וביטוח בריאות תקף.",
      instructions_title: "הוראות חשובות",
      instructions_title_bahrain: "הוראות לביזה אלקטרונית לבחריין",
      instructions_title_cambodia: "הוראות לביזה אלקטרונית לקמבודיה",
      instructions_title_canada: "הוראות eTA לקנדה",
      instructions_title_india: "הוראות לביזה אלקטרונית להודו",
      instructions_title_indonesia: "הוראות לביזה אלקטרונית לאינדונזיה",
      instructions_title_israel: "הוראות ETA-IL לישראל",
      instructions_title_korea: "הוראות K-ETA לקוריאה",
      instructions_title_morocco: "הוראות לביזה אלקטרונית למרוקו",
      instructions_title_new_zealand: "הוראות ל- NZeTA לניו זילנד",
      instructions_title_saudi_arabia: "הוראות לביזה אלקטרונית לערב הסעודית",
      instructions_title_sri_lanka: "הוראות לביזה אלקטרונית לסרי לנקה",
      instructions_title_thailand: "הוראות לביזה אלקטרונית לתאילנד",
      instructions_title_togo: "הנחיות עבור ויזה אלקטרונית לטוגו",
      instructions_title_uk: "הנחיות עבור UK-ETA לבריטניה",
      instructions_title_usa: "הוראות ESTA לארה\"ב",
      instructions_title_vietnam: "הוראות לביזה אלקטרונית לווייטנאם",
      intent_business_bahrain: "מטרת הביקור שלך היא עסקית. אתה רשאי לנהל פעילויות עסקיות במהלך שהותך בבחריין.",
      intent_business_cambodia: "מטרת הביקור שלך היא עסקית. אתה רשאי לנהל פעילויות עסקיות במהלך שהותך בקמבודיה.",
      intent_business_canada: "מטרת הביקור שלך היא עסקית. אתה רשאי לנהל פעילויות עסקיות במהלך שהותך בקנדה.",
      intent_business_india: "מטרת הביקור שלך היא עסקית. אתה יכול לנהל פעילויות עסקיות במהלך שהותך בהודו.",
      intent_business_indonesia: "מטרת הביקור שלך היא עסקית. אתה יכול לנהל פעילויות עסקיות במהלך שהותך באינדונזיה.",
      intent_business_israel: "מטרת הביקור שלך היא עסקית. אתה רשאי לנהל פעילות עסקית במהלך שהותך בישראל.",
      intent_business_korea: "מטרת הביקור שלך היא עסקית. אתה יכול לנהל פעילויות עסקיות במהלך שהותך בקוריאה.",
      intent_business_morocco: "מטרת הביקור שלך היא עסקית. אתה יכול לנהל פעילויות עסקיות במהלך שהותך במרוקו.",
      intent_business_new_zealand: "מטרת הביקור שלך היא עסקית. אתה רשאי לנהל פעילויות עסקיות במהלך שהותך בניו זילנד.",
      intent_business_saudi_arabia: "מטרת הביקור שלך היא עסקית. אתה רשאי לנהל פעילויות עסקיות במהלך שהותך בערב הסעודית.",
      intent_business_sri_lanka: "מטרת הביקור שלך היא עסקית. אתה רשאי לנהל פעילויות עסקיות במהלך שהותך בסרי לנקה.",
      intent_business_thailand: "מטרת הביקור שלך היא עסקית. אתה יכול לנהל פעילויות עסקיות במהלך שהותך בתאילנד.",
      intent_business_togo: "מטרת הביקור שלך היא עסקית. אתה רשאי לנהל פעילויות עסקיות במהלך שהותך בטוגו.",
      intent_business_uk: "מטרת הביקור שלך היא עסקית. אתה רשאי לנהל פעילויות עסקיות במהלך שהותך בבריטניה.",
      intent_business_usa: "מטרת הביקור שלך היא עסקית. אתה רשאי לנהל פעילויות עסקיות במהלך שהותך בארה\"ב.",
      intent_business_vietnam: "מטרת הביקור שלך היא עסקית. אתה יכול לנהל פעילויות עסקיות במהלך שהותך בווייטנאם.",
      intent_tourism_bahrain: "מטרת הביקור שלך היא תיירות בלבד. אינך רשאי לעבוד או לנהל עסקים בבחריין.",
      intent_tourism_cambodia: "מטרת הביקור שלך היא תיירות בלבד. אינך רשאי לעבוד או לנהל עסקים בקמבודיה.",
      intent_tourism_canada: "מטרת הביקור שלך היא תיירות בלבד. אינך רשאי לעבוד או לנהל עסקים בקנדה.",
      intent_tourism_india: "מטרת הביקור שלך היא תיירות בלבד. אינך רשאי לעבוד או לנהל עסקים בהודו.",
      intent_tourism_indonesia: "מטרת הביקור שלך היא תיירות בלבד. אינך רשאי לעבוד או לנהל עסקים באינדונזיה.",
      intent_tourism_israel: "מטרת הביקור שלך היא תיירות בלבד. אינך רשאי לעבוד או לנהל עסקים בישראל.",
      intent_tourism_korea: "מטרת הביקור שלך היא תיירות בלבד. אסור לך לעבוד או לנהל עסקים בקוריאה.",
      intent_tourism_morocco: "מטרת הביקור שלך היא תיירות בלבד. אינך רשאי לעבוד או לנהל עסקים במרוקו.",
      intent_tourism_new_zealand: "מטרת הביקור שלך היא תיירות בלבד. אינך רשאי לעבוד או לנהל עסקים בניו זילנד.",
      intent_tourism_saudi_arabia: "מטרת הביקור שלך היא תיירות בלבד. אינך רשאי לעבוד או לנהל עסקים בערב הסעודית.",
      intent_tourism_sri_lanka: "מטרת הביקור שלך היא תיירות בלבד. אינך רשאי לעבוד או לנהל עסקים בסרי לנקה.",
      intent_tourism_thailand: "מטרת הביקור שלך היא תיירות בלבד. אינך רשאי לעבוד או לנהל עסקים בתאילנד.",
      intent_tourism_togo: "מטרת הביקור שלך היא תיירות בלבד. אינך רשאי לעבוד או לנהל עסקים בטוגו.",
      intent_tourism_uk: "מטרת הביקור שלך היא תיירות בלבד. אינך רשאי לעבוד או לנהל עסקים בבריטניה.",
      intent_tourism_usa: "מטרת הביקור שלך היא תיירות בלבד. אסור לך לעבוד או לנהל עסקים בארה\"ב.",
      intent_tourism_vietnam: "מטרת הביקור שלך היא תיירות בלבד. אינך רשאי לעבוד או לנהל עסקים בווייטנאם.",
      leave_review: "זה יחמם את ליבנו אם תשאיר המלצה או ביקורת עלינו",
      liked_service: "אהבתם את השירות שלנו?",
      passport_requirement_eta: "עליך להציג את הדרכון ששימש להגשת בקשה{visaDocName}; שום דרכון אחר לא יתקבל.",
      passport_requirement_evisa: "עליך להציג את הדרכון ששימש להגשת בקשה ל- eVisa; שום דרכון אחר לא יתקבל.",
      pleasant_flight: "אנו מאחלים לכם טיסה נעימה",
      regards: "בברכה, צוות <br/> ויזנט",
      safe_travels: "תודה שבחרת בויזנט. נסיעות בטוחות!",
      thank_you_choosing: "ותודה שבחרת בויזנט",
      upon_entering_bahrain: "עם כניסתם לבחריין,",
      upon_entering_cambodia: "עם כניסתם לקמבודיה,",
      upon_entering_canada: "עם כניסתם לקנדה,",
      upon_entering_india: "עם כניסתם להודו,",
      upon_entering_indonesia: "עם כניסתם לאינדונזיה,",
      upon_entering_israel: "עם כניסתם לישראל,",
      upon_entering_korea: "עם כניסתם לקוריאה,",
      upon_entering_morocco: "עם כניסתם למרוקו,",
      upon_entering_new_zealand: "עם כניסתם לניו זילנד,",
      upon_entering_saudi_arabia: "עם כניסתם לסעודיה,",
      upon_entering_sri_lanka: "עם כניסתם לסרי לנקה,",
      upon_entering_thailand: "עם כניסתם לתאילנד,",
      upon_entering_togo: "עם כניסתם לטוגו,",
      upon_entering_uk: "עם כניסתם לבריטניה,",
      upon_entering_usa: "עם כניסתם לארצות הברית,",
      upon_entering_vietnam: "עם כניסתם לווייטנאם,",
      valid_since_approval_eta: "{visaDocName}זה תקף {validity} מהיום, או עד שתוקף הדרכון שלך יפוג, המתרחש קודם.",
      valid_since_approval_evisa: "הויזה האלקטרונית שלך תקפה {validity} מהיום, או עד שתוקף הדרכון שלך יפוג, המתרחש קודם.",
      valid_since_entry_bahrain: "עם הכניסה לבחריין, השהייה המותרת שלך תלויה{validity}.",
      valid_since_entry_cambodia: "עם הכניסה לקמבודיה, השהייה המותרת שלך תלויה{validity}.",
      valid_since_entry_canada: "עם הכניסה לקנדה, השהייה המותרת שלך תלויה{validity}.",
      valid_since_entry_india: "עם הכניסה להודו, השהייה המותרת שלך תלויה{validity}.",
      valid_since_entry_indonesia: "עם הכניסה לאינדונזיה, השהייה המותרת שלך תלויה{validity}.",
      valid_since_entry_israel: "עם הכניסה לישראל, השהייה המותרת שלך תלויה{validity}.",
      valid_since_entry_korea: "עם הכניסה לקוריאה, השהייה המותרת שלך תלויה{validity}.",
      valid_since_entry_morocco: "עם הכניסה למרוקו, השהייה המותרת שלך תלויה{validity}.",
      valid_since_entry_new_zealand: "עם הכניסה לניו זילנד, השהייה המותרת שלך תלויה{validity}.",
      valid_since_entry_saudi_arabia: "עם הכניסה לסעודיה, השהייה המותרת שלך תלויה{validity}.",
      valid_since_entry_sri_lanka: "עם הכניסה לסרי לנקה, השהייה המותרת שלך תלויה{validity}.",
      valid_since_entry_thailand: "עם הכניסה לתאילנד, השהייה המותרת שלך תלויה{validity}.",
      valid_since_entry_togo: "עם הכניסה לטוגו, השהייה המותרת שלך תלויה. {validity}",
      valid_since_entry_uk: "עם הכניסה לבריטניה, השהייה המותרת שלך תלויה{validity}.",
      valid_since_entry_usa: "עם הכניסה לארה\"ב, השהייה המותרת שלך תלויה{validity}.",
      valid_since_entry_vietnam: "עם הכניסה לווייטנאם, השהייה המותרת שלך תלויה{validity}.",
      valid_since_specified_eta: "המעניק {visaDocName} שהייה של עד{validity}, עם תאריכים מדויקים המפורטים תחת \"תקף מ/עד\" בקובץ ה- eVisa שלך.",
      valid_since_specified_evisa: "ה- eVisa מעניקה שהייה של עד{validity}, עם תאריכים מדויקים המפורטים תחת \"תקף מ/עד\" בקובץ ה- eVisa שלך.",
      valid_since_specified_note_bahrain: "עליך לעזוב את בחריין עד תאריך תפוגה זה.",
      valid_since_specified_note_cambodia: "עליך לעזוב את קמבודיה עד תאריך תפוגה זה.",
      valid_since_specified_note_canada: "עליך לעזוב את קנדה עד תאריך תפוגה זה.",
      valid_since_specified_note_india: "עליך לעזוב את הודו עד תאריך תפוגה זה.",
      valid_since_specified_note_indonesia: "עליך לעזוב את אינדונזיה עד תאריך תפוגה זה.",
      valid_since_specified_note_israel: "עליך לעזוב את ישראל עד תאריך תפוגה זה.",
      valid_since_specified_note_korea: "עליך לעזוב את קוריאה עד תאריך תפוגה זה.",
      valid_since_specified_note_morocco: "עליך לעזוב את מרוקו עד תאריך תפוגה זה.",
      valid_since_specified_note_new_zealand: "עליך לעזוב את ניו זילנד עד תאריך תפוגה זה.",
      valid_since_specified_note_saudi_arabia: "עליך לעזוב את ערב הסעודית עד תאריך תפוגה זה.",
      valid_since_specified_note_sri_lanka: "עליך לעזוב את סרי לנקה עד תאריך תפוגה זה.",
      valid_since_specified_note_thailand: "עליך לעזוב את תאילנד עד תאריך תפוגה זה.",
      valid_since_specified_note_togo: "עליך לעזוב את טוגו עד תאריך תפוגה זה.",
      valid_since_specified_note_uk: "עליך לעזוב את בריטניה עד תאריך תפוגה זה.",
      valid_since_specified_note_usa: "עליך לעזוב את ארה\"ב עד תאריך תפוגה זה.",
      valid_since_specified_note_vietnam: "עליך לעזוב את וייטנאם עד תאריך תפוגה זה.",
      view_file_instruction: "אתה יכול להוריד בצורה מאובטחת את ה- eVisa שלך באמצעות הכפתור למטה:"
    },
    form_abandonment: {
      action_text: "כדי להקל עליך, <strong> לחץ על הכפתור למטה כדי לסיים את היישום שלך ולאבטח את {visaDocName} </strong> 🔽 שלך",
      action_text_eta: "כדי לסיים את הבקשה שלך ולאבטח את שלך{visaDocName}, <strong> פשוט לחץ על הכפתור למטה 🔽 </strong>",
      action_text_evisa: "כדי לסיים את הבקשה שלך ולאבטח את ה- eVisa שלך, <strong> פשוט לחץ על הכפתור למטה 🔽 </strong>",
      almost_ready_bahrain: "המסע שלך לבחריין כמעט מוכן!",
      almost_ready_cambodia: "המסע שלך לקמבודיה כמעט מוכן!",
      almost_ready_canada: "המסע שלך לקנדה כמעט מוכן!",
      almost_ready_india: "המסע שלך להודו כמעט מוכן!",
      almost_ready_indonesia: "המסע שלך לאינדונזיה כמעט מוכן!",
      almost_ready_israel: "המסע שלך לישראל כמעט מוכן!",
      almost_ready_korea: "המסע שלך לקוריאה כמעט מוכן!",
      almost_ready_morocco: "המסע שלך למרוקו כמעט מוכן!",
      almost_ready_new_zealand: "המסע שלך לניו זילנד כמעט מוכן!",
      almost_ready_saudi_arabia: "המסע שלך לסעודיה כמעט מוכן!",
      almost_ready_sri_lanka: "המסע שלך לסרי לנקה כמעט מוכן!",
      almost_ready_thailand: "המסע שלך לתאילנד כמעט מוכן!",
      almost_ready_togo: "המסע שלך לטוגו כמעט מוכן!",
      almost_ready_uk: "המסע שלך לבריטניה כמעט מוכן!",
      almost_ready_usa: "המסע שלך לארה\"ב כמעט מוכן!",
      almost_ready_vietnam: "המסע שלך לווייטנאם כמעט מוכן!",
      button: "השלם את בקשתך",
      closing: "נסיעות בטוחות, <br> צוות ויזנט 👋",
      greeting: "היי{name},",
      main_text_bahrain: "אתה נמצא במרחק צעד אחד בלבד מהשלמת המסע שלך לבחריין.",
      main_text_cambodia: "אתה נמצא במרחק צעד אחד בלבד מהשלמת המסע שלך לקמבודיה.",
      main_text_canada: "אתה רק צעד אחד מהשלמת המסע שלך לקנדה.",
      main_text_eta: "שמנו לב שהיית רק צעד אחד מהשלמת הב {visaDocName} קשה שלך ב- Visanet.",
      main_text_evisa: "שמנו לב שהיית רק צעד אחד מהשלמת בקשת ה- eVisa שלך ב-Visanet.",
      main_text_india: "אתה רק צעד אחד מההשלמת המסע שלך להודו.",
      main_text_indonesia: "אתה נמצא במרחק צעד אחד בלבד מהשלמת המסע שלך לאינדונזיה.",
      main_text_israel: "אתה רק צעד אחד מהשלמת המסע שלך לישראל.",
      main_text_korea: "אתה רק צעד אחד מהשלמת המסע שלך לקוריאה.",
      main_text_morocco: "אתה נמצא במרחק צעד אחד בלבד מהשלמת המסע שלך למרוקו.",
      main_text_new_zealand: "אתה רק צעד אחד מהשלמת המסע שלך לניו זילנד.",
      main_text_saudi_arabia: "אתה נמצא במרחק צעד אחד בלבד מהשלמת המסע שלך אל ערב הסעודית.",
      main_text_sri_lanka: "אתה רק צעד אחד מהשלמת המסע שלך לסרי לנקה.",
      main_text_thailand: "אתה נמצא במרחק צעד אחד בלבד מהשלמת המסע שלך לתאילנד.",
      main_text_togo: "אתה רק צעד אחד מהשלמת המסע שלך לטוגו.",
      main_text_uk: "אתה רק צעד אחד מהשלמת המסע שלך לבריטניה.",
      main_text_usa: "אתה רק צעד אחד מהשלמת המסע שלך לארה\"ב.",
      main_text_vietnam: "אתה רק צעד אחד מהשלמת המסע שלך לווייטנאם.",
      support: "אם יש לך שאלות או שאתה זקוק לסיוע, צוות התמיכה שלנו כאן כדי לעזור באמצעות דוא\"ל (פשוט השב להודעה זו), <a href='{whatsapp}'> WhatsApp </a> או <a href='tel:{phone}'> טלפון</a>."
    },
    onetime_coupon: {
      closing: "תודה על היותך לקוח מוערך של Visanet. אם יש לך שאלות, הצוות שלנו כאן 24/7 כדי לסייע לך.",
      coupon_label: "קופון",
      feedback_text: "המשוב שלך לא רק עוזר לנו להשתפר אלא גם עוזר לאחרים לגלות את השירות שלנו. כאות הכרת התודה שלנו, אנו מציעים לך קופון חד פעמי לרכישה הבאה שלך:",
      greeting: "היי{name}, <br> מזל טוב על קבלת שלך{visaDocName}! אנו שמחים לעזור לך עם תוכניות הנסיעה שלך ונשמח לשמוע על החוויה שלך.",
      greeting_eta: "👋 היי{name}, <br> אנו מקווים שהחו {visaDocName} ויה שלך הייתה חלקה וללא מאמץ! אנו שמחים לעזור לך עם תוכניות הנסיעה שלך ונשמח לשמוע על החוויה שלך.",
      greeting_evisa: "👋 היי{name}, <br> אנו מקווים שחווית ה- eVisa שלך הייתה חלקה וללא מאמץ! אנו שמחים לעזור לך עם תוכניות הנסיעה שלך ונשמח לשמוע על החוויה שלך.",
      review_label: "השאירו ביקורת",
      support: "תודה על היותך לקוח מוערך של Visanet. אם יש לך שאלות, הצוות שלנו כאן 24/7 כדי לסייע לך. השב ישירות לדוא\"ל זה או צור קשר באמצעות טלפון/WhatsApp בכתובת{phone}.",
      title: "תודה שבחרת בויזנט 💙"
    },
    order_received: {
      applicant_info: "מידע על המועמד",
      application_received_bahrain: "טופס בקשת ה- eVisa שלך בבחריין התקבל בהצלחה.",
      application_received_cambodia: "טופס בקשת eVisa בקמבודיה התקבל בהצלחה.",
      application_received_canada: "טופס בקשת eTA שלך בקנדה התקבל בהצלחה.",
      application_received_india: "טופס בקשת ה- eVisa שלך בהודו התקבל בהצלחה.",
      application_received_indonesia: "טופס בקשת ה- eVisa שלך באינדונזיה התקבל בהצלחה.",
      application_received_israel: "טופס הבקשה הישראלי ETA-IL התקבל בהצלחה.",
      application_received_korea: "טופס בקשת ה- K-ETA שלך בקוריאה התקבל בהצלחה.",
      application_received_morocco: "טופס בקשת ה- eVisa שלך במרוקו התקבל בהצלחה.",
      application_received_new_zealand: "טופס בקשת ה- NZeTA בניו זילנד התקבל בהצלחה.",
      application_received_saudi_arabia: "טופס בקשת ה- eVisa שלך בערב הסעודית התקבל בהצלחה.",
      application_received_sri_lanka: "טופס בקשת ה- eVisa שלך בסרי לנקה התקבל בהצלחה.",
      application_received_thailand: "טופס בקשת ה- eVisa שלך בתאילנד התקבל בהצלחה.",
      application_received_togo: "טופס הבקשה שלך ל- Togo eVisa התקבל בהצלחה.",
      application_received_uk: "טופס בקשת ה- ETA בבריטניה התקבל בהצלחה.",
      application_received_usa: "טופס הבקשה שלך ל- ESTA בארה\"ב התקבל בהצלחה.",
      application_received_vietnam: "טופס הבקשה eVisa שלך בווייטנאם התקבל בהצלחה",
      attention: "תשומת לב",
      available_via: "אנו זמינים באמצעות דוא\"ל (השב ישירות להודעה זו)</a>, <a href='{whatsapp}'> WhatsApp או <a href='tel:{phone}'> טלפון</a>.",
      closing: "הטוב ביותר, <br> צוות ויזנט 🙏",
      delay_alert_bahrain: "תאריך הכניסה המתוכנן שלך הוא יותר מי {daysToUse} מים מעכשיו. כדי להבטיח שהאישור האלקטרוני שלך תקף לטיול שלך, אנו נגיש את בקשת ה- eVisa שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג הוויזה שבחרת דורש כניסה תוך {daysToUse} ימים מיום ההנפקה.",
      delay_alert_cambodia: "תאריך הכניסה המתוכנן שלך הוא יותר מי {daysToUse} מים מעכשיו. כדי להבטיח שהאישור האלקטרוני שלך תקף לטיול שלך, אנו נגיש את בקשת ה- eVisa שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג הוויזה שבחרת דורש כניסה תוך {daysToUse} ימים מיום ההנפקה.",
      delay_alert_canada: "תאריך הכניסה המתוכנן שלך הוא יותר מי {daysToUse} מים מעכשיו. כדי להבטיח שה-eTA שלך תקף לטיול שלך, אנו נגיש את בקשת ה-eTA שלך 3 שבועות לפני מועד הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג ה- eTA שבחרת דורש כניסה תוך {daysToUse} ימים מיום ההנפקה.",
      delay_alert_india: "תאריך הכניסה המתוכנן שלך הוא יותר מי {daysToUse} מים מעכשיו. כדי להבטיח שהאישור האלקטרוני שלך תקף לטיול שלך, אנו נגיש את בקשת ה- eVisa שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג הוויזה שבחרת דורש כניסה תוך {daysToUse} ימים מיום ההנפקה.",
      delay_alert_indonesia: "תאריך הכניסה המתוכנן שלך הוא יותר מי {daysToUse} מים מעכשיו. כדי להבטיח שהאישור האלקטרוני שלך תקף לטיול שלך, אנו נגיש את בקשת ה- eVisa שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג הוויזה שבחרת דורש כניסה תוך {daysToUse} ימים מיום ההנפקה.",
      delay_alert_israel: "תאריך הכניסה המתוכנן שלך הוא יותר מי {daysToUse} מים מעכשיו. כדי להבטיח שה-ETA-IL שלך תקף לטיול שלך, אנו נגיש את בקשת ה- ETA-IL שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג ה- ETA-IL שבחרת דורש כניסה תוך {daysToUse} ימים מיום ההנפקה.",
      delay_alert_korea: "תאריך הכניסה המתוכנן שלך הוא יותר מי {daysToUse} מים מעכשיו. כדי להבטיח כי ה- K-ETA שלך תקף לטיול שלך, אנו נגיש את בקשת ה- K-ETA שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג ה- K-ETA שבחרת דורש כניסה תוך {daysToUse} ימים מיום ההנפקה.",
      delay_alert_morocco: "תאריך הכניסה המתוכנן שלך הוא יותר מי {daysToUse} מים מעכשיו. כדי להבטיח שהאישור האלקטרוני שלך תקף לטיול שלך, אנו נגיש את בקשת ה- eVisa שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג הוויזה שבחרת דורש כניסה תוך {daysToUse} ימים מיום ההנפקה.",
      delay_alert_new_zealand: "תאריך הכניסה המתוכנן שלך הוא יותר מי {daysToUse} מים מעכשיו. כדי להבטיח ש- NZeTA שלך תקף לטיול שלך, אנו נגיש את בקשת ה- NZeTA שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג ה- NZeTA שבחרת דורש כניסה תוך {daysToUse} ימים מיום ההנפקה.",
      delay_alert_saudi_arabia: "תאריך הכניסה המתוכנן שלך הוא יותר מי {daysToUse} מים מעכשיו. כדי להבטיח שהאישור האלקטרוני שלך תקף לטיול שלך, אנו נגיש את בקשת ה- eVisa שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג הוויזה שבחרת דורש כניסה תוך {daysToUse} ימים מיום ההנפקה.",
      delay_alert_sri_lanka: "תאריך הכניסה המתוכנן שלך הוא יותר מי {daysToUse} מים מעכשיו. כדי להבטיח שהאישור האלקטרוני שלך תקף לטיול שלך, אנו נגיש את בקשת ה- eVisa שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג הוויזה שבחרת דורש כניסה תוך {daysToUse} ימים מיום ההנפקה.",
      delay_alert_thailand: "תאריך הכניסה המתוכנן שלך הוא יותר מי {daysToUse} מים מעכשיו. כדי להבטיח שהאישור האלקטרוני שלך תקף לטיול שלך, אנו נגיש את בקשת ה- eVisa שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג הוויזה שבחרת דורש כניסה תוך {daysToUse} ימים מיום ההנפקה.",
      delay_alert_togo: "תאריך הכניסה המתוכנן שלך הוא יותר מי {daysToUse} מים מעכשיו. כדי להבטיח שהאישור האלקטרוני שלך תקף לטיול שלך, אנו נגיש את בקשת ה- eVisa שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג הוויזה שבחרת דורש כניסה תוך {daysToUse} ימים מיום ההנפקה.",
      delay_alert_uk: "תאריך הכניסה המתוכנן שלך הוא יותר מי {daysToUse} מים מעכשיו. כדי להבטיח שה-ETA שלך בבריטניה תקף לטיול שלך, אנו נגיש את בקשת ה-ETA שלך בבריטניה 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג ה- ETA בבריטניה שבחרת דורש כניסה תוך {daysToUse} ימים מיום ההנפקה.",
      delay_alert_usa: "תאריך הכניסה המתוכנן שלך הוא יותר מי {daysToUse} מים מעכשיו. כדי להבטיח שה-ESTA שלך תקפה לטיול שלך, אנו נגיש את בקשת ה- ESTA שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג ה- ESTA שבחרת דורש כניסה תוך {daysToUse} ימים מיום ההנפקה.",
      delay_alert_vietnam: "תאריך הכניסה המתוכנן שלך הוא יותר מי {daysToUse} מים מעכשיו. כדי להבטיח שהאישור האלקטרוני שלך תקף לטיול שלך, אנו נגיש את בקשת ה- eVisa שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג הוויזה שבחרת דורש כניסה תוך {daysToUse} ימים מיום ההנפקה.",
      ensure_details_accurate: "אנא ודא שכל הפרטים האישיים שלך מדויקים ותואמים את המידע בדרכון שלך.",
      estimated_entry_date: "תאריך כניסה משוער:",
      expect_receive_bahrain: "אתה יכול לצפות לקבל את ה- eVisa שלך לבחריין בכתובת דוא\"ל זו",
      expect_receive_cambodia: "אתה יכול לצפות לקבל את ה- eVisa שלך לקמבודיה בכתובת דוא\"ל זו",
      expect_receive_canada: "אתה יכול לצפות לקבל את ה- eTA שלך עבור קנדה בכתובת דוא\"ל זו",
      expect_receive_india: "אתה יכול לצפות לקבל את ה- eVisa שלך להודו בכתובת דוא\"ל זו",
      expect_receive_indonesia: "אתה יכול לצפות לקבל את ה- eVisa שלך עבור אינדונזיה בכתובת דוא\"ל זו",
      expect_receive_israel: "אתה יכול לצפות לקבל את ה- ETA-IL שלך לישראל בכתובת דוא\"ל זו",
      expect_receive_korea: "אתה יכול לצפות לקבל את ה- K-ETA שלך עבור קוריאה בכתובת דוא\"ל זו",
      expect_receive_morocco: "אתה יכול לצפות לקבל את ה- eVisa שלך למרוקו בכתובת דוא\"ל זו",
      expect_receive_new_zealand: "אתה יכול לצפות לקבל את ה- NZeTA שלך לניו זילנד בכתובת דוא\"ל זו",
      expect_receive_saudi_arabia: "אתה יכול לצפות לקבל את ה- eVisa שלך עבור ערב הסעודית בכתובת דוא\"ל זו",
      expect_receive_sri_lanka: "אתה יכול לצפות לקבל את ה- eVisa שלך לסרי לנקה בכתובת דוא\"ל זו",
      expect_receive_thailand: "אתה יכול לצפות לקבל את ה- eVisa שלך לתאילנד בכתובת דוא\"ל זו",
      expect_receive_togo: "אתה יכול לצפות לקבל את ה- eVisa שלך לטוגו בכתובת דוא\"ל זו",
      expect_receive_uk: "אתה יכול לצפות לקבל את ה- ETA שלך בבריטניה עבור בריטניה בכתובת דוא\"ל זו",
      expect_receive_usa: "אתה יכול לצפות לקבל את ה- ESTA שלך לארה\"ב בכתובת דוא\"ל זו",
      expect_receive_vietnam: "אתה יכול לצפות לקבל את ה- eVisa שלך עבור וייטנאם בכתובת דוא\"ל זו",
      greeting: "שלום{name},",
      here_to_help: "אנחנו כאן כדי לעזור לכם ליהנות מנסיעות חלקות!",
      no_further_action: "אם כל המידע נכון, לא נדרשת פעולה נוספת מצידך. בקשת הוויזה שלך נמצאת כעת בידינו, ואנחנו נדאג לכל דבר מכאן.",
      order_details: "{id}פרטי מספר הזמנה:",
      passport_expiration: "תפוגת דרכון",
      passport_issue: "תאריך הוצאת דרכון",
      payment_receipt: "הודעת דוא\"ל נפרדת נשלח עם קבלת התשלום שלך.",
      photos_needed: "🚨 כדי להמשיך לעבד את בקשתך, <u> אנא שלח לנו את התמונות הבאות עבור כל מועמד: </u>",
      processing_bahrain: "הטופס שלך מעובד כעת ויוגש מייד כבקשה רשמית למחלקת ההגירה של בחריין.",
      processing_cambodia: "הטופס שלך מעובד כעת ויוגש מייד כבקשה רשמית למחלקת ההגירה של קמבודיה.",
      processing_canada: "הטופס שלך מעובד כעת ויוגש מייד כבקשה רשמית למחלקת ההגירה של קנדה.",
      processing_india: "הטופס שלך מעובד כעת ויוגש מייד כבקשה רשמית למחלקת ההגירה של הודו.",
      processing_indonesia: "הטופס שלך מעובד כעת ויוגש מייד כבקשה רשמית למחלקת ההגירה של אינדונזיה.",
      processing_israel: "הטופס שלך נמצא כעת בעיבוד ויוגש מייד כבקשה רשמית למחלקת ההגירה בישראל.",
      processing_korea: "הטופס שלך מעובד כעת ויוגש מייד כבקשה רשמית למחלקת ההגירה של קוריאה.",
      processing_morocco: "הטופס שלך מעובד כעת ויוגש מייד כבקשה רשמית למחלקת ההגירה של מרוקו.",
      processing_new_zealand: "הטופס שלך מעובד כעת ויוגש מייד כבקשה רשמית למחלקת ההגירה של ניו זילנד.",
      processing_saudi_arabia: "הטופס שלך מעובד כעת ויוגש מייד כבקשה רשמית למחלקת ההגירה של ערב הסעודית.",
      processing_sri_lanka: "הטופס שלך מעובד כעת ויוגש מייד כבקשה רשמית למחלקת ההגירה של סרי לנקה.",
      processing_thailand: "הטופס שלך מעובד כעת ויוגש מייד כבקשה רשמית למחלקת ההגירה של תאילנד.",
      processing_time_label: "זמן עיבוד:",
      processing_time_text: "עד {days} ימי עסקים",
      processing_time_text_1: "עד יום העסקים הבא.",
      processing_time_text_1_2_days: "עד 1-2 ימי עסקים",
      processing_time_text_3_days: "עד 3 ימי עסקים",
      processing_time_text_5_days: "עד 5 ימי עסקים",
      processing_time_text_few_hours: "עד כמה שעות",
      processing_time_text_next_day: "עד יום העסקים הבא",
      processing_togo: "הטופס שלך מעובד כעת ויוגש מייד כבקשה רשמית למחלקת ההגירה של טוגו.",
      processing_uk: "הטופס שלך מעובד כעת ויוגש מייד כבקשה רשמית למחלקת ההגירה של בריטניה.",
      processing_usa: "הטופס שלך נמצא כעת בעיבוד ויוגש מייד כבקשה רשמית למחלקת ההגירה של ארה\"ב.",
      processing_vietnam: "הטופס שלך מעובד כעת ויוגש מייד כבקשה רשמית למחלקת ההגירה של וייטנאם.",
      product: "סוג ויזה:",
      quantity: "כמות:",
      send_photos_via: "אתה יכול לשלוח את התמונות על ידי מענה לדוא\"ל זה או באמצעות <a href='{whatsapp}'> WhatsApp</a>.",
      thank_you_choosing: "תודה שבחרת בויזנט",
      thank_you_order: "תודה על ההזמנה שלך!",
      total_price: "סה\"כ מחיר:",
      urgent_order: "הזמנה דחופה:",
      within_business_days: "בתוך {days} ימי עסקים.",
      within_business_days_1: "עד יום העסקים הבא.",
      within_business_days_1_2_days: "תוך 1-2 ימי עסקים.",
      within_business_days_3_days: "תוך 3 ימי עסקים.",
      within_business_days_5_days: "תוך 5 ימי עסקים.",
      within_business_days_few_hours: "בתוך כמה שעות.",
      within_business_days_next_day: "ביום העסקים הבא."
    },
    order_status: {
      closing: "בברכה, צוות <br> ויזנט",
      current_status: "ℹ מצב נוכחי:",
      greeting: "שלום{name}, <br> אנחנו כאן כדי לעדכן אותך על מצב ההזמנה שלך! להלן, תמצא את העדכונים האחרונים. תהיו בטוחים שאנו מחויבים להפוך את עיבוד הויזה שלכם לחלק ככל האפשר.",
      help_section: "<strong>❓ זקוק לעזרה או יש לך שאלות? </strong><br>אל תהס <a href='https://visanet.co/contact'> ס לפנות אל </a> ינו בכל עת.",
      status: {
        active: {
          approval_time: "האישור אורך בדרך כלל {days} ימי עסקים.",
          approval_time_1_2_days: "האישור אורך בדרך כלל 1-2 ימי עסקים.",
          approval_time_3_days: "האישור אורך בדרך כלל 3 ימי עסקים.",
          approval_time_5_days: "האישור אורך בדרך כלל 5 ימי עסקים.",
          approval_time_few_hours: "האישור בדרך כלל לוקח כמה שעות.",
          approval_time_next_day: "האישור אורך בדרך כלל עד יום עסקים אחד.",
          description: "קיבלנו בהצלחה את בקשתך. תחזיק מעמד - תהליך האישור נמצא בעיצומו ובדרך כלל לוקח {days} ימים.",
          description_1_2_days: "קיבלנו בהצלחה את בקשתך. הבקשה שלך נמצאת כעת בבדיקה. האישור אורך בדרך כלל 1-2 ימי עסקים.",
          description_3_days: "קיבלנו בהצלחה את בקשתך. הבקשה שלך נמצאת כעת בבדיקה. האישור אורך בדרך כלל 3 ימי עסקים.",
          description_5_days: "קיבלנו בהצלחה את בקשתך. הבקשה שלך נמצאת כעת בבדיקה. האישור אורך בדרך כלל 5 ימי עסקים.",
          description_few_hours: "קיבלנו בהצלחה את בקשתך. הבקשה שלך נמצאת כעת בבדיקה. האישור בדרך כלל לוקח כמה שעות.",
          description_next_day: "קיבלנו בהצלחה את בקשתך. הבקשה שלך נמצאת כעת בבדיקה. האישור אורך בדרך כלל עד יום עסקים אחד.",
          title: "פעיל"
        },
        canceled: {
          description: "ההזמנה שלך בוטלה.",
          title: "בוטל"
        },
        completed: {
          description: "מזל טוב! בקשתך אושרה, ושלחנו לך בדוא\"ל את כל הפרטים הרלוונטיים.",
          title: "הושלם"
        },
        issue: {
          description: "נראה שיש בעיה עם הבקשה שלך. אנא בדוק את תיבת הדואר הנכנס שלך לפרטים.",
          title: "גיליון"
        }
      },
      thank_you: "תודה שבחרת ב-Visanet לצרכי הנסיעה שלך."
    },
    resume_url: {
      action_text: "כדי להפוך את הדברים לחלקים יותר עבורך, <strong> פשוט לחץ על הכפתור למטה כדי לחדש את מילוי הטופס שלך ולאבטח את תוכניות הנסיעה שלך </strong> 🔽",
      almost_ready_bahrain: "הטיול הקרוב שלך לבחריין כמעט מוכן לסיום!",
      almost_ready_cambodia: "הטיול הקרוב שלך לקמבודיה כמעט מוכן לסיום!",
      almost_ready_canada: "הטיול הקרוב שלך לקנדה כמעט מוכן לסיום!",
      almost_ready_india: "הטיול הקרוב שלך להודו כמעט מוכן לסיום!",
      almost_ready_indonesia: "הטיול הקרוב שלך לאינדונזיה כמעט מוכן לסיום!",
      almost_ready_israel: "הטיול הקרוב שלכם לישראל כמעט מוכן לסיום!",
      almost_ready_korea: "הטיול הקרוב שלך לקוריאה כמעט מוכן לסיום!",
      almost_ready_morocco: "הטיול הקרוב שלך למרוקו כמעט מוכן לסיום!",
      almost_ready_new_zealand: "הטיול הקרוב שלך לניו זילנד כמעט מוכן לסיום!",
      almost_ready_saudi_arabia: "הטיול הקרוב שלך בערב הסעודית כמעט מוכן לסיום!",
      almost_ready_sri_lanka: "הטיול הקרוב שלך לסרי לנקה כמעט מוכן לסיום!",
      almost_ready_thailand: "הטיול הקרוב שלך לתאילנד כמעט מוכן לסיום!",
      almost_ready_togo: "הטיול הקרוב שלך לטוגו כמעט מוכן לסיום!",
      almost_ready_uk: "הטיול הקרוב שלך לבריטניה כמעט מוכן לסיום!",
      almost_ready_usa: "הטיול הקרוב שלך לארה\"ב כמעט מוכן לסיום!",
      almost_ready_vietnam: "הטיול הקרוב שלך לווייטנאם כמעט מוכן לסיום!",
      button: "המשך הטופס שלך",
      closing: "מאחל לכם נסיעות בטוחות ונעימות, <br> צוות ויזנט 👋",
      greeting: "היי{name},",
      main_text_eta: "נראה שאתה נמצא במרחק צעדים ספורים ממילוי הטו {visaDocName} פס שלך ב- Visanet.",
      main_text_evisa: "נראה שאתה נמצא במרחק צעדים ספורים ממילוי טופס ה-eVisa שלך ב-Visanet.",
      support: "אם אתה זקוק לעזרה כלשהי או יש לך שאלות, צוות התמיכה שלנו מוכן לסייע לך. <br>אל תהסס להשיב לדוא\"ל זה, או ליצור איתנו קשר באמצעות <a href='{whatsapp}'> WhatsApp </a> או <a href='tel:{phone}'> טלפון</a>."
    },
    wrapper: {
      confidentiality_notice: "🔐 הודעת סודיות: הודעה זו מכילה מידע המיועד לנמען בלבד. אם התקבל בטעות, אנא הודע לנו מייד ומחק דוא\"ל זה.",
      legal_notice: "ℹ️ אתה מקבל דוא\"ל זה מכיוון שהגשת בקשה לויזה דרך {domain} האתר. <br>🔒 <strong> הודעת סודיות</strong>: דוא\"ל זה וכל קובץ מצורף מיועד אך ורק לנמען/ים המיועדים ועשויים להכיל מידע סודי. כל סקירה, שימוש, גילוי או הפצה בלתי מורשים של תקשורת זו אסורים בהחלט. אם אינך הנמען המיועד, אנא הודע לשולח באופן מיידי על ידי מענה לדוא\"ל זה, מחק הודעה זו והשמיד את כל העותקים שלה.",
      legal_notice_abandonment: "ℹ️ קיבלת דוא\"ל זה מכיוון שהתחלת למלא טופס בקשה לויזה בכתובת{domain}.",
      legal_notice_approved_eta: "ℹ️ קיבלת דוא\"ל זה מכיוון שהגשת בקשה לקבלת דיוו {docName} ח{domain}.",
      legal_notice_approved_evisa: "ℹ️ קיבלת דוא\"ל זה מכיוון שהגשת בקשה ל- eVisa באמצעות{domain}.",
      legal_notice_coupon: "ℹ️ קיבלת דוא\"ל זה מכיוון שהשלמת לאחרונה בקשת ויזה בכתובת{domain}.",
      legal_notice_received: "ℹ️ קיבלת דוא\"ל זה מכיוון שהגשת בקשה לויזה דרך{domain}.",
      legal_notice_resume: "ℹ️ קיבלת דוא\"ל זה מכיוון ששמרת את טופס הוויזה שלך בכתובת{domain}.",
      legal_notice_status: "ℹ️ קיבלת דוא\"ל זה מכיוון שביקשת עדכון סטטוס לגבי בקשת הוויזה שלך בכתובת{domain}.",
      privacy_policy: "מדיניות פרטיות"
    }
  },
  emergency_contact: "קשר חירום",
  emergency_contact_address: "כתובת איש קשר לשעת חירום",
  emergency_contact_full_name: "שמו המלא של איש הקשר לשעת חירום",
  emergency_contact_phone: "מספר הטלפון של איש הקשר לשעת חירום",
  emergency_contact_relation: "מערכת יחסים",
  employee: "עובד",
  empty_if_unknown: "אם לא ידוע, השאר ריק.",
  eng_as_in_passport: "⚠️ הזן באנגלית, בדיוק כפי שמוצג בדרכון שלך.",
  ensure_correct_email_bahrain: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_cambodia: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_canada: "ה- eTA יישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_india: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_indonesia: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_israel: "ה- ETA-IL שלך יישלח לכאן. אנא בדוק שוב את הדיוק.",
  ensure_correct_email_korea: "ה- K-ETA יישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_morocco: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_new_zealand: "ה- NZeTA יישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_saudi_arabia: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_sri_lanka: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_thailand: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_togo: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_uk: "ה- eTA יישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_usa: "ה- ESTA יישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_vietnam: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  estimate_date: "אתה יכול להעריך שנה ותאריך משוערים.",
  estimate_entry_date_5_years_valid: "אין צורך להיות מדויק. הויזה תקפה למשך 5 שנים מרגע ההנפקה.",
  estimate_entry_date_year_valid: "אין צורך להיות מדויק. הויזה תקפה למשך שנה מרגע ההנפקה.",
  estimate_entry_in_2_years: "אין צורך להיות מדויק. הויזה שלך תישאר בתוקף עד שנתיים ממועד ההנפקה.",
  estimate_entry_in_half_year: "אין צורך להיות מדויק. אתה תהיה רשאי להיכנס למדינה עד שישה חודשים מרגע ההנפקה",
  estimate_one_min: "אתה יכול להעריך. בחירת מקום אחד מספיקה.",
  estimate_port_entry: "אתה יכול להעריך. הכניסה מותרת דרך כל הנמלים הרשומים.",
  estimate_visa_5_years: "אין צורך להיות מדויק. הויזה תקפה למשך 5 שנים מרגע ההנפקה.",
  eta: "ETA | תעודות",
  eta_long: "אישור נסיעה אלקטרוני | אישורי נסיעה אלקטרוניים",
  ever_convicted: "האם הורשעתם פעם בפשע?",
  ever_refused_entry: "האם אי פעם סירבו לך כניסה לארץ כלשהי?",
  ever_visited_bahrain: "האם ביקרת אי פעם בבחריין בעבר?",
  ever_visited_cambodia: "האם ביקרת אי פעם בקמבודיה בעבר?",
  ever_visited_canada: "האם ביקרתם פעם בקנדה בעבר?",
  ever_visited_india: "האם ביקרת בעבר בהודו?",
  ever_visited_indonesia: "האם ביקרת אי פעם באינדונזיה בעבר?",
  ever_visited_israel: "האם ביקרת בישראל בעבר?",
  ever_visited_korea: "האם ביקרת בעבר בדרום קוריאה?",
  ever_visited_morocco: "האם ביקרתם פעם במרוקו בעבר?",
  ever_visited_new_zealand: "האם ביקרתם פעם בניו זילנד בעבר?",
  ever_visited_saudi_arabia: "האם ביקרתם בעבר בערב הסעודית?",
  ever_visited_sri_lanka: "ביקרת אי פעם בסרי לנקה בעבר?",
  ever_visited_thailand: "האם ביקרת אי פעם בתאילנד בעבר?",
  ever_visited_togo: "האם אי פעם ביקרת בטוגו בעבר?",
  ever_visited_uk: "האם ביקרת אי פעם בבריטניה בעבר?",
  ever_visited_usa: "האם אי פעם ביקרת בארצות הברית בעבר?",
  ever_visited_vietnam: "האם אי פעם ביקרת בווייטנאם בעבר?",
  evisa: "ויסה אלקטרונית | eVisas",
  evisa_long: "ויזה אלקטרונית | אשרות אלקטרוניות",
  evisas: "אשרות אלקטרוניות",
  exactly_as_in_passport: "הפרטים שאתה מזן <strong> חייבים להתאים בדיוק לדרכון שלך</strong>.",
  expected_entry_date: "תאריך כניסה מתוכנן",
  expected_entry_port: "נמל כניסה מתוכנן",
  expected_exit_date: "תאריך יציאה מתוכנן",
  expected_exit_port: "נמל יציאה מתוכנן",
  expected_stay_address_bahrain: "כתובת מגורים מתוכננת בבחריין",
  expected_stay_address_cambodia: "כתובת מגורים מתוכננת בקמבודיה",
  expected_stay_address_canada: "כתובת מגורים מתוכננת בקנדה",
  expected_stay_address_india: "כתובת מגורים מתוכננת בהודו",
  expected_stay_address_indonesia: "כתובת מגורים מתוכננת באינדונזיה",
  expected_stay_address_israel: "כתובת מגורים מתוכננת בישראל",
  expected_stay_address_korea: "כתובת מגורים מתוכננת בקוריאה",
  expected_stay_address_morocco: "כתובת מגורים מתוכננת במרוקו",
  expected_stay_address_new_zealand: "כתובת מגורים מתוכננת בניו זילנד",
  expected_stay_address_saudi_arabia: "כתובת מגורים מתוכננת בערב הסעודית",
  expected_stay_address_sri_lanka: "כתובת מגורים מתוכננת בסרי לנקה",
  expected_stay_address_thailand: "כתובת מגורים מתוכננת בתאילנד",
  expected_stay_address_togo: "כתובת מגורים מתוכננת בטוגו",
  expected_stay_address_uk: "כתובת מגורים מתוכננת בבריטניה",
  expected_stay_address_usa: "כתובת מגורים מתוכננת בארה\"ב",
  expected_stay_address_vietnam: "כתובת מגורים מתוכננת בווייטנאם",
  explore_visa_options: "ויזות שאנחנו מוציאים",
  extra_nationality: {
    birth: "מלידה",
    from: "מתי קיבלת את הלאום הזה?",
    has: "לאום נוסף",
    how: "כיצד נרכשה הלאום?",
    naturalization: "על ידי התאזרחות",
    none: "אין לי אזרחות אחרת",
    parents: "דרך ההורים",
    past: "היה לי אזרחות אחרת בעבר",
    present: "כרגע יש לי אזרחות אחרת",
    until: "מתי פג האזרחות?"
  },
  failure_page: {
    chat: "חלון הצ'אט אמור להיפתח באופן אוטומטי. אתם מוזמנים לשלוח לנו מילה שם ואנו ננסה לענות במהירות.",
    contact: "אנא {link} ואנו נעזור לך לבצע תשלום מאובטח, ולהתקדם עם הנפקת הויזה האלקטרונית שלך.",
    failed: "התשלום נכשל",
    oops: "אופס! לא הצלחנו לחייב אותך.",
    sad_emoji_img: "איור אמוג'י כחול עצוב",
    saved: "אבל <span class='text-primary'> אל דאגה </span> - הטופס שלך נשמר במערכת שלנו."
  },
  faq: "<span class='text-primary'>שאלות נפוצות </span>",
  faq_img: "איור סימן שאלה",
  father_country: "ארץ הולדתו של האב",
  father_name: "שם האב",
  female: "נקבה",
  final_price_note: "כל המסים והעמלות כלולים. אין עלויות נסתרות.",
  first_name: "שם פרטי",
  five_stars: "5 כוכבים",
  follow_us: "להירשם כמנוי",
  footer: {
    contact: "אנשי קשר",
    explore: "לחקור",
    visas: "חשבונות אלקטרוניים ו- ETA"
  },
  form_modified_by_other: "הטופס שונה על ידי כרטיסייה או מכשיר אחר.",
  form_review: {
    applicant_details: "סקירת דרכון",
    checkbox: "אני מאשר שכל הפרטים שסופקו מדויקים ותואמים את הדרכון שלי.",
    date_of_expiry: "תאריך תפוגה",
    date_of_issue: "תאריך ההנפקה",
    ensure_note: "אנא ודא שכל הפרטים בדף זה נכונים.",
    mistake_back: "מצאת טעות? אתה יכול לחזור לתקן את זה.",
    number: "מספר דרכון",
    order_details: "סיכום הזמנה",
    quantity: "מספר המועמדים:",
    total_price: "סה\"כ מחיר:"
  },
  form_saved_in_system: "טופס הבקשה שלך נשמר כעת במערכת שלנו",
  form_steps: {
    details: "פרטים",
    payment: "תשלום",
    review: "סקירה",
    upload: "תמונות",
    visa_select: "בחירת ויזה"
  },
  from_price: "{price}",
  full_name: "שם מלא",
  global_faqs: [
    {
      a: "<p>🔐 התשלום וכל המידע שהוזן באתרים שלנו הוא בסביבה מאובטחת ומוצפנת בכפוף לתקנים המחמירים ביותר: SSL ו- PCI של{currentYear}. </p>\n<p>🛡️ אבטחת נתונים ופרטיות הם בראש סדר העדיפויות שלנו. הנתונים שלך מוגנים ברמה הגבוהה ביותר, על פי הסטנדרטים המחמירים והמעודכנים ביותר המשמשים ארגונים כגון בנקים ואתרים ממשלתיים. </p>\n<p>🤝 אנו מתחייבים שלא נעשה כל שימוש בפרטים האישיים שאתה מסר לנו למעט השלמת המטרה אליה התחייבנו - הנפקת ויזה אלקטרונית עבורך. </p>\n<p>ℹ️ מידע נוסף ניתן למצוא </a> בדף מדיניות הפר <a href=\"/privacy\" target=\"_blank\"> טיות של אתר האינטרנט שלנו. </p>",
      q: "מהי מדיניות האבטחה שלך והאם ניתן לסמוך עליה?"
    },
    {
      a: "<p>יצרנו {domain} במטרה לספק פתרון מקצועי, מהיר, מאובטח ובמחיר סביר לבעיה הידועה של קבלת ויזה למדינה זרה. הניסיון שלנו בתחום התיירות והניהול הדיפלומטי ברחבי העולם הוביל אותנו למסקנה שאין דרך קלה, בטוחה ורווחית להשיג ויזה למדינה זרה, במיוחד לישראלים. לכן יצרנו {domain} - באתר שלנו נעזור לכם לקבל אשרות אלקטרוניות למדינות שונות מבלי לעזוב את ביתכם ובמחירים הנמוכים ביותר במדינה! </p><p>🛡️ ויזנט הינה חברה רשמית ומקצועית העובדת בתחום הנפקת אשרות מזה שנים{yearsActive}. תוכלו לברר עלינו עוד בפנקס החברות הממלכתי, כמו גם לקרוא ביקורות ודעות עלינו ברשתות החברתיות:{socialLinks}. </p><p>👮 כל הוויזות שהונפקו באתר שלנו הן רשמיות ומתקבלות ישירות מרשויות הממשלה. תוכל למצוא מידע נוסף עלינו בדף אודות <a href=\"/about\"> Visanet. </a> </p>",
      q: "מי אתה, {domain} אתר אינטרנט? האם האתר שלך רשמי?"
    }
  ],
  global_field: "חל על כל המועמדים",
  google_apple_pay: "אפל/גוגל פיי",
  guardian_passport: "מספר דרכון מבוגר מלווה",
  hero_cta_bahrain: "הגש בקשה לוויזה אלקטרונית בחריין",
  hero_cta_cambodia: "הגש בקשה לקבלת ויזה אלקטרונית בקמבודיה",
  hero_cta_canada: "הגש בקשה ל- eTA של קנדה",
  hero_cta_home: "הוויזות שאנחנו מוציאים",
  hero_cta_india: "הגש בקשה לוויזה אלקטרונית בהודו",
  hero_cta_indonesia: "הגש בקשה לוויזה אלקטרונית באינדונזיה",
  hero_cta_israel: "הגש בקשה ל- ETA-IL",
  hero_cta_korea: "הגש בקשה לדרום קוריאה K-ETA",
  hero_cta_morocco: "הגש בקשה לקבלת ויזה אלקטרונית במרוקו",
  hero_cta_new_zealand: "הגש בקשה לניו זילנד NZeTA",
  hero_cta_saudi_arabia: "הגש בקשה לקבלת ויזה אלקטרונית בערב הסעודית",
  hero_cta_sri_lanka: "הגש בקשה לקבלת ויזה אלקטרונית בסרי לנקה",
  hero_cta_thailand: "הגש בקשה לוויזה אלקטרונית בתאילנד",
  hero_cta_togo: "הגש בקשה לוויזה אלקטרונית של טוגו",
  hero_cta_uk: "הגש בקשה ל- ETA בבריטניה",
  hero_cta_usa: "הגש בקשה ל- ESTA בארה\"ב",
  hero_cta_vietnam: "הגש בקשה לוויזה אלקטרונית בווייטנאם",
  hero_img: "כותרת ראשית",
  highschool: "בית ספר תיכון",
  hindu: "הינדואיזם",
  home_address: "כתובת בית",
  home_page: {
    meta_desc: "{domain}אתה יכול להגיש בקשה לויזה אלקטרונית למדינות שונות מבלי שתצטרך לעזוב את הבית או לבקר בשגרירות",
    overview_body1_bahrain: "הגש בקשה ל- eVisa שלך בבחריין באופן מקוון בקלות וקבל אישור תוך 3-5 ימים בלבד, שנמסר ישירות לתיבת הדואר הנכנס שלך.",
    overview_body1_cambodia: "הגש בקשה ל- eVisa שלך בקמבודיה במהירות ובבטחה. קבל את ה- eVisa שלך תוך 3-5 ימים וחקור את הארץ ההיסטורית הזו.",
    overview_body1_canada: "דלג על הטרחה של ניירת עם שירות ה- ETA שלנו בקנדה. ה- ETA שלך, בתוקף עד חמש שנים, יישלח ישירות לדוא\"ל שלך תוך 1-3 ימים בלבד.",
    overview_body1_india: "הגש בקשה ל- eVisa ההודית שלך באינטרנט בקלות. קבל את ה- eVisa המאושרת שלך ישירות לדוא\"ל שלך תוך 1-3 ימים והתכונן לטבול את עצמך בקסם של הודו.",
    overview_body1_indonesia: "הגשת בקשה לויזה אינדונזיה היא פשוטה אצלנו. קבל את הויזה המאושרת שלך באמצעות דוא\"ל תוך 3-5 ימים וצעד לגן עדן.",
    overview_body1_israel: "הגש בקשה ל-ETA שלך בישראל ללא מאמץ. אישור הנסיעה שלך יימסר לדוא\"ל שלך תוך 1-3 ימים, מוכן לנסיעה שלך.",
    overview_body1_korea: "הגשת בקשה ל- K-ETA שלך לדרום קוריאה היא פשוטה ומהירה. קבל את אישור הנסיעה שלך ישירות לתיבת הדואר הנכנס שלך תוך 1-3 ימים.",
    overview_body1_morocco: "הגש בקשה לוויזה האלקטרונית שלך במרוקו ללא מאמץ. ה-eVisa המאושרת שלך תימסר ישירות לדוא\"ל שלך תוך 1-3 ימים בלבד.",
    overview_body1_new_zealand: "אבטח את ה- NZeTA שלך בקלות באינטרנט. אישור הנסיעה שלך יישלח לדוא\"ל שלך תוך 1-3 ימים, מוכן לנסיעה שלך.",
    overview_body1_saudi_arabia: "הגש בקשה ל- eVisa שלך בערב הסעודית באינטרנט בקלות וקבל אישור תוך 1-3 ימים בלבד, מוכן למסע שלך לארץ שובה לב זו.",
    overview_body1_sri_lanka: "הגש בקשה ל- eVisa שלך בסרי לנקה באינטרנט בקלות וקבל אישור תוך 1-3 ימים בלבד, מוכן למסע שלך לארץ שובה לב זו.",
    overview_body1_thailand: "קבל את ויזת תאילנד שלך באינטרנט ללא טרחה. תיהנו מתהליך אישור מהיר וקבלו את הויזה שלכם בדוא\"ל תוך 3-21 ימים.",
    overview_body1_togo: "הגש בקשה ל- eVisa שלך בטוגו באופן מקוון בקלות וקבל אישור תוך 1-3 ימים בלבד, מוכן למסע שלך לארץ שובה לב זו.",
    overview_body1_uk: "האתר היעיל שלנו הופך את הגשת הבקשה עבור ETA שלך לבריטניה ללא מאמץ. תשכחו מעבודות הנייר המייגעות - ה- ETA המאושר בבריטניה, בתוקף לשנתיים, יגיע ישירות לתיבת הדואר הנכנס שלך תוך 1-3 ימים.",
    overview_body1_usa: "האתר היעיל שלנו הופך את הגשת בקשה ל- ESTA שלך לארה\"ב ללא מאמץ. תשכחו מעבודות הנייר המייגעות - ה- ESTA המאושר שלכם, בתוקף לשנתיים, יגיע ישירות לתיבת הדואר הנכנס שלכם תוך 1-3 ימים.",
    overview_body1_vietnam: "קבל את ויזת וייטנאם שלך באינטרנט ללא טרחה. תיהנו מתהליך אישור מהיר וקבלו את הויזה שלכם בדוא\"ל תוך 1-7 ימים.",
    overview_body2_bahrain: "חקור את המסגד הגדול אל-פתאח המהמם של בחריין.",
    overview_body2_cambodia: "התפעלו מהזריחה מעל אנגקור וואט.",
    overview_body2_canada: "התפעלו מהאורורה בוריאליס המדהימה ביוקון.",
    overview_body2_india: "רכבו על פיל בג'איפור ותרגישו כמו בני מלוכה.",
    overview_body2_indonesia: "תוכלו להירגע בחופים הבתוליים של באלי ולאמץ את אווירת האי.",
    overview_body2_israel: "לצוף במי הריפוי של ים המלח.",
    overview_body2_korea: "התמכרו לתרבות אוכל הרחוב התוססת של מיונגדונג.",
    overview_body2_morocco: "טיילו בשווקים התוססים של מרקש והתמקחו כמו מקצוען.",
    overview_body2_new_zealand: "טיילו בשבילים עוצרי הנשימה של מילפורד סאונד.",
    overview_body2_saudi_arabia: "חקור את הקברים המהממים המגולפים בסלע של אל-אולה.",
    overview_body2_sri_lanka: "חקור את הקברים המהממים המגולפים בסלע של אל-אולה.",
    overview_body2_thailand: "חקור את ההריסות העתיקות של Ayutthaya ולטבול בהיסטוריה התאילנדית.",
    overview_body2_togo: "חקור את השווקים התוססים והחופים המדהימים של לומה.",
    overview_body2_uk: "חקור את מגדל לונדון ההיסטורי וחשוף מאות שנים של סודות מלכותיים.",
    overview_body2_usa: "טיילו בגשר שער הזהב האייקוני וספגו את הנופים של מפרץ סן פרנסיסקו.",
    overview_body2_vietnam: "צאו לשייט בסירה חולמנית דרך מערות הגיר של מפרץ האלונג.",
    overview_lead_bahrain: "תכשיט של המפרץ הערבי, בחריין מציעה שילוב ייחודי של מודרניות ומסורת, מאדריכלות עתידנית ועד מבצרים עתיקים.",
    overview_lead_cambodia: "קמבודיה, שקועה בהיסטוריה, היא ביתם של אנגקור וואט המלכותי ופנום פן התוסס.",
    overview_lead_canada: "חוו את השממה העצומה, ההרים המתנשאים והערים התוססות של קנדה. מהרוקי ועד מפלי הניאגרה, כל פינה מספרת סיפור.",
    overview_lead_india: "קליידוסקופ של צבעים, רוחניות והיסטוריה. מהטאג' מאהל המלכותי לרחובות התוססים של ג'איפור, הודו היא ארץ של חוויות תרבותיות עמוקות.",
    overview_lead_indonesia: "ביתם של החופים השלווים והתרבות העשירה של באלי, אינדונזיה מציעה בריחה קסומה. גלה את שדות האורז של אובוד או צלול לתוך שוניות האלמוגים התוססות.",
    overview_lead_israel: "ארץ של היסטוריה נצחית וחדשנות מודרנית. גלו את האתרים הקדושים בירושלים ואת חיי הלילה התוססים של תל אביב.",
    overview_lead_korea: "ארץ שבה המסורת פוגשת טכנולוגיה. חקור את הרחובות ההומים של סיאול, מקדשים בודהיסטים שלווים והנופים עוצרי הנשימה של האי ג'ג'ו.",
    overview_lead_morocco: "שער לאפריקה, מרוקו היא עומס חושי של סוקים שוקקים, מסגדים מלכותיים ומדבר סהרה העצום.",
    overview_lead_new_zealand: "חלומו של הרפתקן, ניו זילנד מתגאה בפיורדים מדהימים, גבעות מתגלגלות ופעילויות חוצות מרגשות.",
    overview_lead_saudi_arabia: "חשפו את המסתורין של ערב הסעודית, ארץ של פלאים עתיקים ופלאים מודרניים. מהקברים הנבטים של אל-אולה לעיר העתידנית ריאד.",
    overview_lead_sri_lanka: "חשפו את המסתורין של ערב הסעודית, ארץ של פלאים עתיקים ופלאים מודרניים. מהקברים הנבטים של אל-אולה לעיר העתידנית ריאד.",
    overview_lead_thailand: "ארץ של מקדשים מוזהבים, שווקים תוססים וחופים מדהימים. מההריסות העתיקות של איוטטאיה לרחובות ההומים של בנגקוק, תאילנד מציעה שטיח של חוויות שמחכות לחקור.",
    overview_lead_togo: "פנינה נסתרת במערב אפריקה, טוגו מציעה שילוב ייחודי של שווקים תוססים, חופים מדהימים ומורשת תרבותית עשירה.",
    overview_lead_uk: "בריטניה היא מדינה בעלת היסטוריה עשירה, תרבות מגוונת ונופים מדהימים. מציוני הדרך האיקוניים של לונדון ועד היופי המחוספס של הרמות הסקוטיות, בריטניה מציעה שטיח של חוויות שמחכות לחקור.",
    overview_lead_usa: "בריטניה משלבת היסטוריה עשירה, תרבות מגוונת ונופים מדהימים. מציוני הדרך האיקוניים של לונדון ועד ליופי המחוספס של ההיילנדס הסקוטי, הוא מציע חוויות אינסופיות לחקור.",
    overview_lead_vietnam: "שילוב הרמוני של יופי טבעי ומורשת תרבותית. גלו את טרסות האורז השופעות, רחובות האנוי ההומים ומפרץ האלונג השליו.",
    overview_menu_label_desktop: "בחר את היעד שלך",
    overview_menu_label_mobile: "בחר יעד",
    title: "ויזות Visanet הופכות {'|'} לקלות, נסיעות ללא גבולות",
    travel_map: "מפת נסיעות"
  },
  homepage: "בית",
  hotel_name: "שם המלון",
  hotel_name_address: "כתובת או שם המלון",
  hourglass: "איור שעון חול",
  icons: {
    bell: "סמל פעמון",
    building: "אייקון בניין גבוה מודרני",
    clam: "פתח צדפה עם סמל פנינה",
    coffee: "סמל כוס קפה",
    elephant: "סמל פיל",
    honey: "בקבוק דבש עם סמל קנדה",
    lawn_mower: "סמל מכסחת דשא",
    meat: "סמל חתיכות בשר",
    raccoon: "אייקון דביבון",
    spider: "סמל עכביש",
    trees: "סמל עצים טרופיים",
    volcano: "סמל הר געש"
  },
  illustation: "איור",
  image_upload: "העלאת תמונות",
  image_upload_instructions: "הוראות העלאת תמונות",
  image_upload_prefer: "איך תרצה לשלוח לנו את התמונות?",
  images: {
    al_fateh_grand_mosque_hero: "מסגד הגדול אל-פתח דגם תלת מימד, eVisa בחריין",
    aling_aling: "מפל אלינג-אלינג, באלי, אינדונזיה",
    angkor: "אנגקור וואט, סיאם ריפ, קמבודיה eVisa",
    angkor_desc: "אנגקור וואט, סיאם ריפ, קמבודיה",
    angkor_hero: "אנגקור וואט דגם תלת מימד, קמבודיה eVisa",
    arugam: "מפרץ ארוגאם, ויזה סרי לנקה",
    arugam_desc: "מפרץ ארוגאם, סרי לנקה",
    bahrain_beach_cta: "דגם תלת מימד של חוף בחריין, eVisa בחריין",
    bahrain_fort: "מבצר בחריין, ויזה אלקטרונית בחריין",
    bahrain_fort_desc: "מבצר בחריין, בחריין",
    bahrain_trade_center: "מרכז הסחר בחריין, מנאמה",
    bahrain_world_trade_center_cta: "מודל תלת מימד של מרכז הסחר העולמי בחריין, eVisa בחריין",
    bali_temple: "מקדש באלי, אינדונזיה",
    balinese_dancer_cta: "דגם תלת מימד של רקדן באלינזי, ויזה אינדונזיה",
    banff: "הפארק הלאומי באנף, קנדה",
    big_ben: "ביג בן, לונדון",
    borobudur: "מקדש בורובודור, ויזה אינדונזיה",
    borobudur_desc: "מקדש בורובודור, אינדונזיה",
    borobudur_hero: "דגם תלת מימד של מקדש בורובודור, ויזה אינדונזיה",
    british_guard_cta: "דגם תלת מימד בריטי גאורד, ETA בבריטניה",
    buddha_statue_cta: "דגם תלת מימד של פסל בודהה, הודו eVisa",
    cambodia_beach_cta: "דגם תלת מימד חוף קמבודיה, קמבודיה eVisa",
    camel_saudi_arabia_cta: "דגם תלת מימד של גמל, ערב הסעודית eVisa",
    casablanca: "קזבלנקה, מרוקו",
    cathedral: "קתדרלה, ירושלים",
    central_park: "סנטרל פארק, ניו יורק",
    chefchaouen: "שפצ'ואן, מרוקו eVisa",
    chefchaouen_cta: "דגם תלת מימד של שפצ'ואן, מרוקו eVisa",
    chefchaouen_desc: "שפצ'ואן, מרוקו",
    clipboard_checkmark: "לוח עם סימן ביקורת",
    clipboard_with_checkmark: "לוח עם סמל תלת מימד של סימן ביקורת",
    "da-nang-bridge": "גשר דה נאנג, וייטנאם",
    dead_sea: "ים המלח, ישראל ETA-IL",
    dead_sea_desc: "ים המלח, ישראל",
    dome_of_the_rock_hero: "כיפת הסלע דגם תלת מימד, ישראל ETA-IL",
    edinburgh_castle: "טירת אדינבורו, בריטניה ETA",
    edinburgh_castle_desc: "טירת אדינבורו, בריטניה",
    elephant_sri_lanka_cta: "דגם תלת מימד של פיל, ויזה סרי לנקה",
    goa: "גואה, הודו",
    golden_bridge: "גשר הזהב, ויזת וייטנאם",
    golden_bridge_desc: "גשר הזהב, וייטנאם",
    grand_canyon: "גרנד קניון, ESTA ארה\"ב",
    grand_canyon_desc: "גרנד קניון, ארה\"ב",
    gwanghwamun: "שער גוואנגוואמון, דרום קוריאה",
    gyeongbokgung_hero: "ארמון גיונגבוקגונג, דרום קוריאה KETA",
    ha_long_bay_cta: "דגם תלת מימד של מפרץ הלונג, ויזת וייטנאם",
    handara_gate: "שער הנדרה, באלי, אינדונזיה",
    hanok: "כפר בוקצ'ון האנוק, דרום קוריאה",
    hassan_ii_mosque_hero: "מסגד חסן השני דגם תלת מימד, מרוקו eVisa",
    hisma: "Hisma, ערב הסעודית",
    ho_chi_minh: "הו צ'י מין, וייטנאם",
    hollywood: "הוליווד, לוס אנג'לס",
    itmad: "קבר אטימאד-אוד-דולה, הודו",
    jeju_island: "האי ג'ג'ו, דרום קוריאה KETA",
    jeju_island_desc: "האי ג'ג'ו, דרום קוריאה",
    kokatahi: "קוקטאהי, ניו זילנד NZeTA",
    kokatahi_desc: "קוקטאהי, ניו זילנד",
    korean_warrior_cta: "לוחם קוריאני בלבוש מסורתי דגם תלת מימד, דרום קוריאה KETA",
    "lake-louise": "אגם לואיז, קנדה",
    madain_saleh: "מדין סאלח, ערב הסעודית eVisa",
    madain_saleh_desc: "מדיין סאלח, ערב הסעודית",
    manhattan_hero: "דגם תלת מימד של מנהטן, ESTA ארה\"ב",
    masjid_al_haram_hero: "מסג'יד אל חראם דגם תלת מימד, ערב הסעודית eVisa",
    masks: "טקס מסכה הינדי, צפון הודו",
    matamata: "מטמטה, ניו זילנד",
    monks: "נזירים קמבודיים, קמבודיה",
    moraine: "אגם מוריין, קנדה",
    new_zealand_landscape_hero: "מודל תלת מימד של נוף ניו זילנד, ניו זילנד NZeTA",
    niagara_falls: "מפלי הניאגרה, קנדה ETA",
    niagara_falls_cta: "דגם תלת מימד מפלי הניאגרה, קנדה ETA",
    niagara_falls_desc: "מפלי הניאגרה, קנדה",
    ninh_binh: "נין בין, וייטנאם",
    nuwara: "נוארה אלייה, סרי לנקה",
    passport_icon: "סמל דרכון",
    phi_phi_islands: "איי פי פי, תאילנד",
    phi_phi_islands_desc: "איי פי פי, תאילנד",
    qalat_al_bahrain: "קלאת אל-בחריין, בחריין",
    red_bus_palace_westminster: "אוטובוס אדום, ארמון ווסטמינסטר, לונדון",
    rocking_chair_with_cat_and_laptop: "כסא נדנדה עם חתול ומחשב נייד",
    royal_guard_horse: "המשמר המלכותי, לונדון",
    sigiriya: "סיגיריה, סרי לנקה",
    statue_of_liberty_cta: "פסל החירות דגם תלת מימד, ESTA ארה\"ב",
    taghazout: "טאגאזוט, מרוקו",
    taj_mahal: "טאג' מהאל, הודו eVisa",
    taj_mahal_desc: "טאג' מהאל, הודו",
    taj_mahal_hero: "דגם תלת מימד של טאג' מאהל, הודו eVisa",
    tel_aviv_beach_cta: "חוף תל אביב דגם תלת מימד, ישראל ETA-IL",
    togo_village: "כפר טוגו, טוגו eVisa",
    togo_waterfall: "מפל טוגו, טוגו eVisa",
    togo_waterfall_desc: "מפל מים, טוגו",
    toronto_hero: "טורונטו מודל תלת מימד, קנדה ETA",
    uluwatu_temple: "מקדש אולוואטו דגם תלת מימד, אינדונזיה eVisa",
    unawatuna_beach_hero: "דגם תלת מימד חוף אונוואטונה, ויזה סרי לנקה",
    ushaiqer: "אושייקר, ערב הסעודית",
    vietnam_house_on_beach_hero: "בית וייטנאם על החוף דגם תלת מימד, ויזת וייטנאם",
    wat_chalong: "וואט צ'אלונג, תאילנד"
  },
  images_required_note_face: "תמונת פנים אחרונה.",
  images_required_note_face_pass: "תמונת פנים אחרונה וצילום דרכון.",
  images_required_note_pass: "צילום דרכון.",
  images_required_note_start_bahrain: "מחלקת ההגירה של בחריין דורשת מכל מי שמבקש ויזה אלקטרונית לספק",
  images_required_note_start_cambodia: "מחלקת ההגירה של קמבודיה דורשת מכל מי שמבקש ויזה אלקטרונית לספק",
  images_required_note_start_india: "מחלקת ההגירה של הודו דורשת מכל מי שמבקש ויזה אלקטרונית לספק",
  images_required_note_start_indonesia: "מחלקת ההגירה של אינדונזיה מחייבת כל מי שמבקש ויזה אלקטרונית לספק",
  images_required_note_start_israel: "מחלקת ההגירה בישראל דורשת מכל מי שמגיש בקשה ל-ETA-IL לספק",
  images_required_note_start_korea: "מחלקת ההגירה של דרום קוריאה מחייבת כל מי שמבקש K-ETA לספק",
  images_required_note_start_morocco: "מחלקת ההגירה של מרוקו דורשת מכל מי שמבקש ויזה אלקטרונית לספק",
  images_required_note_start_saudi_arabia: "מחלקת ההגירה של ערב הסעודית דורשת מכל מי שמבקש ויזה אלקטרונית לספק",
  images_required_note_start_sri_lanka: "מחלקת ההגירה של סרי לנקה דורשת מכל מי שמבקש ויזה אלקטרונית לספק",
  images_required_note_start_thailand: "מחלקת ההגירה של תאילנד דורשת מכל מי שמבקש ויזה אלקטרונית לספק",
  images_required_note_start_togo: "מחלקת ההגירה של טוגו דורשת מכל מי שמבקש ויזה אלקטרונית לספק",
  images_required_note_start_uk: "מחלקת ההגירה של בריטניה דורשת מכל מי שמבקש ETA בבריטניה לספק",
  images_required_note_start_usa: "מחלקת ההגירה של ארה\"ב דורשת מכל מי שמגיש בקשה ל- ESTA לספק",
  images_required_note_start_vietnam: "מחלקת ההגירה של וייטנאם מחייבת כל מי שמבקש ויזה אלקטרונית לספק",
  india: "הודו",
  india_evisa: "ויזה אלקטרונית בהודו",
  india_page: {
    faq: [
      {
        a: "<p>לאחר מילוי והגשת טופס <a href=\"#form\"> הוויזה המקו </a> ון באתר האינטרנט שלנו, אנו נעבד את בקשתך ונשלח אותה למשרד ההגירה הראשי של הודו, המטפל בויזות אלקטרוניות מכל רחבי העולם. </p><p>לאחר 2-3 ימים הויזה האלקטרונית מאושרת ונשלחת אליך ישירות בדוא\"ל - מסמך זה מהווה אישור רשמי לבקר בהודו. </p><p>כל שעליכם לעשות בהמשך הוא להדפיס את הוויזה שלכם, לשמור אותה בהישג יד ולהציג אותה על פי בקשה ברגע שתגיעו להודו - בתמורה תקבלו (ללא עלות נוספת) חותמת רשמית בדרכון המאפשרת לכם להיכנס ולצאת מהודו למשך חודש, שנה או 5 שנים (תלוי בסוג הויזה שתבחרו), עם שהייה מקסימלית של 30/90 יום לכניסה (או 180 יום אם תבחרו אשרת עסקים). </p>",
        q: "כיצד פועל תהליך הנפקת הוויזה להודו באתר?"
      },
      {
        a: "<p>לאחר הנפקת הוויזה האלקטרונית שלך, אתה זכאי להיכנס להודו בתוך החודש, השנה או חמש השנים הבאות, תלוי בסוג הוויזה שתבחר: </p> <ul> <li> <strong> ויזה למשך 30 יום (תיירות) </strong> - מרגע כניסתך לגבולות המדינה, תוכל להישאר שם עד 30 ימים רצופים. אתה יכול להשתמש בויזה עבור 2 כניסות במהלך תוקפו. </li><li><strong>ויזה לשנה אחת/5 שנים (תיירות) </strong> - מרגע כניסתך לגבולות המדינה, תוכל להישאר שם עד 90 ימים רצופים. <br>אם עזבת את גבולות המדינה ונכנסת מחדש, תוכל להישאר למשך 90 יום נוספים וכן הלאה עד סוף שנה/5 שנים ממועד הנפקת הויזה. </li><li><strong>ויזה לשנה אחת (עסקים) </strong> - מרגע כניסתך למדינה, יש לך את הזכות להישאר בה עד 180 יום ברציפות. </li></ul><p>⚠️ שימו לב: משך הזמן הכולל בהודו מוגבל ל -180 יום בכל שנה קלנדרית (למשל 2024). </p>",
        q: "לכמה זמן תקפה ויזה אלקטרונית הודית?"
      },
      {
        a: "<p>אם רכשת ויזה אלקטרונית לשנה או יותר, אין הגבלה למספר הפעמים שתרשו להיכנס לגבולות הודו. <br>כל עוד הויזה לא פגה - הכניסה חופשית. <br>במקרה של ויזה אלקטרונית לחודש אחד, אתה רשאי להיכנס להודו פעמיים לכל היותר. </p>",
        q: "כמה פעמים מותר לך להיכנס להודו עם אותה ויזה?"
      },
      {
        a: "<p>הכניסה הראשונה שלך להודו עם הויזה שהונפקה לך חייבת להיות כניסה אווירית (במטוס) או בים (בספינה). <br>כניסה קרקעית בהחלט אפשרית, אך רק אם זו הפעם השנייה (או יותר) שאתה נכנס להודו לאחר השימוש בויזה האלקטרונית. </p>",
        q: "האם ניתן להיכנס להודו ביבשה עם הוויזה?"
      },
      {
        a: "<p>לא, ממשלת הודו מגבילה </strong> כניסה <strong> ראשונה עם ויזה אלקטרונית לנמלים מסוימים. להלן רשימת שדות התעופה שמהם מותר להיכנס להודו: </p> <ul> <li> דלהי מומ </li> <li> באי </li> <li> גואה צ' </li> <li> נאי </li> <li> קולקטה </li> <li> בנגלורו היידראבאד גאיה </li> <li> קוצ'ין אחמדאבאד אמריצר תירוואנאנ </li> <li> תאפ </li> <li> וראם ג'איפור לו </li> <li> קנאו </li> <li> </li> <li> </li> <li> </li> <li> </li><li>טרישי ור </li> <li> נאסי </li> <li> קליקוט </li> <li> מנגלור פונה נג </li> <li> פור </li> <li> קוימבטור בג </li> <li> דוגרה </li> <li> גוואהאטי </li> <li> צ'אנדיגאר מדוראי ויסאקהפטנאם בהובנשוואר פורט בלייר והנה הנמלים שדרכם אתם </li> <li> </li> <li> </li> <li> </li> <li> </li> <li> </li> </ul> <p> יכול להגיע דרך הים: </p> <ul> <li> מומבאי </li> <li> קוצ'ין </li> <li> מורמוגאו צ'נאי ניו מנגלור </li> <li> </li> <li> </li> </ul>",
        q: "האם ניתן להיכנס להודו משדה תעופה או גבול כלשהו?"
      },
      {
        a: "<p>-לא. התשלום באתרים שלנו הושלם, סופי וכולל את כל העמלות, המסים והעמלות לממשלת הודו. <br>לתשלום באתרים שלנו תקבל חותמת רשמית בדרכון שלך עם הנחיתה, ללא צורך בתשלום נוסף. </p>",
        q: "האם יש תשלום נוסף עבור הויזה בהודו?"
      },
      {
        a: "<p>כל אדם שאינו אזרח הודו, ורוצה להיכנס לגבולות המדינה. אף מדינה/לאום אינו יוצא מן הכלל. </p>",
        q: "מי צריך להגיש בקשה לויזה להודו?"
      },
      {
        a: "<p>ממשלת הודו מחייבת אותך להגיש בקשה לפחות 4 ימים לפני הטיסה המתוכננת שלך. לקבלת ביטחון רב יותר, אנו ממליצים להגיש את הבקשה לפחות שבוע לפני עזיבתך. עם זאת, ניתן להגיש בקשות 1-3 ימים לפני הטיסה שלך, כאשר 99% מהויזות מטופלות דרך האתר שלנו ויזנט, וקיבלו אישור תוך 1-3 ימים. </p><p>⚡ בנוסף, האתר שלנו מציע שירות מזורז לוויזה הודית דחופה, אשר מאושרת בדרך כלל תוך כ -24 שעות ומוכנה עד למחרת. </p>",
        q: "כמה זמן לפני הנסיעה שלי עלי להגיש בקשה לויזה הודית?"
      },
      {
        a: "<p>-לא. משרד החוץ של הודו אינו מתיר הארכה. עם זאת, בהחלט ניתן להנפיק ויזה אלקטרונית נוספת מיד לאחר תום הויזה הקודמת. </p>",
        q: "האם ניתן להאריך את תוקפו של ויזה אלקטרונית להודו?"
      },
      {
        a: "<p>-לא. עליך לעזוב את גבולות המדינה ולהיכנס רק לאחר שהנפקת ויזה אלקטרונית חדשה. </p>",
        q: "האם ניתן לקבל ויזה חדשה בהודו?"
      },
      {
        a: "<p>-כן. כל אדם שאינו אזרח הודו חייב להיות בעל אשרת כניסה כדי להיכנס לגבולות המדינה, כולל ילדים בגילאי 0-18. <br>בעזרתנו תוכלו להנפיק ויזה אלקטרונית לילדכם בשילוב עם הזמנת הויזה שלכם, והכל בטופס מקוון נוח אחד. </p>",
        q: "האם ילדים זקוקים לויזה אלקטרונית כדי להיכנס להודו?"
      },
      {
        a: "<p>גם הוויזה המסורתית וגם הוויזה האלקטרונית הם מסמכים שמטרתם לאשר את כניסתך והשהייה בהודו. <br>הוויזה האלקטרונית הומצאה על מנת להקל על חייך - אין צורך לשלוח מסמכים פיזית, להגיע לשגרירות ולחכות שבועות לתשובה ולקבל את הדרכון בחזרה. באתר שלנו התהליך כולו מתבצע באופן מקוון, באנגלית פשוטה וללא צורך לצאת מהבית. תוך 1-3 ימים בלבד. </p>",
        q: "מה ההבדל בין ויזה אלקטרונית לויזה רגילה?"
      },
      {
        a: "<p>כן, באתר Visanet תוכלו להשיג ויזות אלקטרוניות ו- ETA למדינות רבות, כולל <a href=\"/usa\"> ארצות הברית, <a href=\"/israel\"> ישראל</a>, <a href=\"/korea\"> דרום קוריאה </a> </a></a>, <a href=\"/vietnam\"> וייטנאם ועוד רבות אחרות. נשמח לסייע לכם בכל צרכי אשרת הנסיעה שלכם. </p><p>בנוסף, אתר האינטרנט הבינלאומי Visanet זמין במספר שפות לנוחיותכם: <a href=\"https://visanet.co.il/india\"> עברית</a>, Ру <a href=\"https://visanet.ru/india\"> сский, וסוודית</a>. <a href=\"https://visanet.se/india\"> </a> </p>",
        q: "האם אתה מסייע בקבלת אשרות למדינות אחרות?"
      },
      {
        a: "<p>אל תהסס לחקור את הב </a> לוג <a href=\"/blog\"> שלנו לקבלת החדשות האחרונות, העדכונים והמדריכים המקיפים לקבלת אשרות להודו. </p><p>בנוסף, הצוות שלנו מוכן להציע לך <a href=\"/contact\"> סיוע אנושי חי 24/7</a>. </p><p>תודה לך, צוות ויזנט. </p>",
        q: "יש לי שאלות נוספות"
      }
    ],
    meta_desc: "קבל את eVisa שלך בהודו תוך 3-5 ימים על ידי מילוי טופס מקוון קצר באנגלית. ויזה הודית רשמית {currentYear} ללא ביקור בשגרירות",
    title: "ויזנט יישום מקוון eVisa להודו {currentYear} {'|'}"
  },
  india_stay_limit_note: "עבור לאומים שאינם ארה\"ב, בריטניה, קנדה ויפן, מגבלת השהייה היא 90 יום.",
  indonesia: "אינדונזיה",
  indonesia_evisa: "ויזה אלקטרונית של אינדונזיה",
  indonesia_page: {
    faq: [
      {
        a: "הוויזה האלקטרונית לאינדונזיה היא מסמך רשמי המאפשר כניסה לאינדונזיה למטרות שונות, כגון תיירות, עסקים וביקורים חברתיים, ללא צורך לבקר בשגרירות לקבלת חותמת ויזה פיזית בדרכון שלך.",
        q: "מהי ויזה אלקטרונית לאינדונזיה?"
      },
      {
        a: "אזרחי רוב המדינות יכולים להגיש בקשה לויזה אלקטרונית לאינדונזיה באופן מקוון. בדוק את רשימת הז <a data-eligibility-list-opener> כאות המלאה כאן </a> כדי לאשר אם הלאום שלך מתאים.",
        q: "מי זכאי לוויזה אלקטרונית של אינדונזיה?"
      },
      {
        a: "אינדונזיה מציעה מספר סוגים של ויזות אלקטרוניות, כולל: ויזה אלקטרונית ל <ul> <li> תיירים ויזה עסקית </li> <li> </li> </ul>",
        q: "אילו סוגים של ויזות אלקטרוניות זמינות לאינדונזיה?"
      },
      {
        a: "העיבוד אורך בדרך כלל 3-5 ימי עסקים, אם כי זה יכול להשתנות בהתאם לנפח היישומים או לכל בעיה ספציפית ביישומים בודדים.",
        q: "כמה זמן לוקח לעיבוד הוויזה האלקטרונית של אינדונזיה?"
      },
      {
        a: "תוקפו של הויזה האלקטרונית תלוי בסוג הויזה ונע בין 60 יום עד 5 שנים.",
        q: "מהו תוקפו של ויזה אלקטרונית לאינדונזיה?"
      },
      {
        a: "<ul><li>ויזה 60 יום: שהייה עד 60 יום (ניתנת להרחבה) (כניסה יחידה) </li> <li> ויזה לשנה: שהייה עד 60 יום לכניסה (כניסות מרובות) אשרה לשנ </li> <li> תיים: שהייה עד 60 יום בכניסה (כניסות מרובות) ויזה </li> <li> 5 שנים: שהייה עד 60 יום לכל כניסה (כניסות מרובות) </li> </ul> כל סוגי הוויזה מאפשרים פעילויות כגון תיירות, ביקור במשפחה או חברים והשתתפות בפגישות או בתערוכות כמשתתף. עם זאת, הם אוסרים בהחלט לעבוד או לעסוק בפעילויות הרווחיות.",
        q: "מהם משך הוויזה ותקופות השהייה השונות?"
      },
      {
        a: "<ul><li>דרכון תקף עם תוקף של לפחות 6 חודשים מיום הכניסה. </li><li>תמונה עדכנית בגודל דרכון - אתה יכול לשלוח לנו את התמונה בכל פורמט שתרצה (למשל, מהטלפון שלך), ואנו נערוך אותה בהתאם לדרישות הספציפיות. </li><li>כרטיס חזרה או הלאה. </li><li>הצהרת בנק אישית המציגה יתרה מינימלית של 2000 דולר ארה\"ב או שווה ערך לשלושת החודשים האחרונים (חייב לכלול את שמך, תאריך התקופה ויתרת החשבון שלך). </li></ul>",
        q: "אילו מסמכים נדרשים לבקשת הוויזה האלקטרונית לאינדונזיה?"
      },
      {
        a: "הויזה האלקטרונית הסטנדרטית לתיירים למשך 60 יום מיועדת לכניסה יחידה. עם זאת, אשרות שנה, שנתיים וחמש שנים הן כניסה מרובות, ומאפשרות לך להיכנס לאינדונזיה מספר פעמים במהלך תקופת תוקפו של הויזה, כאשר כל שהייה מוגבלת עד 60 יום.",
        q: "האם אוכל להיכנס לאינדונזיה מספר פעמים עם ויזה אלקטרונית?"
      },
      {
        a: "ניתן להגיש בקשה לויזה אלקטרונית דרך אתר <a href=\"#form\"> </a> האינטרנט שלנו. מלא את הטופס עם הפרטים שלך, העלה את המסמכים הדרושים ושלם את האגרה באופן מקוון.",
        q: "כיצד אוכל להגיש בקשה לויזה אלקטרונית לאינדונזיה?"
      },
      {
        a: "כן, באלי היא חלק מאינדונזיה, ואותן דרישות אשרה חלות.",
        q: "אני טס לבאלי, האם אני צריך גם ויזה?"
      },
      {
        a: "לא, יש להגיש בקשה לויזה אלקטרונית ולאשר אותה לפני הכניסה לאינדונזיה. אם אתה כבר באינדונזיה וצריך להאריך את שהותך, בקר במשרד הגירה.",
        q: "האם אוכל להגיש בקשה לויזה אלקטרונית כשאני כבר באינדונזיה?"
      },
      {
        a: "כן, מומלץ להדפיס את הוויזה האלקטרונית שלך ולשאת אותה איתך בעת נסיעה לאינדונזיה, מכיוון שתצטרך להציג אותה לרשויות ההגירה עם ההגעה.",
        q: "האם אני צריך להדפיס את הויזה האלקטרונית שלי?"
      },
      {
        a: "אם תאריכי הנסיעה שלך משתנים, ייתכן שתצטרך להגיש בקשה לוויזה אלקטרונית חדשה, מכיוון שכל ויזה קשורה לתאריכי כניסה ויציאה ספציפיים. <a href=\"/contact\">צור איתנו קשר </a> כדי לברר לגבי הנפקה מחדש או שינוי הויזה שלך.",
        q: "מה אם תוכניות הנסיעה שלי ישתנו?"
      }
    ],
    meta_desc: "הגש בקשה לויזה אלקטרונית לאינדונזיה באנגלית. קבל ויזה מבלי לבקר בשגרירות, תהליך מהיר ונוח",
    title: "ויזה אלקטרונית לאינדונזיה ובאלי ויזנט מקוון {currentYear} {'|'}"
  },
  inside_country: "בפנים {country}",
  islam: "האיסלאם",
  israel: "ישראל",
  israel_evisa: "ישראל ETA-IL",
  israel_page: {
    faq: [
      {
        a: "בדרך כלל תקבל תשובה תוך יום עד שלושה ימים.",
        q: "כמה זמן ייקח לקבל תשובה לאחר שליחת טופס IL-ETA?"
      },
      {
        a: "ה- ETA-IL שלך תקף בדרך כלל לנסיעות מרובות עד שנתיים או עד שתוקף הדרכון שלך יפוג. אין צורך להגיש בקשה חוזרת בתקופה זו. תפוגה בישראל לא תשפיע על עזיבתך.",
        q: "כמה זמן תקף ה- ETA-IL שלי?"
      },
      {
        a: "אזרחים ממדינות זכאות יכולים להגיש בקשה ל-ETA-IL בישראל באופן מקוון. תוכל לצפות ברשימת המדינות הזכאות <a data-eligibility-list-opener> כאן</a>.",
        q: "מי זכאי להגיש בקשה ל-ETA-IL בישראל?"
      },
      {
        a: "כן, כולם, ללא קשר לגיל, זקוקים ל- ETA-IL אם מגיעים ממדינה פטורה לוויזה. מבוגר חייב להגיש בקשה בשם קטין.",
        q: "האם קטינים זקוקים ל- ETA-IL?"
      },
      {
        a: "ETA-IL מאפשר שהייה עד 90 יום. עבור שהיות ארוכות יותר, בקש הארכה במשרד ההגירה הישראלי המקומי.",
        q: "מה אם אני רוצה לבקר בישראל יותר משלושה חודשים?"
      },
      {
        a: "הגש בקשה בכל עת לפני הנסיעה שלך. מומלץ להגיש את בקשתך לפחות 72 שעות לפני הזמנת טיסות או לינה.",
        q: "מתי עלי להגיש בקשה ל- ETA-IL?"
      },
      {
        a: "הגש בקשה מחדש אם אתה מקבל דרכון חדש, שנה את שמך או שנה את האזרחות שלך. כל יישום חדש עולה{price}.",
        q: "מתי עלי להגיש בקשה מחדש עבור ETA-IL חדש?"
      },
      {
        a: "כן, קיום ETA-IL תקף אינו מבטיח כניסה. קציני בקרת גבולות יכולים לדחות כניסה אם אינך עומד בדרישות החוקיות והפרוצדורליות.",
        q: "האם ניתן לסרב לי כניסה עם ETA-IL תקף?"
      },
      {
        a: "הדפסת ה- ETA-IL אינה נדרשת, אך רצוי שיהיה איתך את מספר האישור או עותק מודפס.",
        q: "האם עלי להדפיס את האישור?"
      },
      {
        a: "<p>כן, באתר Visanet תוכלו להשיג ויזות אלקטרוניות ו- ETA למדינות רבות, כולל <a href=\"/usa\"> ארצות הברית, <a href=\"/canada\"> קנדה</a>, <a href=\"/india\"> הודו </a></a>, <a href=\"/korea\"> דרום קוריאה ורבות </a> אחרות. נשמח לסייע לכם בכל צרכי אשרת הנסיעה שלכם. </p><p>בנוסף, אתר האינטרנט הבינלאומי של Visanet זמין במספר שפות לנוחיותך: Ру <a href=\"https://visanet.ru/israel\"> сский, וסוונדאית</a>. <a href=\"https://visanet.se/israel\"> </a> </p>",
        q: "האם אתה מסייע בקבלת אשרות למדינות אחרות?"
      }
    ],
    meta_desc: "קבל את אשרת ה- ETA-IL לישראל עכשיו, זמינה החל מיולי 2024. הגש טופס בקשה קצר וקבל את אישור הויזה האלקטרונית לישראל תוך 1-2 ימים",
    title: "ויזה לישראל ETA-IL זמינה באינטרנט עכשיו Visanet {currentYear} {'|'}"
  },
  job_seniority: "שנים של ותק",
  judaism: "יהדות",
  kid: "(ילד)",
  kid_visa_price: "מחיר ויזה לילדים:",
  korea: "דרום קוריאה",
  korea_accompanying_children_info: "ילדים בגילאי 0-17 אינם זקוקים ל- K-ETA כדי להיכנס לדרום קוריאה אם הם מלווים בהורה. אם ילדיכם מצטרפים לטיול שלכם, אנא הוסיפו אותם למטה.",
  korea_evisa: "דרום קוריאה K-ETA",
  korea_page: {
    faq: [
      {
        a: "<p>ה- <strong> K- </strong> Electronic <strong> T </strong> ravel <strong> A </strong> uthorization או בקי <strong> צור K-ETA</strong>, הוא מסמך אישור נסיעה אלקטרוני המספק אישור כניסה לגבולות דרום קוריאה. זה עובד בדומה לויזה אך מתקבל באופן מקוון. </p>",
        q: "מהי אשרת כניסה K-ETA לדרום קוריאה?"
      },
      {
        a: "<p>כן, מטיילים מכמעט 112 מדינות המתכננים לבקר בקוריאה לביקור לטווח קצר זקוקים ל- K-ETA. </p>",
        q: "האם אני צריך K-ETA כדי להיכנס לדרום קוריאה?"
      },
      {
        a: "לאחר שתשלח את הטופס המקוון באתר שלנו, תקבל אישור K-ETA באמצעות דוא\"ל. הביאו עותק מודפס או דיגיטלי של מסמך זה בעת הכניסה לדרום קוריאה.",
        q: "כיצד פועל תהליך K-ETA?"
      },
      {
        a: "כל אישור K-ETA תקף לשלוש שנים או עד שתוקף הדרכון שלך יפוג.",
        q: "לכמה זמן תקף ה- K-ETA?"
      },
      {
        a: "עבור רוב הלאומים, לאחר שנכנסת לדרום קוריאה באמצעות K-ETA, אתה רשאי להישאר עד 90 יום לכל היותר. עם זאת, אם השתמשת בדרכון הרוסי שלך עבור ה- K-ETA שלך, השהייה שלך לא תעלה על 60 יום ברציפות, ולא תעלה על 90 ימי שהייה בתוך 180 יום.",
        q: "מהי מגבלת השהייה המקסימלית בדרום קוריאה עם K-ETA?"
      },
      {
        a: "העלות עבור K-ETA של דרום קוריאה באתר שלנו היא{price}.",
        q: "כמה עולה K-ETA?"
      },
      {
        a: "התהליך אורך בדרך כלל עד שלושה ימי עבודה.",
        q: "כמה זמן לוקח להנפיק K-ETA?"
      },
      {
        a: "לא, אין צורך כזה בדרכון ביומטרי כדי להגיש בקשה ל-K-ETA.",
        q: "האם אני צריך דרכון ביומטרי כדי לקבל ויזה באמצעות K-ETA?"
      },
      {
        a: "לא. אתה יכול להגיש בקשה ל- ETA קוריאני גם אם טרם רכשת כרטיס טיסה.",
        q: "האם עלי לרכוש כרטיסי טיסה לפני הגשת בקשה ל- ETA קוריאנית?"
      },
      {
        a: "כן. אם כבר יש לך ויזה תקפה, אתה יכול להשתמש בה כדי להיכנס לדרום קוריאה. K-ETA אינו מבטל אשרות קיימות.",
        q: "יש לי כבר ויזה תקפה. האם אוכל להשתמש בו במקום לקבל K-ETA?"
      },
      {
        a: "הויזה המסורתית דורשת תיעוד פיזי, ביקורי שגרירות ותקופת המתנה ארוכה יותר. מצד שני, K-ETA היא מערכת מקוונת פשוטה המאפשרת לקבל אישור להיכנס לדרום קוריאה תוך מספר ימים.",
        q: "מה ההבדל בין ויזה רגילה לבין K-ETA?"
      },
      {
        a: "<p>אל תהסס לחקור את הב </a> לוג <a href=\"/blog\"> שלנו לקבלת החדשות האחרונות, העדכונים והמדריכים המקיפים להשגת ETA לקוריאה. </p><p>בנוסף, הצוות שלנו מוכן להציע לך <a href=\"/contact\"> סיוע אנושי חי 24/7</a>. </p><p>תודה לך, צוות ויזנט. </p>",
        q: "יש לי שאלות נוספות"
      }
    ],
    meta_desc: "הגש בקשה להיתר כניסה אלקטרוני לדרום קוריאה K-ETA באנגלית וקבל אותו תוך 1-3 ימים",
    title: "K-ETA לדרום קוריאה - ויזנט בקשה לויזה מקוונת {currentYear} {'|'}"
  },
  landport: "לנדפורט",
  languages: {
    en: "אנגלי",
    he: "עברית",
    ru: "רוסי",
    sv: "שוודית"
  },
  last_name: "שם משפחה",
  last_travel: {
    country: "לאן נסעת בפעם האחרונה?",
    from: "מ",
    traveled: "האם אי פעם נסעת לחו\"ל?",
    until: "עד"
  },
  last_visa_issue_date: "תאריך הנפקת אשרה קודמת",
  link_copied: "קישור הועתק",
  link_send: "שלח את הקישור",
  link_sent: "הקישור נשלח בהצלחה",
  link_validity_time: "הקישור תקף למשך 30 יום בלבד. אנא חזרו ומלאו את הטופס במסגרת הזמן.",
  list_price: "מחיר מחירון",
  male: "זכר",
  marital: {
    divorced: "גרושים",
    married: "נשוי",
    single: "יחיד",
    widowed: "אלמן"
  },
  marital_status: "מצב משפחתי",
  may_resume: "אתה יכול להמשיך את הטופס מהנקודה שבה הפסקת",
  may_use_phone_camera: "אתה יכול להשתמש במצלמה של הטלפון.",
  medical_insurance_included: "ביטוח רפואי נדרש כבר כלול במחיר הויזה שלנו.",
  military_rank: "דרגה",
  military_ranks: {
    corporal: "רב\"ט",
    nco: "NCO",
    officer: "קצין",
    "private": "פרטי",
    sergeant: "סרג'נט",
    staff_sergeant: "סמל ראשון"
  },
  military_roles: {
    fighter: "לוחם",
    office: "עבודה במשרד",
    support: "תמיכה"
  },
  military_service: "שירות צבאי",
  military_service_type: "סוג השירות",
  mobile_payment: {
    header: "הוראות תשלום נייד",
    instruction_1: "פתח את האפליקציה והעביר את הסכום של:",
    instruction_2: "שלח את ההעברה למספר {0}",
    phone_hint: "לאימות - מספר הטלפון המשמש להעברה",
    phone_label: "הטלפון של השולח",
    proceed: "אישור תשלום",
    transfer_id: "מספר אישור העברה",
    transfer_id_hint: "מספר האישור המוצג באפליקציה לאחר השלמת התשלום"
  },
  month: "חודש",
  morocco: "מרוקו",
  morocco_evisa: "מרוקו eVisa",
  morocco_page: {
    faq: [
      {
        a: "<p>לאחר מילוי והגשת טופס הוויזה המקוון באתר האינטרנט שלנו, אנו נעבד את בקשתך ונשלח אותה למשרד ההגירה הראשי של מרוקו, המטפל בויזות אלקטרוניות מכל רחבי העולם. <br><br>לאחר 2-3 ימים הויזה האלקטרונית מאושרת ונשלחת ישירות לדוא\"ל שלך. מסמך זה מהווה אישור רשמי להיכנס ולבקר במרוקו. <br><br>מכאן והלאה, כל שעליכם לעשות הוא להדפיס את הוויזה, לשמור אותה בהישג יד ולהציג אותה כשתתבקשו לעשות זאת בעת הצ'ק-אין לטיסה, ולאחר מכן עם הנחיתה במרוקו. <br>בתמורה תקבל (ללא תשלום נוסף) חותמת רשמית בדרכון שלך המאפשרת לך להיכנס ולהישאר במרוקו למשך חודש. </p>",
        q: "כיצד פועל תהליך הנפקת ויזה אלקטרונית למרוקו?"
      },
      {
        a: "<p>הויזה למרוקו מתקבלת תוך 2-3 ימי עסקים, תלוי בסוג הוויזה שרכשת: <br> • ויזה אלקטרונית רגילה למשך 180 יום מתקבלת תוך 2-3 ימים במרוקו. <br>• ויזה אלקטרונית דחופה מתקבלת בתוך יום עסקים אחד במרוקו. אתה יכול לקבל את הויזה האלקטרונית הדחופה באותו יום, אם אתה מזמין עד הצהריים (ביום עסקים). </p>",
        q: "כמה זמן לוקח לקבל ויזה אלקטרונית למרוקו?"
      },
      {
        a: "<p>-לא. התשלום באתר שלנו הוא שלם, סופי וכולל את כל העמלות, המסים והעמלות לממשלת מרוקו. </p>",
        q: "האם יש תשלום נוסף עבור הוויזה במרוקו?"
      },
      {
        a: "<p>אם אינך אזרח אירופה או ארה\"ב או מרוקו, אתה זקוק לויזה אלקטרונית כדי להיכנס למרוקו. </p>",
        q: "מי צריך ויזה למרוקו?"
      },
      {
        a: "לאחר שהונפקה לך ויזה אלקטרונית למרוקו והיא נשלחה לדוא\"ל שלך, תוכל להיכנס למרוקו במהלך 180 הימים הבאים.",
        q: "לכמה זמן תקפה הוויזה האלקטרונית למרוקו?"
      },
      {
        a: "ויזה אלקטרונית למשך 180 יום מאפשרת כניסה אחת בלבד למרוקו. מה שהופך אותה לויזה חד פעמית.",
        q: "כמה פעמים מותר לך להיכנס למרוקו עם אותה ויזה?"
      },
      {
        a: "כן. מיולי 2022 ניתן להנפיק ויזה אלקטרונית למרוקו למטרות תיירות ו/או עסקיות.",
        q: "האם ניתן להוציא ויזה למרוקו לאחר פרוץ מגיפת ה- COVID?"
      },
      {
        a: "כן. כל אדם שאינו אזרח מרוקו חייב להיות בעל ויזה אלקטרונית כדי להיכנס לגבולות המדינה, כולל ילדים בגילאי 0-18. בעזרתנו תוכלו להנפיק ויזה אלקטרונית לילדכם בשילוב עם הזמנת הויזה שלכם, והכל בטופס מקוון קצר ונוח.",
        q: "האם ילדים זקוקים לויזה כדי להיכנס למרוקו?"
      },
      {
        a: "<p>המינימום הנדרש על ידי ממשלת מרוקו הוא 3 ימים לפני תאריך הטיסה שלך. <br>כדי להיות בצד הבטוח, אנו ממליצים למלא את הטופס לפחות שבוע לפני הטיסה, אך מותר לעשות זאת עד 3 ימים לפני מועד הטיסה שלך. <br><strong>אם הטיסה שלך היא בעוד יומיים או פחות, אתה יכול להנפיק ויזה דחופה באתר שלנו, שתהיה מוכנה למחרת (או תוך מספר שעות, להזמנות מוקדמות במהלך ימי העבודה) </strong> </p>",
        q: "כמה זמן לפני הנסיעה עלי להנפיק ויזה למרוקו?"
      },
      {
        a: "לא. משרד החוץ של מרוקו אינו מאפשר הארכה. עם זאת, בהחלט ניתן להנפיק ויזה אלקטרונית נוספת מיד לאחר תום הויזה הקודמת.",
        q: "האם ניתן להאריך את תוקפו של ויזה אלקטרונית למרוקו?"
      },
      {
        a: "לא. עליך לעזוב את גבולות המדינה ולהיכנס רק לאחר שהנפקת ויזה אלקטרונית חדשה.",
        q: "האם ניתן להנפיק ויזה אלקטרונית חדשה בזמן שאני במרוקו?"
      },
      {
        a: "כניסתך למרוקו עם הויזה האלקטרונית שהונפקה לך חייבת להיות אווירית (במטוס) או בים (באונייה).",
        q: "האם אוכל להיכנס למרוקו בים/יבשה באמצעות הוויזה האלקטרונית?"
      },
      {
        a: "גם הוויזה המסורתית וגם הוויזה האלקטרונית הם מסמכים שמטרתם לאשר את כניסתך והשהייה במרוקו. הוויזה האלקטרונית הומצאה על מנת להקל על חייכם - אין צורך לשלוח מסמכים פיזית, להגיע לשגרירות ולחכות שבועות לתשובה ולקבל את הדרכון בחזרה - באתר שלנו התהליך כולו מתבצע באופן מקוון, באנגלית פשוטה וללא צורך לצאת מהבית, באמצעות טופס מקוון קצר. בדרך זו אתה יכול לקבל ויזה תוך 2-3 ימים בלבד.",
        q: "מה ההבדל בין ויזה אלקטרונית לויזה רגילה?"
      }
    ],
    meta_desc: "קבל את ה- eVisa שלך במרוקו תוך 2-3 ימים על ידי מילוי טופס מקוון קצר באנגלית. ויזה רשמית למרוקו {currentYear} ללא ביקור בשגרירות",
    title: "ויזה אלקטרונית למרוקו - בקשה מקוונת מהירה Visanet {currentYear} {'|'}"
  },
  mother_country: "ארץ הלידה של האם",
  mother_name: "שם אמא",
  msg_contact: "הודעה - צור קשר",
  nationality: "לאום",
  nav: {
    cta_bahrain: "קבל את הויזה האלקטרונית שלך בבחריין",
    cta_cambodia: "קבל את הוויזה האלקטרונית שלך בקמבודיה",
    cta_canada: "קבל את eTA שלך בקנדה",
    cta_home: "התחל את היישום שלך",
    cta_india: "קבל את הויזה האלקטרונית שלך בהודו",
    cta_indonesia: "קבל את האישור האלקטרוני שלך באינדונזיה",
    cta_israel: "קבל את ה- ETA-IL שלך",
    cta_korea: "קבל את ה- K-ETA שלך",
    cta_morocco: "קבל את האישור האלקטרוני שלך במרוקו",
    cta_new_zealand: "קבל את ה- NZeTA שלך",
    cta_saudi_arabia: "קבל את האישור האלקטרוני שלך בערב הסעודית",
    cta_sri_lanka: "קבל את הוויזה האלקטרונית שלך בסרי לנקה",
    cta_thailand: "קבל את האישור האלקטרוני שלך בתאילנד",
    cta_togo: "קבל את הוויזה האלקטרונית שלך בטוגו",
    cta_uk: "קבל את ETA בבריטניה",
    cta_usa: "קבל את ה- ESTA שלך",
    cta_vietnam: "קבל את הוויזה האלקטרונית שלך בווייטנאם",
    visa_country_select: {
      label: "ויזות",
      option_bahrain: "ויזה אלקטרונית בחריין",
      option_cambodia: "ויזה אלקטרונית בקמבודיה",
      option_canada: "קנדה eTA",
      option_india: "ויזה אלקטרונית בהודו",
      option_indonesia: "ויזה אלקטרונית של אינדונזיה",
      option_israel: "ישראל ETA-IL",
      option_korea: "דרום קוריאה K-ETA",
      option_morocco: "מרוקו eVisa",
      option_new_zealand: "ניו זילנד NZeTA",
      option_saudi_arabia: "ערב הסעודית eVisa",
      option_sri_lanka: "ויזה אלקטרונית של סרי לנקה",
      option_thailand: "תאילנד eVisa",
      option_togo: "ויזה אלקטרונית של טוגו",
      option_uk: "בריטניה ו",
      option_usa: "ארה\"ב זה",
      option_vietnam: "ויזה אלקטרונית בווייטנאם"
    }
  },
  "new": "חדש",
  new_zealand: "ניו זילנד",
  new_zealand_evisa: "ניו זילנד eTA - NZeTA",
  new_zealand_page: {
    faq: [
      {
        a: "<p>• א <b> שרת כניסה ל- NZeTA לניו זילנד </b> <br> אם ברצונך להיכנס לניו זילנד למטרות תיירות ו/או לימודים לטווח קצר, עליך להנפיק אשרת כניסה ל- NZeTA לניו זילנד. אתה יכול לעשות זאת ישירות באתר שלנו במחיר של {price} <br> אשרת הכניסה לניו זילנד תקפה לשנתיים ומאפשרת לך להיכנס, לנסוע ולהיכנס מחדש לניו זילנד במהלך השנתיים הללו. <br>• <b> אשרת מעבר (חיבור) לניו זילנד </b> <br> אם אתה עובר דרך ניו זילנד בחיבור - כלומר בדרכך ליעד אחר ולא תישאר במדינה, אתה צריך אשרת מעבר. הנפקת אשרת מעבר לניו זילנד דומה להנפקת אשרת כניסה, אך זהו מסמך אחר שנותן לך הרשאות אחרות - או נכון יותר: הגבלות. <br>• אשרת מעבר לניו זילנד מאפשרת לך לעבור בשדה התעופה הבינלאומי באוקלנד. <br>• בזמן השהייה בשדה התעופה, אינך יכול לעזוב את אזור החיבור. <br>• משך השהייה בשדה התעופה מוגבל ל -24 שעות. <br>• עליך להחזיק כרטיס טיסה מניו זילנד, המתוכנן ל -24 השעות הבאות מההגעה. <br>• אינך יכול להגיש בקשות ויזה לניו זילנד במהלך שהותך בשדה התעופה. </p>",
        q: "מה ההבדל בין אשרת כניסה לאשרת מעבר לניו זילנד?"
      },
      {
        a: "עלות הנפקת אשרת תייר לניו זילנד באתר האינטרנט שלנו היא{price}.",
        q: "מה המחיר של NZeTA (ויזה אלקטרונית לניו זילנד)?"
      },
      {
        a: "<p>אשרת כניסה/מעבר של NZeTA לניו זילנד מוכנה תוך 1-2 ימים. <br>במקרים דחופים ניתן לקבל טיפול דחוף ואישור ויזה באותו יום/למחרת. </p>",
        q: "כמה זמן לוקח לקבל את אישור הוויזה האלקטרונית לניו זילנד?"
      },
      {
        a: "<p>לאחר הגשת טופס ה- NZeTA הקצר המקוון באתר שלנו, נעבד את בקשתך ונשלח אותה למשרד ההגירה הראשי של ניו זילנד, המטפל בבקשות לוויזות כניסה/מעבר אלקטרוניות מכל רחבי העולם. <br>לאחר 1-2 ימים הויזה האלקטרונית של NZeTA מאושרת ונשלחת ישירות לדוא\"ל שלך - מסמך זה הוא הרשאה רשמית להיכנס ולבקר בניו זילנד. זה הכל! </p>",
        q: "כיצד פועל תהליך הנפקת הוויזה האלקטרונית של NZeTA?"
      },
      {
        a: "כל אדם המעוניין לבקר בניו זילנד ו/או לעבור בשדה התעופה בניו זילנד חייב להנפיק כניסה/מעבר NZeTA.",
        q: "מי צריך ויזה אלקטרונית לניו זילנד?"
      },
      {
        a: "ויזה אלקטרונית של NZeTA לניו זילנד תקפה לשנתיים מרגע הנפקת הויזה האלקטרונית.",
        q: "כמה זמן תקפה אשרת הכניסה לניו זילנד?"
      },
      {
        a: "הויזה האלקטרונית של NZeTA מאפשרת כניסה ויציאה ללא הגבלה לניו זילנד. אתה יכול לבוא וללכת כרצונך.",
        q: "כמה פעמים מותר לך להיכנס לניו זילנד עם ה- NZeTA?"
      },
      {
        a: "אם רכשת אשרת כניסה (העלות באתר שלנו:{price}), התשובה היא <strong> לא. אין תשלום נוסף עבור דמי IVL, או כל תשלום נוסף אחר. המחיר באתר שלנו מלא וכולל את כל העמלות והעמלות. </strong><br>מצד שני, אם רכשת אשרת מעבר, ואתה מעוניין להיכנס לניו זילנד, תצטרך \"לשדרג\" את בקשתך על ידי תשלום דמי IVL המתבקשים מכל תייר ונגבים להגנת הטבע בניו זילנד.",
        q: "האם יש תשלום נוסף בניו זילנד עבור דמי IVL?"
      },
      {
        a: "<p>כדי לקבל ויזה אלקטרונית של NZeTA עליך לספק את פרטי הדרכון שלך ותמונה עדכנית של הפנים שלך. אתה יכול לצלם סלפי לתמונה זו. <br>לאחר מכן, כדי להיכנס לניו זילנד, תצטרך להציג כרטיס טיסה יוצא. </p>",
        q: "מה נדרש כדי להנפיק ויזה אלקטרונית לניו זילנד?"
      }
    ],
    meta_desc: "קבל את ה- eVisa שלך בניו זילנד תוך 1-2 ימים על ידי מילוי טופס מקוון קצר באנגלית. ויזה רשמית לניו זילנד {currentYear} ללא ביקור בשגרירות",
    title: "NZeTA לניו זילנד - ויזנט לבקשת ויזה מקוונת {currentYear} {'|'}"
  },
  next: "הבא",
  next_day: "יום העסקים הבא",
  no: "לא",
  num_entries: "כניסות מותרות:",
  occupation: "עיסוק",
  order_email_after_payment: "לאחר התשלום המוצלח, תקבל: אישור בדוא\"ל על ההזמנה שלך וקבלה על התשלום שלך.",
  order_summary: "סיכום הזמנה",
  other: "אחר",
  our_payment_methods: "טופס בקשת הויזה שלך מוכן ונשמר במערכת שלנו. כדי לאשר את ההזמנה שלך, אנא השלם את התשלום המאובטח שלך להלן:",
  outside_country: "בחוץ {country}",
  page: {
    about: "על אודות",
    contact: "אנשי קשר",
    country_flag: "דגל המדינה",
    features: {
      "1_body_bahrain": "להיפרד מביקורים בשגרירות וערימות ניירת. הטופס המקוון שלנו יעיל, והאישור האלקטרוני שלך יימסר באמצעות דואר אלקטרוני תוך מספר ימים בלבד.",
      "1_body_cambodia": "להיפרד מביקורים בשגרירות וערימות ניירת. הטופס המקוון שלנו יעיל, והאישור האלקטרוני שלך יימסר באמצעות דואר אלקטרוני תוך מספר ימים בלבד.",
      "1_body_canada": "אין תורים, אין ביקורים בשגרירות - רק טופס מקוון פשוט. קבל את ה- eTA המאושר שלך ישירות לתיבת הדואר הנכנס שלך תוך ימים.",
      "1_body_home": "הגש בקשה בכל עת ובכל מקום. קבל את ה- eVisa המאושרת שלך ישירות לתיבת הדואר הנכנס שלך - נוח, מהיר וחסכוני.",
      "1_body_india": "דלג על השגרירות. הגש בקשה מקוונת תוך דקות, וקבל את eVisa שלך לתיבת הדואר הנכנס שלך תוך 1-3 ימים - מהיר, נוח וללא טרחה.",
      "1_body_indonesia": "להיפרד מביקורים בשגרירות וערימות ניירת. הטופס המקוון שלנו יעיל, והאישור האלקטרוני שלך יימסר באמצעות דואר אלקטרוני תוך מספר ימים בלבד.",
      "1_body_israel": "אין תורים, אין ביקורים בשגרירות - רק טופס מקוון פשוט. קבל את ה- ETA-IL המאושר שלך ישירות לתיבת הדואר הנכנס שלך תוך ימים.",
      "1_body_korea": "אין תורים, אין ביקורים בשגרירות - רק טופס מקוון פשוט. קבל את ה- K-ETA המאושר שלך ישירות לתיבת הדואר הנכנס שלך תוך ימים.",
      "1_body_morocco": "להיפרד מביקורים בשגרירות וערימות ניירת. הטופס המקוון שלנו יעיל, והאישור האלקטרוני שלך יימסר באמצעות דואר אלקטרוני תוך מספר ימים בלבד.",
      "1_body_new_zealand": "אין תורים, אין ביקורים בשגרירות - רק טופס מקוון פשוט. קבל את ה- NZeTA המאושר ישירות לתיבת הדואר הנכנס שלך תוך ימים.",
      "1_body_saudi_arabia": "דלג על השגרירות. הגש בקשה מקוונת תוך דקות, וקבל את eVisa שלך לתיבת הדואר הנכנס שלך תוך 1-3 ימים - מהיר, נוח וללא טרחה.",
      "1_body_sri_lanka": "טופס הבקשה eVisa מוגש ישירות באתר האינטרנט שלנו, ללא צורך בשליחה פיזית של מסמכים או הגעה לשגרירות. לאחר 1-2 ימים תקבל את ה- eVisa המאושרת שהזמנת ישירות לדוא\"ל שלך במחיר הנמוך ביותר.",
      "1_body_thailand": "אין תורים, אין ביקורים בשגרירות - רק טופס מקוון פשוט. קבל את ה- eVisa המאושרת שלך ישירות לתיבת הדואר הנכנס שלך תוך ימים.",
      "1_body_togo": "אין תורים, אין ביקורים בשגרירות - רק טופס מקוון פשוט. קבל את ה- eVisa המאושרת שלך ישירות לתיבת הדואר הנכנס שלך תוך ימים.",
      "1_body_uk": "אין תורים, אין ביקורים בשגרירות - רק טופס מקוון פשוט. קבל את ETA המאושר בבריטניה ישירות לתיבת הדואר הנכנס שלך תוך ימים.",
      "1_body_usa": "אין תורים, אין ביקורים בשגרירות - רק טופס מקוון פשוט. קבל את ה- ESTA המאושר ישירות בתיבת הדואר הנכנס שלך תוך ימים.",
      "1_body_vietnam": "דלג על השגרירות. הגש בקשה מקוונת תוך דקות, וקבל את eVisa שלך לתיבת הדואר הנכנס שלך תוך 1-7 ימים - מהיר, נוח וללא טרחה.",
      "1_title_bahrain": "תהליך מהיר ויעיל",
      "1_title_cambodia": "תהליך מהיר ויעיל",
      "1_title_canada": "תהליך מהיר ויעיל",
      "1_title_home": "תהליך מהיר וקל",
      "1_title_india": "תהליך מהיר וקל",
      "1_title_indonesia": "תהליך מהיר ויעיל",
      "1_title_israel": "תהליך מהיר ויעיל",
      "1_title_korea": "תהליך מהיר ויעיל",
      "1_title_morocco": "תהליך מהיר ויעיל",
      "1_title_new_zealand": "תהליך מהיר ויעיל",
      "1_title_saudi_arabia": "תהליך מהיר וקל",
      "1_title_sri_lanka": "תהליך מהיר וקל",
      "1_title_thailand": "תהליך מהיר ויעיל",
      "1_title_togo": "תהליך מהיר ויעיל",
      "1_title_uk": "תהליך מהיר ויעיל",
      "1_title_usa": "תהליך מהיר ויעיל",
      "1_title_vietnam": "תהליך מהיר וקל",
      "2_body_bahrain": "תיהנו משקט נפשי בידיעה שאנו עומדים היטב מאחורי השירות שלנו. אם הבקשה שלך נדחתה, נתקן אותה או נחזיר לך כספי מלא, ללא שאלות.",
      "2_body_cambodia": "תיהנו משקט נפשי בידיעה שאנו עומדים היטב מאחורי השירות שלנו. אם הבקשה שלך נדחתה, נתקן אותה או נחזיר לך כספי מלא, ללא שאלות.",
      "2_body_canada": "הרגישו רגועים בידיעה שאנחנו עומדים מאחורי השירות שלנו. אם הבקשה שלך נדחתה, נתקן אותה או נחזיר לך את מלוא החזר.",
      "2_body_home": "הרקורד שלנו מדבר בעד עצמו: עשרות אלפי נוסעים מוגשים, תמיד עם 100% הצלחה או הבטחה להחזר מלא.",
      "2_body_india": "תיהנו משקט נפשי עם הבטחת החזר כספי שלנו. אם הבקשה שלך נדחתה, אנו נתקן אותה או נחזיר לך החזר כספי - ללא שאלות.",
      "2_body_indonesia": "תיהנו משקט נפשי בידיעה שאנו עומדים היטב מאחורי השירות שלנו. אם הבקשה שלך נדחתה, נתקן אותה או נחזיר לך כספי מלא, ללא שאלות.",
      "2_body_israel": "הרגישו רגועים בידיעה שאנחנו עומדים מאחורי השירות שלנו. אם הבקשה שלך נדחתה, נתקן אותה או נחזיר לך את מלוא החזר.",
      "2_body_korea": "הרגישו רגועים בידיעה שאנחנו עומדים מאחורי השירות שלנו. אם הבקשה שלך נדחתה, נתקן אותה או נחזיר לך את מלוא החזר.",
      "2_body_morocco": "תיהנו משקט נפשי בידיעה שאנו עומדים היטב מאחורי השירות שלנו. אם הבקשה שלך נדחתה, נתקן אותה או נחזיר לך כספי מלא, ללא שאלות.",
      "2_body_new_zealand": "הרגישו רגועים בידיעה שאנחנו עומדים מאחורי השירות שלנו. אם הבקשה שלך נדחתה, נתקן אותה או נחזיר לך את מלוא החזר.",
      "2_body_saudi_arabia": "תיהנו משקט נפשי עם הבטחת החזר כספי שלנו. אם הבקשה שלך נדחתה, אנו נתקן אותה או נחזיר לך החזר כספי - ללא שאלות.",
      "2_body_sri_lanka": "תיהנו משקט נפשי עם הבטחת החזר כספי שלנו. אם הבקשה שלך נדחתה, אנו נתקן אותה או נחזיר לך החזר כספי - ללא שאלות.",
      "2_body_thailand": "הרגישו רגועים בידיעה שאנחנו עומדים מאחורי השירות שלנו. אם הבקשה שלך נדחתה, נתקן אותה או נחזיר לך את מלוא החזר - ללא שאלות.",
      "2_body_togo": "הרגישו רגועים בידיעה שאנחנו עומדים מאחורי השירות שלנו. אם הבקשה שלך נדחתה, נתקן אותה או נחזיר לך את מלוא החזר.",
      "2_body_uk": "הרגישו רגועים בידיעה שאנחנו עומדים מאחורי השירות שלנו. אם הבקשה שלך נדחתה, נתקן אותה או נחזיר לך את מלוא החזר.",
      "2_body_usa": "הרגישו רגועים בידיעה שאנחנו עומדים מאחורי השירות שלנו. אם הבקשה שלך נדחתה, נתקן אותה או נחזיר לך את מלוא החזר.",
      "2_body_vietnam": "תיהנו משקט נפשי עם הבטחת החזר כספי שלנו. אם הבקשה שלך נדחתה, אנו נתקן אותה או נחזיר לך החזר כספי - ללא שאלות.",
      "2_title_bahrain": "אחריות להצלחה או החזר מלא",
      "2_title_cambodia": "אחריות להצלחה או החזר מלא",
      "2_title_canada": "אחריות להצלחה או החזר מלא",
      "2_title_home": "שקט נפשי מובטח",
      "2_title_india": "אחריות להצלחה או החזר מלא",
      "2_title_indonesia": "אחריות להצלחה או החזר מלא",
      "2_title_israel": "אחריות להצלחה או החזר מלא",
      "2_title_korea": "אחריות להצלחה או החזר מלא",
      "2_title_morocco": "אחריות להצלחה או החזר מלא",
      "2_title_new_zealand": "אחריות להצלחה או החזר מלא",
      "2_title_saudi_arabia": "אחריות להצלחה או החזר מלא",
      "2_title_sri_lanka": "אחריות להצלחה או החזר מלא",
      "2_title_thailand": "אחריות להצלחה או החזר מלא",
      "2_title_togo": "אחריות להצלחה או החזר מלא",
      "2_title_uk": "אחריות להצלחה או החזר מלא",
      "2_title_usa": "אחריות להצלחה או החזר מלא",
      "2_title_vietnam": "אחריות להצלחה או החזר מלא",
      "3_body_bahrain": "מאז 2019, סייענו לאינספור מטיילים ברחבי העולם. התחבר אלינו בכל עת - באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp</a>, <a href=\"{telegram}\"> טלגרם</a>, צ'אט <a data-chat-opener> </a> חי</a>, <a href=\"mailto:{email}\" target=\"_blank\"> דוא\"ל ו <a href=\"tel:{phone}\"> טלפון</a>.",
      "3_body_cambodia": "מאז 2019, סייענו לאינספור מטיילים ברחבי העולם. התחבר אלינו בכל עת - באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp</a>, <a href=\"{telegram}\"> טלגרם</a>, צ'אט <a data-chat-opener> </a> חי</a>, <a href=\"mailto:{email}\" target=\"_blank\"> דוא\"ל ו <a href=\"tel:{phone}\"> טלפון</a>.",
      "3_body_canada": "מאז 2019, עזרנו לאינספור מטיילים לאבטח את ETA שלהם בצורה חלקה. הצוות הרב לשוני שלנו מוכן לסייע בכל עת באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp</a>, <a href=\"{telegram}\"> Telegram</a>, <a data-chat-opener> צ'אט חי </a></a>, <a href=\"mailto:{email}\" target=\"_blank\"> דוא\"ל ו <a href=\"tel:{phone}\"> טלפון</a>.",
      "3_body_home": "החל <a href='/contact'> מצ'אט ודוא\"ל ועד אפליקציות טלפון והודעות</a>, הצוות הידידותי שלנו עומד לשירותך לפני, במהלך ואחרי הטיול שלך.",
      "3_body_india": "מאז 2019, סייענו לעשרות אלפי מטיילים. הצוות שלנו זמין יום ולילה באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp</a>, ט <a href=\"{telegram}\"> לגרם</a>, <a data-chat-opener> צ'אט חי </a></a>, <a href=\"mailto:{email}\" target=\"_blank\"> דוא\"ל ו <a href=\"tel:{phone}\"> טלפון</a>.",
      "3_body_indonesia": "מאז 2019, סייענו לאינספור מטיילים ברחבי העולם. התחבר אלינו בכל עת - באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp</a>, <a href=\"{telegram}\"> טלגרם</a>, צ'אט <a data-chat-opener> </a> חי</a>, <a href=\"mailto:{email}\" target=\"_blank\"> דוא\"ל ו <a href=\"tel:{phone}\"> טלפון</a>.",
      "3_body_israel": "מאז 2019, עזרנו לאינספור מטיילים לאבטח את ETA שלהם בצורה חלקה. הצוות הרב לשוני שלנו מוכן לסייע בכל עת באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp</a>, <a href=\"{telegram}\"> Telegram</a>, <a data-chat-opener> צ'אט חי </a></a>, <a href=\"mailto:{email}\" target=\"_blank\"> דוא\"ל ו <a href=\"tel:{phone}\"> טלפון</a>.",
      "3_body_korea": "מאז 2019, עזרנו לאינספור מטיילים לאבטח את ETA שלהם בצורה חלקה. הצוות הרב לשוני שלנו מוכן לסייע בכל עת באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp</a>, <a href=\"{telegram}\"> Telegram</a>, <a data-chat-opener> צ'אט חי </a></a>, <a href=\"mailto:{email}\" target=\"_blank\"> דוא\"ל ו <a href=\"tel:{phone}\"> טלפון</a>.",
      "3_body_morocco": "מאז 2019, סייענו לאינספור מטיילים ברחבי העולם. התחבר אלינו בכל עת - באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp</a>, <a href=\"{telegram}\"> טלגרם</a>, צ'אט <a data-chat-opener> </a> חי</a>, <a href=\"mailto:{email}\" target=\"_blank\"> דוא\"ל ו <a href=\"tel:{phone}\"> טלפון</a>.",
      "3_body_new_zealand": "מאז 2019, עזרנו לאינספור מטיילים לאבטח את ה-NZETA שלהם בצורה חלקה. הצוות הרב לשוני שלנו מוכן לסייע בכל עת באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp</a>, <a href=\"{telegram}\"> Telegram</a>, <a data-chat-opener> צ'אט חי </a></a>, <a href=\"mailto:{email}\" target=\"_blank\"> דוא\"ל ו <a href=\"tel:{phone}\"> טלפון</a>.",
      "3_body_saudi_arabia": "מאז 2019, סייענו לעשרות אלפי מטיילים. הצוות שלנו זמין יום ולילה באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp</a>, ט <a href=\"{telegram}\"> לגרם</a>, <a data-chat-opener> צ'אט חי </a></a>, <a href=\"mailto:{email}\" target=\"_blank\"> דוא\"ל ו <a href=\"tel:{phone}\"> טלפון</a>.",
      "3_body_sri_lanka": "מאז 2019, סייענו לעשרות אלפי מטיילים. הצוות שלנו זמין יום ולילה באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp</a>, ט <a href=\"{telegram}\"> לגרם</a>, <a data-chat-opener> צ'אט חי </a></a>, <a href=\"mailto:{email}\" target=\"_blank\"> דוא\"ל ו <a href=\"tel:{phone}\"> טלפון</a>.",
      "3_body_thailand": "מאז 2019, עזרנו לאינספור מטיילים לאבטח את eVisa שלהם בצורה חלקה. הצוות הרב לשוני שלנו מוכן לסייע בכל עת באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp</a>, <a href=\"{telegram}\"> Telegram</a>, <a data-chat-opener> צ'אט חי </a></a>, <a href=\"mailto:{email}\" target=\"_blank\"> דוא\"ל ו <a href=\"tel:{phone}\"> טלפון</a>.",
      "3_body_togo": "מאז 2019, עזרנו לאינספור מטיילים לאבטח את eVisa שלהם בצורה חלקה. הצוות הרב לשוני שלנו מוכן לסייע בכל עת באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp</a>, <a href=\"{telegram}\"> Telegram</a>, <a data-chat-opener> צ'אט חי </a></a>, <a href=\"mailto:{email}\" target=\"_blank\"> דוא\"ל ו <a href=\"tel:{phone}\"> טלפון</a>.",
      "3_body_uk": "מאז 2019, עזרנו לאינספור מטיילים לאבטח את ETA שלהם בצורה חלקה. הצוות הרב לשוני שלנו מוכן לסייע בכל עת באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp</a>, <a href=\"{telegram}\"> Telegram</a>, <a data-chat-opener> צ'אט חי </a></a>, <a href=\"mailto:{email}\" target=\"_blank\"> דוא\"ל ו <a href=\"tel:{phone}\"> טלפון</a>.",
      "3_body_usa": "מאז 2019, עזרנו לאינספור מטיילים לאבטח את ה- ESTA שלהם בצורה חלקה. הצוות הרב לשוני שלנו מוכן לסייע בכל עת באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp</a>, <a href=\"{telegram}\"> Telegram</a>, <a data-chat-opener> צ'אט חי </a></a>, <a href=\"mailto:{email}\" target=\"_blank\"> דוא\"ל ו <a href=\"tel:{phone}\"> טלפון</a>.",
      "3_body_vietnam": "מאז 2019, סייענו לעשרות אלפי מטיילים. הצוות שלנו זמין יום ולילה באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp</a>, ט <a href=\"{telegram}\"> לגרם</a>, <a data-chat-opener> צ'אט חי </a></a>, <a href=\"mailto:{email}\" target=\"_blank\"> דוא\"ל ו <a href=\"tel:{phone}\"> טלפון</a>.",
      "3_title_bahrain": "מומחה, שירות לקוחות 24/7",
      "3_title_cambodia": "מומחה, שירות לקוחות 24/7",
      "3_title_canada": "תמיכת לקוחות מקצועית 24/7",
      "3_title_home": "תמיכה ייעודית מסביב לשעון",
      "3_title_india": "תמיכת לקוחות מקצועית 24/7",
      "3_title_indonesia": "מומחה, שירות לקוחות 24/7",
      "3_title_israel": "תמיכת לקוחות מקצועית 24/7",
      "3_title_korea": "תמיכת לקוחות מקצועית 24/7",
      "3_title_morocco": "מומחה, שירות לקוחות 24/7",
      "3_title_new_zealand": "תמיכת לקוחות מקצועית 24/7",
      "3_title_saudi_arabia": "תמיכת לקוחות מקצועית 24/7",
      "3_title_sri_lanka": "תמיכת לקוחות מקצועית 24/7",
      "3_title_thailand": "תמיכת לקוחות מקצועית 24/7",
      "3_title_togo": "תמיכת לקוחות מקצועית 24/7",
      "3_title_uk": "תמיכת לקוחות מקצועית 24/7",
      "3_title_usa": "תמיכת לקוחות מקצועית 24/7",
      "3_title_vietnam": "תמיכת לקוחות מקצועית 24/7",
      open_passports_img: "דרכונים פתוחים",
      socials_body_bahrain: "זקוקים לעזרה, עדכונים או טיפים לטיולים? <a href='/contact'>פנה אלינו </a> או עקוב אחרינו ברשתות החברתיות. אנו מחויבים להפוך את המסע שלך ללא מאמץ מתחילתו ועד סופו.",
      socials_body_cambodia: "זקוקים לעזרה, עדכונים או טיפים לטיולים? <a href='/contact'>פנה אלינו </a> או עקוב אחרינו ברשתות החברתיות. אנו מחויבים להפוך את המסע שלך ללא מאמץ מתחילתו ועד סופו.",
      socials_body_canada: "זקוקים לעזרה או למידע נוסף? <a href='/contact'>צור קשר </a> או עקוב אחרינו ברשתות החברתיות כדי להישאר מעודכן ולהפוך את תכנון הנסיעות שלך לקל עוד יותר.",
      socials_body_home: "שאלות, משוב או טיפים לטיולים? התחבר אלינו בפלטפורמה המועדפת עליך ובוא נשמור על הנסיעות שלך חלקות.",
      socials_body_india: "יש לך שאלה או זקוק לעזרה? <a href='/contact'>פנה אלינו </a> או עקוב אחרינו ברשתות החברתיות כדי להישאר מעודכן.",
      socials_body_indonesia: "זקוקים לעזרה, עדכונים או טיפים לטיולים? <a href='/contact'>פנה אלינו </a> או עקוב אחרינו ברשתות החברתיות. אנו מחויבים להפוך את המסע שלך ללא מאמץ מתחילתו ועד סופו.",
      socials_body_israel: "זקוקים לעזרה או למידע נוסף? <a href='/contact'>צור קשר </a> או עקוב אחרינו ברשתות החברתיות כדי להישאר מעודכן ולהפוך את תכנון הנסיעות שלך לקל עוד יותר.",
      socials_body_korea: "זקוקים לעזרה או למידע נוסף? <a href='/contact'>צור קשר </a> או עקוב אחרינו ברשתות החברתיות כדי להישאר מעודכן ולהפוך את תכנון הנסיעות שלך לקל עוד יותר.",
      socials_body_morocco: "זקוקים לעזרה, עדכונים או טיפים לטיולים? <a href='/contact'>פנה אלינו </a> או עקוב אחרינו ברשתות החברתיות. אנו מחויבים להפוך את המסע שלך ללא מאמץ מתחילתו ועד סופו.",
      socials_body_new_zealand: "זקוקים לעזרה או למידע נוסף? <a href='/contact'>צור קשר </a> או עקוב אחרינו ברשתות החברתיות כדי להישאר מעודכן ולהפוך את תכנון הנסיעות שלך לקל עוד יותר.",
      socials_body_saudi_arabia: "יש לך שאלה או זקוק לעזרה? <a href='/contact'>פנה אלינו </a> או עקוב אחרינו ברשתות החברתיות כדי להישאר מעודכן.",
      socials_body_sri_lanka: "יש לך שאלה או זקוק לעזרה? <a href='/contact'>פנה אלינו </a> או עקוב אחרינו ברשתות החברתיות כדי להישאר מעודכן.",
      socials_body_thailand: "זקוקים לעזרה או למידע נוסף? <a href='/contact'>צור קשר </a> או עקוב אחרינו ברשתות החברתיות כדי להישאר מעודכן ולהפוך את תכנון הנסיעות שלך לקל עוד יותר.",
      socials_body_togo: "זקוקים לעזרה או למידע נוסף? <a href='/contact'>צור קשר </a> או עקוב אחרינו ברשתות החברתיות כדי להישאר מעודכן ולהפוך את תכנון הנסיעות שלך לקל עוד יותר.",
      socials_body_uk: "זקוקים לעזרה או למידע נוסף? <a href='/contact'>צור קשר </a> או עקוב אחרינו ברשתות החברתיות כדי להישאר מעודכן ולהפוך את תכנון הנסיעות שלך לקל עוד יותר.",
      socials_body_usa: "זקוקים לעזרה או למידע נוסף? <a href='/contact'>צור קשר </a> או עקוב אחרינו ברשתות החברתיות כדי להישאר מעודכן ולהפוך את תכנון הנסיעות שלך לקל עוד יותר.",
      socials_body_vietnam: "יש לך שאלה או זקוק לעזרה? <a href='/contact'>פנה אלינו </a> או עקוב אחרינו ברשתות החברתיות כדי להישאר מעודכן.",
      why_evisa_desc_bahrain: "באתר שלנו תוכלו להגיש בקשה לוויזה אלקטרונית לבחריין ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 3-5 ימים בלבד. שלח טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים כלשהם או לבקר בשגרירות, ולקבל את ה- eVisa הרשמית שלך לבחריין.",
      why_evisa_desc_cambodia: "באתר האינטרנט שלנו תוכלו להגיש בקשה לוויזה אלקטרונית לקמבודיה ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 3-5 ימים בלבד. שלח טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים כלשהם או לבקר בשגרירות, ולקבל את הויזה האלקטרונית הרשמית שלך לקמבודיה, בתוקף למשך 30 יום.",
      why_evisa_desc_canada: "באתר האינטרנט שלנו תוכלו להגיש בקשה ל- eTA לקנדה ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 1-2 ימים בלבד. הגש טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים או לבקר בשגרירות, ולקבל את ה- eTA הרשמי שלך לקנדה, בתוקף למשך 5 שנים.",
      why_evisa_desc_home: "באתר האינטרנט שלנו תוכלו להגיש בקשה לויזה אלקטרונית למדינות שונות ולקבל את מכתב אישור הויזה שלכם למייל שלכם תוך מספר ימים. הגש טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים כלשהם או לבקר בשגרירות, ולקבל את אשרת הכניסה הרשמית שלך.",
      why_evisa_desc_india: "באתר האינטרנט שלנו תוכלו להגיש בקשה ל- eVisa להודו ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 1-3 ימים בלבד. שלח טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים כלשהם או לבקר בשגרירות, וקבל את ה- eVisa הרשמית שלך להודו, בתוקף בין 30 יום ל -5 שנים.",
      why_evisa_desc_indonesia: "באתר האינטרנט שלנו תוכלו להגיש בקשה ל- eVisa לאינדונזיה ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 1-3 ימים בלבד. שלח טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים כלשהם או לבקר בשגרירות, ולקבל את ה- eVisa הרשמית שלך לאינדונזיה, תקפה למשך 60 יום.",
      why_evisa_desc_israel: "באתר האינטרנט שלנו תוכלו להגיש בקשה ל-ETA-IL לישראל ולקבל את מכתב האישור שלכם למייל שלכם תוך 1-2 ימים בלבד. הגש טופס מהיר וקל, מאובטח באינטרנט, ללא צורך בשליחת מסמכים פיזית או ביקור בשגרירות, וקבל אישור נסיעה אלקטרוני רשמי לישראל בתוקף לשנתיים.",
      why_evisa_desc_korea: "באתר שלנו אתה יכול להגיש בקשה ל- K-ETA לדרום קוריאה ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 1-3 ימים בלבד. שלח טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים כלשהם או לבקר בשגרירות, ולקבל את ה- K-ETA הרשמי שלך לדרום קוריאה, בתוקף לשנתיים.",
      why_evisa_desc_morocco: "באתר האינטרנט שלנו תוכלו להגיש בקשה לוויזה אלקטרונית למרוקו ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 1-3 ימים בלבד. שלח טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים כלשהם או לבקר בשגרירות, וקבל את ה- eVisa הרשמית שלך למרוקו, בתוקף למשך 180 יום.",
      why_evisa_desc_new_zealand: "באתר האינטרנט שלנו תוכל להגיש בקשה ל- NZeTA לניו זילנד ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 1-2 ימים בלבד. שלח טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים כלשהם או לבקר בשגרירות, ולקבל את ה- NZeTA הרשמי שלך לניו זילנד, בתוקף לשנתיים.",
      why_evisa_desc_saudi_arabia: "באתר האינטרנט שלנו תוכלו להגיש בקשה ל- eVisa לסעודיה ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 1-2 ימים בלבד. שלח טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים כלשהם או לבקר בשגרירות, וקבל את ה- eVisa הרשמית שלך לסעודיה, בתוקף למשך 180 יום.",
      why_evisa_desc_sri_lanka: "באתר האינטרנט שלנו תוכלו להגיש בקשה ל- eVisa לסרי לנקה ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 1-2 ימים בלבד. שלח טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים כלשהם או לבקר בשגרירות, וקבל את ה- eVisa הרשמית שלך לסרי לנקה, בתוקף למשך 30 יום.",
      why_evisa_desc_thailand: "באתר האינטרנט שלנו תוכלו להגיש בקשה ל- eVisa לתאילנד ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 1-3 ימים בלבד. שלח טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים כלשהם או לבקר בשגרירות, וקבל את ה- eVisa הרשמית שלך לתאילנד, בתוקף למשך 90 יום עד 5 שנים.",
      why_evisa_desc_togo: "באתר האינטרנט שלנו תוכלו להגיש בקשה לוויזה אלקטרונית לטוגו ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 1-3 ימים בלבד. שלח טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים כלשהם או לבקר בשגרירות, וקבל את ה- eVisa הרשמית שלך לטוגו, בתוקף למשך 15 יום עד 90 יום.",
      why_evisa_desc_uk: "באתר האינטרנט שלנו תוכל להגיש בקשה ל- ETA לבריטניה ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 1-3 ימים בלבד. שלח טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים כלשהם או לבקר בשגרירות, ולקבל את ETA הרשמית שלך לבריטניה, בתוקף למשך 6 חודשים.",
      why_evisa_desc_usa: "באתר האינטרנט שלנו אתה יכול להגיש בקשה ל- ESTA לארה\"ב ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 1-3 ימים בלבד. הגש טופס מהיר וקל, מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים או לבקר בשגרירות, ולקבל את ה- ESTA הרשמית שלך לארה\"ב, בתוקף לשנתיים.",
      why_evisa_desc_vietnam: "באתר האינטרנט שלנו תוכלו להגיש בקשה לוויזה אלקטרונית לווייטנאם ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 4-5 ימים בלבד. שלח טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים כלשהם או לבקר בשגרירות, וקבל את ה- eVisa הרשמית שלך לווייטנאם, בתוקף למשך 90 יום.",
      why_title_bahrain: "מדוע לקבל את הויזה שלך לבחריין באופן מקוון",
      why_title_cambodia: "מדוע לקבל את הוויזה שלך לקמבודיה באופן מקוון",
      why_title_canada: "מדוע לקבל את הוויזה שלך לקנדה באופן מקוון",
      why_title_home: "למה כדאי להזמין ויזה באתר ויזה.נט?",
      why_title_india: "מדוע לקבל את הויזה שלך להודו באופן מקוון",
      why_title_indonesia: "מדוע לקבל את ה- eVisa האינדונזיה שלך באינטרנט",
      why_title_israel: "למה לקבל את הוויזה שלך לישראל באופן מקוון עם Visanet",
      why_title_korea: "מדוע לקבל את הויזה שלך לדרום קוריאה באופן מקוון עם Visanet",
      why_title_morocco: "מדוע לקבל את הוויזה שלך למרוקו באופן מקוון",
      why_title_new_zealand: "מדוע לקבל את הוויזה שלך לניו זילנד באופן מקוון",
      why_title_saudi_arabia: "מדוע לקבל את הוויזה שלך לסעודיה באופן מקוון עם Visanet",
      why_title_sri_lanka: "מדוע לקבל את הויזה שלך לסרי לנקה באופן מקוון",
      why_title_thailand: "מדוע לקבל את הויזה שלך לתאילנד באופן מקוון",
      why_title_togo: "מדוע לקבל את הויזה שלך לטוגו באופן מקוון",
      why_title_uk: "מדוע לקבל את הויזה שלך לבריטניה באופן מקוון",
      why_title_usa: "למה לקבל את הויזה שלך לארה\"ב באינטרנט",
      why_title_vietnam: "מדוע לקבל את הוויזה שלך לווייטנאם באופן מקוון עם Visanet"
    },
    form_title_bahrain: "טופס ויזה אלקטרונית בחריין",
    form_title_cambodia: "טופס ויזה אלקטרונית בקמבודיה",
    form_title_canada: "טופס eTA קנדה",
    form_title_india: "טופס ויזה אלקטרונית בהודו",
    form_title_indonesia: "טופס ויזה אלקטרונית באינדונזיה",
    form_title_israel: "טופס ישראל ETA-IL",
    form_title_korea: "טופס K-ETA של דרום קוריאה",
    form_title_morocco: "טופס ויזה אלקטרונית מרוקו",
    form_title_new_zealand: "טופס NZeTA של ניו זילנד",
    form_title_saudi_arabia: "טופס ויזה אלקטרוני של ערב הסעודית",
    form_title_sri_lanka: "טופס ויזה אלקטרונית בסרי לנקה",
    form_title_thailand: "טופס ויזה אלקטרונית בתאילנד",
    form_title_togo: "טוגו טוגו eVisa",
    form_title_uk: "טופס ETA בבריטניה",
    form_title_usa: "טופס ESTA בארה\"ב",
    form_title_vietnam: "טופס ויזה אלקטרונית בווייטנאם",
    get_visa_cta_bahrain: "קבל את הויזה האלקטרונית שלך בבחריין",
    get_visa_cta_cambodia: "קבל את הוויזה האלקטרונית שלך בקמבודיה",
    get_visa_cta_canada: "קבל את eTA שלך בקנדה",
    get_visa_cta_india: "קבל את הויזה האלקטרונית שלך בהודו",
    get_visa_cta_indonesia: "קבל את האישור האלקטרוני שלך באינדונזיה",
    get_visa_cta_israel: "קבל את ה- ETA-IL בישראל שלך",
    get_visa_cta_korea: "קבל את ה- KETA שלך בדרום קוריאה",
    get_visa_cta_morocco: "קבל את האישור האלקטרוני שלך במרוקו",
    get_visa_cta_new_zealand: "קבל את ניו זילנד NZeTA שלך",
    get_visa_cta_saudi_arabia: "קבל את האישור האלקטרוני שלך בערב הסעודית",
    get_visa_cta_sri_lanka: "קבל את הוויזה האלקטרונית שלך בסרי לנקה",
    get_visa_cta_thailand: "קבל את האישור האלקטרוני שלך בתאילנד",
    get_visa_cta_togo: "קבל את הוויזה האלקטרונית שלך בטוגו",
    get_visa_cta_uk: "קבל את ETA בבריטניה",
    get_visa_cta_usa: "קבל את ה- ESTA שלך בארה\"ב",
    get_visa_cta_vietnam: "קבל את הוויזה האלקטרונית שלך בווייטנאם",
    hero_body_bahrain: "הגש בקשה מקוונת תוך דקות וקבל את הוויזה הרשמית שלך לבחריין ישירות בתיבת הדואר הנכנס שלך - ללא ביקורים בשגרירות, ללא טרחה. עם תמיכה 24/7 וערבות הצלחה של 100%, אנו הופכים את התחלת ההרפתקה שלך בחריין לפשוטה ככל האפשר.",
    hero_body_cambodia: "הגש בקשה מקוונת תוך דקות וקבל את הוויזה הרשמית שלך לקמבודיה ישירות בתיבת הדואר הנכנס שלך - ללא ביקורים בשגרירות, ללא טרחה. עם תמיכה 24/7 וערבות הצלחה של 100%, אנו הופכים את התחלת ההרפתקה שלך בקמבודיה לפשוטה ככל האפשר.",
    hero_body_canada: "הגש בקשה מקוונת תוך דקות לקבלת אשרת eTA הרשמית שלך לקנדה - ללא ביקורים בשגרירות או ניירת מייגעת. עם תמיכה 24/7, אחריות להצלחה של 100% ומשלוח דואר אלקטרוני ישיר, אנו הופכים את המסע שלך לקנדה ללא מתח.",
    hero_body_india: "הגש בקשה מקוונת תוך דקות וקבל את ה- eVisa הרשמית שלך להודו בדוא\"ל - אין צורך בביקורים בשגרירות או בניירת. עם תמיכה 24/7 וערבות הצלחה של 100%, אנו הופכים את המסע שלך להודו לחלק וללא מתח.",
    hero_body_indonesia: "הגש בקשה מקוונת תוך דקות וקבל את הוויזה שלך לאינדונזיה - אין צורך בביקורי שגרירות. בין אם אתם נרגעים בבאלי או חוקרים מעבר לכך, תיהנו מתמיכה 24/7 ומהבטחת הצלחה של 100% לטיול ללא מתח.",
    hero_body_israel: "הגש בקשה מקוונת תוך דקות וקבל את ה- ETA-IL הרשמי שלך לישראל בדוא\"ל - אין צורך בביקורים בשגרירות או בניירת. עם תמיכה 24/7 וערבות הצלחה של 100%, אנו הופכים את המסע שלך לישראל לחלק וללא מתח.",
    hero_body_korea: "הגש בקשה מקוונת תוך דקות לקבלת אשרת K-ETA הרשמית שלך לדרום קוריאה - אין צורך בביקורים בשגרירות או בניירת. עם תמיכה 24/7, 100% אחריות להצלחה ומשלוח דואר אלקטרוני ישיר, אנו הופכים את המסע שלך ללא מתח.",
    hero_body_morocco: "הגש בקשה מקוונת תוך דקות וקבל את הוויזה הרשמית שלך למרוקו ישירות בתיבת הדואר הנכנס שלך - ללא ביקורים בשגרירות, ללא טרחה. עם תמיכה 24/7 וערבות הצלחה של 100%, אנו הופכים את התחלת ההרפתקה שלך במרוקו לפשוטה ככל האפשר.",
    hero_body_new_zealand: "הגש בקשה מקוונת תוך דקות לקבלת אשרת ה- NZeTA הרשמית שלך לניו זילנד - ללא ביקורים בשגרירות או ניירת מייגעת. עם תמיכה 24/7, אחריות להצלחה של 100% ומשלוח דואר אלקטרוני ישיר, אנו הופכים את המסע שלך ללא מתח.",
    hero_body_saudi_arabia: "הגש בקשה מקוונת תוך דקות כדי לקבל את האישור האלקטרוני הרשמי שלך בערב הסעודית בדוא\"ל - אין צורך בביקורים בשגרירות או בניירת. תיהנו מתמיכה 24/7 ומהבטחת הצלחה של 100% לטיול חלק.",
    hero_body_sri_lanka: "הגש בקשה מקוונת באמצעות הטופס המאובטח שלנו כדי לקבל את ה- eVisa הרשמית שלך לסרי לנקה שנמסר ישירות לדוא\"ל שלך. הימנע מביקור בשגרירות ומניירת ממושכת עם תהליך מהיר ואמין המגובה באחריות ההצלחה של 100% שלנו. צוות התמיכה שלנו 24/7 תמיד מוכן לסייע.",
    hero_body_thailand: "הגש בקשה מקוונת תוך דקות לקבלת הוויזה האלקטרונית הרשמית שלך לתאילנד - ללא ביקורים בשגרירות או ניירת מייגעת. עם תמיכה 24/7, אחריות להצלחה של 100% ומשלוח דואר אלקטרוני ישיר, אנו הופכים את המסע שלך לתאילנד ללא מתח.",
    hero_body_togo: "הגש בקשה מקוונת תוך דקות וקבל את הויזה הרשמית שלך לטוגו ישירות בתיבת הדואר הנכנס שלך - ללא ביקורים בשגרירות, ללא טרחה. עם תמיכה 24/7 וערבות הצלחה של 100%, אנו הופכים את התחלת ההרפתקה שלך בטוגו לפשוטה ככל האפשר.",
    hero_body_uk: "ETA שלך בבריטניה מכסה את אנגליה, ויילס, סקוטלנד וצפון אירלנד. הגש בקשה מקוונת תוך דקות וקבל את אישורך בדוא\"ל - ללא ביקורים בשגרירות, ללא טרחה. עם תמיכה 24/7 וערבות הצלחה של 100%, הנסיעה היא ללא דאגות.",
    hero_body_usa: "הגש בקשה מקוונת תוך דקות לקבלת ESTA הרשמית שלך לארצות הברית - אין צורך בביקורים בשגרירות או בניירת. עם תמיכה 24/7, אחריות להצלחה של 100% ומשלוח דואר אלקטרוני ישיר, אנו הופכים את המסע שלך לאמריקה ללא מתח.",
    hero_body_vietnam: "הגש בקשה מקוונת תוך דקות וקבל את הוויזה האלקטרונית הרשמית שלך לווייטנאם בדוא\"ל - אין צורך בביקורים בשגרירות או בניירת. עם תמיכה 24/7 וערבות הצלחה של 100%, אנו הופכים את המסע שלך לווייטנאם לחלק וללא מתח.",
    hero_header_bahrain: "ויזה אלקטרונית בחריין",
    hero_header_cambodia: "ויזה אלקטרונית בקמבודיה",
    hero_header_canada: "קנדה eTA",
    hero_header_home: "ויזות למטייל הישראלי בחו״ל",
    hero_header_india: "ויזה אלקטרונית בהודו",
    hero_header_indonesia: "ויזה אלקטרונית של אינדונזיה",
    hero_header_israel: "ישראל ETA-IL",
    hero_header_korea: "דרום קוריאה K-ETA",
    hero_header_morocco: "מרוקו eVisa",
    hero_header_new_zealand: "ניו זילנד NZeTA",
    hero_header_saudi_arabia: "ערב הסעודית eVisa",
    hero_header_sri_lanka: "ויזה אלקטרונית של סרי לנקה",
    hero_header_thailand: "תאילנד eVisa",
    hero_header_togo: "ויזה אלקטרונית של טוגו",
    hero_header_uk: "בריטניה ו",
    hero_header_usa: "ארה\"ב זה",
    hero_header_vietnam: "ויזה אלקטרונית בווייטנאם",
    hero_price: "מחיר:",
    hero_processing: "אישור:",
    hero_sub: "ברוכים הבאים לויזה.נט — האתר המוביל בישראל להנפקת ויזות אלקטרוניות: <a href=\"/india\">ויזה להודו</a>, <a href=\"/us\">ויזה לארה״ב</a>, <a href=\"/uk\">ויזה לאנגליה</a>, <a href=\"/vietnam\">ויזה לויאטנם</a>, <a href=\"/morocco\">ויזה למרוקו</a>, <a href=\"/canada\">ויזה לקנדה</a>, <a href=\"/israel\">ויזה לישראל</a> ועוד מגוון יעדים. הגשת טופס ויזה אונליין, בתהליך פשוט, קצר ומאובטח, במחיר הוגן וללא צורך לבקר בשגרירות.",
    hero_sub_bahrain: "קבל את ה- eVisa שלך בבחריין בקלות",
    hero_sub_cambodia: "קבל את הוויזה האלקטרונית שלך בקמבודיה בקלות",
    hero_sub_canada: "קבל את eTA שלך בקנדה באופן מיידי",
    hero_sub_india: "קבל את הויזה האלקטרונית שלך בהודו במהירות",
    hero_sub_indonesia: "קבל את האישור האלקטרוני שלך באינדונזיה במהירות",
    hero_sub_israel: "קבל את ETA-IL בישראל באופן מיידי",
    hero_sub_korea: "קבל את ה- K-ETA שלך בקוריאה באופן מיידי",
    hero_sub_morocco: "קבל את ה- eVisa שלך במרוקו בקלות",
    hero_sub_new_zealand: "קבל את ה- NZeTA שלך בניו זילנד במהירות",
    hero_sub_saudi_arabia: "קבל את ה- eVisa הסעודית שלך במהירות",
    hero_sub_sri_lanka: "נסיעות לסרי לנקה הופכות לפשוטות",
    hero_sub_thailand: "קבל את האישור האלקטרוני שלך בתאילנד במהירות",
    hero_sub_togo: "קבל את ה-eVisa שלך בטוגו בקלות",
    hero_sub_uk: "קבל את ETA שלך בבריטניה באופן מיידי",
    hero_sub_usa: "קבל את ה- ESTA שלך בארה\"ב במהירות",
    hero_sub_vietnam: "קבל את הוויזה האלקטרונית שלך בווייטנאם במהירות",
    hero_video: "סרטון של חותמת ויזה Visanet בתוך דף הפתיחה של דרכון",
    how_it_works: "איך התהליך עובד",
    language: "שפה",
    more_reviews: {
      body: "לביקורות נוספות של לקוחות, בקר אותנו בכתובת:",
      title: "ראה את כל הביקורות שלנו"
    },
    pricing_card: {
      approved_within_bahrain: "ויזה אלקטרונית תוך 1-3 ימים",
      approved_within_cambodia: "ויזה אלקטרונית תוך 3-5 ימים",
      approved_within_canada: "ETA אושרה תוך 1-3 ימים",
      approved_within_india: "ויזה אלקטרונית תוך 1-3 ימים",
      approved_within_indonesia: "ויזה אושרה תוך 2-3 ימים",
      approved_within_israel: "ETA אושרה תוך 1-3 ימים",
      approved_within_korea: "KETA אושרה תוך 1-2 ימים",
      approved_within_morocco: "ויזה אלקטרונית תוך 2-3 ימים",
      approved_within_new_zealand: "NZeTA אושר תוך 1-3 ימים",
      approved_within_saudi_arabia: "ויזה אלקטרונית אושרה תוך 1-2 ימים",
      approved_within_sri_lanka: "ויזה אלקטרונית אושרה תוך 1-2 ימים",
      approved_within_thailand: "ויזה אושרה תוך 3-21 ימים",
      approved_within_togo: "ויזה אלקטרונית תוך 1-3 ימים",
      approved_within_uk: "אישור ETA בבריטניה תוך 1-3 ימים",
      approved_within_usa: "אישור ESTA תוך 1-3 ימים",
      approved_within_vietnam: "ויזה אושרה תוך 2-3 ימים",
      no_embassy: "אין צורך לבקר בשגרירות",
      online: "קבל אישור באינטרנט, ישירות מהבית",
      skip_voa: "דלג על קו VoA בשדה התעופה",
      support: "תמיכה מתמדת מתחילתו ועד סופו",
      urgent_option: "הזמנה אקספרס למקרים דחופים",
      valid_15_days_30_days_90_days: "תקף למשך 15 יום, 30 יום או 90 יום",
      valid_1_year_90_days_per_visit: "תקף לשנה אחת, 90 יום לביקור",
      valid_2_years: "תקף לשנתיים",
      valid_2_years_90_days_per_visit: "תקף לשנתיים, 90 יום לביקור",
      valid_3_months_6_months_5_years: "תקף למשך 3 חודשים, 6 חודשים או 5 שנים",
      valid_5_years_6_months_per_visit: "תקף למשך 5 שנים, 6 חודשים לביקור",
      valid_for_180_days: "תקף למשך 180 יום",
      valid_for_2_weeks_3_months_or_more: "תקף לשבועיים, 3 חודשים או יותר",
      valid_for_30_days: "תקף למשך 30 יום",
      valid_for_30_days_90_days_1_year_stay: "תקף למשך 30 יום, 90 יום או שנה",
      valid_for_30_days_or_more: "תקף למשך 30 יום או יותר",
      valid_for_3_months: "תקף למשך 3 חודשים",
      valid_for_90_days: "תקף למשך 90 יום",
      valid_two_years_90_days_stay: "תקף לשנתיים, 90 ימי שהייה"
    },
    product_features: {
      cta: "הגש בקשה לויזה",
      img_bahrain: "קו הרקיע של בחריין, ויזה אלקטרונית בחריין",
      img_cambodia: "כפר בקמבודיה, קמבודיה eVisa",
      img_canada: "האגם וההר הקנדי, קנדה ETA",
      img_india: "מקדש גנגטוק, הודו eVisa",
      img_indonesia: "חתירה בבאלי, ויזה אינדונזיה",
      img_israel: "הגנים הבהאים בחיפה, ישראל ETA-IL",
      img_korea: "כפר האנוק, דרום קוריאה KETA",
      img_morocco: "אוארזאזאט, מרוקו eVisa",
      img_new_zealand: "ערוץ הוקיטיקה, ניו זילנד NZeTA",
      img_saudi_arabia: "נוף ערב הסעודית, ערב הסעודית eVisa",
      img_sri_lanka: "קו החוף, ויזת סרי לנקה",
      img_thailand: "וואט צ'אלונג, ויזה תאילנד",
      img_togo: "פסל בודהה, ויזה טוגו",
      img_uk: "סטונהנג', ETA בבריטניה",
      img_usa: "ניו יורק, ארה\"ב ESTA",
      img_vietnam: "הוי אן, וייטנאם ויזה",
      processing: "אישור:",
      title_bahrain: "ויזה לבחריין",
      title_cambodia: "ויזה לקמבודיה",
      title_canada: "ויזה לקנדה",
      title_india: "ויזה להודו",
      title_indonesia: "ויזה לאינדונזיה",
      title_israel: "ויזה לישראל",
      title_korea: "ויזה לדרום קוריאה",
      title_morocco: "ויזה למרוקו",
      title_new_zealand: "ויזה לניו זילנד",
      title_saudi_arabia: "ויזה לסעודיה",
      title_sri_lanka: "ויזה לסרי לנקה",
      title_thailand: "ויזה לתאילנד",
      title_togo: "ויזה לטוגו",
      title_uk: "ויזה לבריטניה",
      title_usa: "ויזה לארצות הברית",
      title_vietnam: "ויזה לווייטנאם",
      validity: "תוקף:"
    },
    start_filling_form_bahrain: "התחל את בקשתך עוד היום וקבל את ה- eVisa המאושרת שלך תוך 3-5 ימים. הגיע הזמן לחקור את היופי של בחריין ללא עיכובים או כאבי ראש.",
    start_filling_form_cambodia: "התחל את בקשתך עוד היום וקבל את ה- eVisa המאושרת שלך תוך 3-5 ימים. הגיע הזמן לחקור את היופי של קמבודיה ללא עיכובים או כאבי ראש.",
    start_filling_form_canada: "התחל עכשיו, ותקבל את eTA המאושרת שלך בדוא\"ל תוך 1-3 ימים. התנסה בתכנון נסיעות קל ומאובטח - התחל את הבקשה שלך עוד היום.",
    start_filling_form_india: "התחל את הבקשה שלך עכשיו וקבל את ה- eVisa המאושרת שלך בדוא\"ל תוך 1-3 ימים בלבד. הפוך את הנסיעות שלך לפשוטות, מאובטחות וללא מתח.",
    start_filling_form_indonesia: "התחל את בקשתך עוד היום וקבל את ה- eVisa המאושרת שלך תוך 5 ימים. הגיע הזמן לחקור את היופי של אינדונזיה ללא עיכובים או כאבי ראש.",
    start_filling_form_israel: "התחל עכשיו, ותקבל את ה- ETA-IL המאושר שלך בדוא\"ל תוך 1-3 ימים. התנסה בתכנון נסיעות קל ומאובטח - התחל את היישום שלך עוד היום.",
    start_filling_form_korea: "התחל עכשיו, ותקבל את ה- K-ETA המאושר שלך בדוא\"ל תוך 1-3 ימים. התנסה בתכנון נסיעות קל ומאובטח - התחל את היישום שלך עוד היום.",
    start_filling_form_morocco: "התחל את בקשתך עוד היום וקבל את ה- eVisa המאושרת שלך תוך 1-3 ימים. הגיע הזמן לחקור את היופי של מרוקו ללא עיכובים או כאבי ראש.",
    start_filling_form_new_zealand: "התחל עכשיו, ותקבל את ה- nZeTA המאושר שלך בדוא\"ל תוך 1-3 ימים. התנסה בתכנון נסיעות קל ומאובטח - התחל את היישום שלך עוד היום.",
    start_filling_form_saudi_arabia: "התחל את הבקשה שלך עכשיו וקבל את ה- eVisa המאושרת שלך בדוא\"ל תוך 1-3 ימים בלבד. הפוך את הנסיעות שלך לפשוטות, מאובטחות וללא מתח.",
    start_filling_form_sri_lanka: "התחל למלא את הטופס המקוון הפשוט שלנו עכשיו וקבל את אישור ה- eVisa שלך ונמסר לדוא\"ל שלך תוך 1-3 ימים.",
    start_filling_form_thailand: "התחל עכשיו, ותקבל את ה-eVisa המאושרת שלך בדוא\"ל תוך 3-21 ימים. התנסה בתכנון נסיעות קל ומאובטח - התחל את היישום שלך עוד היום.",
    start_filling_form_togo: "התחל את בקשתך עוד היום וקבל את ה- eVisa המאושרת שלך תוך 1-3 ימים. הגיע הזמן לחקור את היופי של טוגו ללא עיכובים או כאבי ראש.",
    start_filling_form_uk: "התחל עכשיו, ותקבל את ETA המאושרת בבריטניה בדוא\"ל תוך 1-3 ימים. התנסה בתכנון נסיעות קל ומאובטח - התחל את הבקשה שלך עוד היום.",
    start_filling_form_usa: "התחל עכשיו, ותקבל את ה- ESTA המאושרת שלך בדוא\"ל תוך 1-3 ימים. התנסה בתכנון נסיעות קל ומאובטח - התחל את היישום שלך עוד היום.",
    start_filling_form_vietnam: "התחל את הבקשה שלך עכשיו וקבל את ה- eVisa המאושרת שלך בדוא\"ל תוך 1-7 ימים בלבד. הפוך את הנסיעות שלך לפשוטות, מאובטחות וללא מתח.",
    steps: {
      "1_body_bahrain": "ה <a href='#form'> שלם את היישום </a> המאובטח שלנו בכמה שלבים פשוטים. אין ניירת, אין תורים, ואין יציאה מהבית.",
      "1_body_cambodia": "ה <a href='#form'> שלם את היישום </a> המאובטח שלנו בכמה שלבים פשוטים. אין ניירת, אין תורים, ואין יציאה מהבית.",
      "1_body_canada": "מלא את ה <a href='#form'> טופס המאובטח שלנו </a> תוך דקות ספורות - אין צורך להגיש מסמכים פיזיים או לבקר במשרד.",
      "1_body_home": "הגשת טופס הויזה המקוון באתרנו הנו תהליך פשוט, המתבצע כולו בעברית אונליין, ולוקח בממוצע כ-5-10 דק' בלבד. אנחנו מבקשים להזין רק פרטי דרכון (ובמדינות מסוימות להוסיף תמונות) — ללא צורך בשליחת מסמכים בדואר רשום, יציאה מהבית או ביקור פיזי בשגרירות!",
      "1_body_india": "מלא את <a href='#form'> הטופס המאו </a> בטח שלנו תוך מספר דקות בלבד - אין צורך בדואר מסמכים או יציאה מהבית.",
      "1_body_indonesia": "ה <a href='#form'> שלם את היישום </a> המאובטח שלנו בכמה שלבים פשוטים. אין ניירת, אין תורים, ואין יציאה מהבית.",
      "1_body_israel": "מלא את ה <a href='#form'> טופס המאובטח שלנו </a> תוך דקות ספורות - אין צורך להגיש מסמכים פיזיים או לבקר במשרד.",
      "1_body_korea": "מלא את ה <a href='#form'> טופס המאובטח שלנו </a> תוך דקות ספורות - אין צורך להגיש מסמכים פיזיים או לבקר במשרד.",
      "1_body_morocco": "ה <a href='#form'> שלם את היישום </a> המאובטח שלנו בכמה שלבים פשוטים. אין ניירת, אין תורים, ואין יציאה מהבית.",
      "1_body_new_zealand": "מלא את ה <a href='#form'> טופס המאובטח שלנו </a> תוך דקות ספורות - אין צורך להגיש מסמכים פיזיים או לבקר במשרד.",
      "1_body_saudi_arabia": "מלא את <a href='#form'> הטופס המאו </a> בטח שלנו תוך מספר דקות בלבד - אין צורך בדואר מסמכים או יציאה מהבית.",
      "1_body_sri_lanka": "מלא את <a href='#form'> הטופס המאו </a> בטח שלנו תוך מספר דקות בלבד - אין צורך בדואר מסמכים או יציאה מהבית.",
      "1_body_status": "הצוות שלנו זמין 24/7 כדי לענות על שאלותיך.",
      "1_body_thailand": "מלא את ה <a href='#form'> טופס המאובטח שלנו </a> תוך דקות ספורות - אין צורך להגיש מסמכים פיזיים או לבקר במשרד.",
      "1_body_togo": "ה <a href='#form'> שלם את היישום </a> המאובטח שלנו בכמה שלבים פשוטים. אין ניירת, אין תורים, ואין יציאה מהבית.",
      "1_body_uk": "מלא את ה <a href='#form'> טופס המאובטח שלנו </a> תוך דקות ספורות - אין צורך להגיש מסמכים פיזיים או לבקר במשרד.",
      "1_body_usa": "מלא את ה <a href='#form'> טופס המאובטח שלנו </a> תוך דקות ספורות - אין צורך להגיש מסמכים פיזיים או לבקר במשרד.",
      "1_body_vietnam": "מלא את <a href='#form'> הטופס המאו </a> בטח שלנו תוך מספר דקות בלבד - אין צורך בדואר מסמכים או יציאה מהבית.",
      "1_title_bahrain": "מלא את הטופס המקוון",
      "1_title_cambodia": "מלא את הטופס המקוון",
      "1_title_canada": "מלא את הטופס המקוון",
      "1_title_home": "ממלאים טופס מאובטח אונליין",
      "1_title_india": "מלא את הטופס המקוון",
      "1_title_indonesia": "מלא את הטופס המקוון",
      "1_title_israel": "מלא את הטופס המקוון",
      "1_title_korea": "מלא את הטופס המקוון",
      "1_title_morocco": "מלא את הטופס המקוון",
      "1_title_new_zealand": "מלא את הטופס המקוון",
      "1_title_saudi_arabia": "מלא את הטופס המקוון",
      "1_title_sri_lanka": "מלא את הטופס המקוון",
      "1_title_status": "תמיכה כאשר אתה צריך את זה",
      "1_title_thailand": "מלא את הטופס המקוון",
      "1_title_togo": "מלא את הטופס המקוון",
      "1_title_uk": "מלא את הטופס המקוון",
      "1_title_usa": "מלא את הטופס המקוון",
      "1_title_vietnam": "מלא את הטופס המקוון",
      "2_body_bahrain": "אנו מגישים את בקשתך בצורה מאובטחת לרשויות בחריין. רוב ה- eVisa מאושרים תוך 3-5 ימים ונמסרים ישירות לתיבת הדואר הנכנס שלך.",
      "2_body_cambodia": "אנו מגישים את בקשתך בצורה מאובטחת לרשויות בקמבודיה. רוב ה- eVisa מאושרים תוך 3 ימים ונמסרים ישירות לתיבת הדואר הנכנס שלך.",
      "2_body_canada": "אנו שולחים את בקשתך בצורה מאובטחת לרשויות הקנדיות. רוב ה- ETA מאושרים תוך 1-3 ימים (או מהר יותר לבקשות דחופות).",
      "2_body_home": "אחרי הגשת טופס הויזה, אנו מיד מעבדים את בקשתכם ושולחים בקשה רשמית לרשות ההגירה הרלוונטית עבור הנפקת ויזה בשמכם — אישור אלקטרוני מתקבל תוך 1-3 ימים ונשלח ישירות למייל שלכם.",
      "2_body_india": "אנו מגישים את בקשתך לרשויות ההגירה של הודו. רוב ה- eVisa מאושרים תוך 1-3 ימים (או מהר יותר לבקשות דחופות).",
      "2_body_indonesia": "אנו שולחים את פרטיך לרשויות אינדונזיה. רוב ה- eVisa מאושרים תוך 5 ימים ונמסרים ישירות לתיבת הדואר הנכנס שלך.",
      "2_body_israel": "אנו מגישים את בקשתך בצורה מאובטחת לרשויות הישראליות. רוב ה- ETA מאושרים תוך 1-3 ימים (או מהר יותר לבקשות דחופות).",
      "2_body_korea": "אנו מטפלים בהגשה לרשויות דרום קוריאה. רוב ה- K-ETA מאושרים תוך 1-3 ימים (או מהר יותר לבקשות דחופות).",
      "2_body_morocco": "אנו מטפלים בהגשה לרשויות מרוקאיות. רוב ה- eVisa מאושרים תוך 1-3 ימים (או מהר יותר לבקשות דחופות).",
      "2_body_new_zealand": "אנו מטפלים בהגשה לרשויות ניו זילנד. רוב ה- NZETA מאושרים תוך 1-3 ימים (או מהר יותר לבקשות דחופות).",
      "2_body_saudi_arabia": "אנו מגישים את בקשתך לרשויות ההגירה של ערב הסעודית. רוב ה- eVisa מאושרים תוך 1-3 ימים (או מהר יותר לבקשות דחופות).",
      "2_body_sri_lanka": "לאחר הגשתנו, אנו מעבדים מייד את בקשתך ושולחים בקשה רשמית למשרד ההגירה של סרי לנקה בשמך. הויזה שלך תאושר ויישלח אליך בדוא\"ל תוך 1-3 ימים.",
      "2_body_status": "בדוק בקלות את הסטטוס שלך בכל עת עם שני פרטים בלבד.",
      "2_body_thailand": "אנו מטפלים בהגשה לרשויות התאילנדיות. רוב ה- eVisa מאושרים תוך 3-21 ימים (או מהר יותר לבקשות דחופות).",
      "2_body_togo": "אנו שולחים את בקשתך בצורה מאובטחת לרשויות טוגו. רוב ה- eVisa מאושרים תוך 3 ימים ונמסרים ישירות לתיבת הדואר הנכנס שלך.",
      "2_body_uk": "אנו מטפלים בהגשה לרשויות בריטניה. רוב ה- ETA בבריטניה מאושרים תוך 1-3 ימים (או מהר יותר לבקשות דחופות).",
      "2_body_usa": "אנו מטפלים בהגשה לרשויות האמריקאיות. רוב ה- ESTA מאושרים תוך 1-3 ימים (או מהר יותר לבקשות דחופות).",
      "2_body_vietnam": "אנו מגישים את בקשתך לרשויות ההגירה של וייטנאם. רוב ה- eVisa מאושרים תוך 1-7 ימים (או מהר יותר לבקשות דחופות).",
      "2_title_bahrain": "קבל את האישור שלך",
      "2_title_cambodia": "קבל את האישור שלך",
      "2_title_canada": "קבל את האישור שלך",
      "2_title_home": "ממתינים לאישור הויזה",
      "2_title_india": "קבל את האישור שלך",
      "2_title_indonesia": "קבל את האישור שלך",
      "2_title_israel": "קבל את האישור שלך",
      "2_title_korea": "קבל את האישור שלך",
      "2_title_morocco": "קבל את האישור שלך",
      "2_title_new_zealand": "קבל את האישור שלך",
      "2_title_saudi_arabia": "קבל את האישור שלך",
      "2_title_sri_lanka": "קבל את האישור שלך",
      "2_title_status": "חווית משתמש חלקה",
      "2_title_thailand": "קבל את האישור שלך",
      "2_title_togo": "קבל את האישור שלך",
      "2_title_uk": "קבל את האישור שלך",
      "2_title_usa": "קבל את האישור שלך",
      "2_title_vietnam": "קבל את האישור שלך",
      "3_body_bahrain": "הדפס את ה- eVisa המאושרת שלך והציג אותה עם ההגעה. הכניסה שלך חלקה, ואתה מוכן ליהנות מהטיול שלך לבחריין.",
      "3_body_cambodia": "הדפס את ה- eVisa המאושרת שלך והציג אותה עם ההגעה. הכניסה שלך חלקה, ואתה מוכן ליהנות מהטיול שלך לקמבודיה.",
      "3_body_canada": "ה- eTA שלך מקושר אלקטרונית לדרכון שלך - אין צורך להדפיס דבר. פשוט הציגו את הדרכון שלכם עם ההגעה ותיהנו מחוויית כניסה חלקה.",
      "3_body_home": "ברכותינו, ויזה אלקטרונית רשמית עם חתימה ממשלתית תחכה לכם בדוא״ל בסוף ההמתנה — כעת לכם נשאר רק להדפיס את אשרת הנסיעה, לארוז את המזוודה... ולנו לאחל לכם טיסה נעימה!",
      "3_body_india": "הדפס את ה- eVisa המאושרת שלך והציג אותה עם ההגעה. הכניסה שלך חלקה, ואתה מוכן ליהנות מהטיול שלך להודו.",
      "3_body_indonesia": "הדפס את ה- eVisa המאושרת שלך והציג אותה עם ההגעה. הכניסה שלך חלקה, ואתה מוכן ליהנות מהטיול שלך לאינדונזיה.",
      "3_body_israel": "ה- ETA-IL שלך מקושר אלקטרונית לדרכון שלך - אין צורך להדפיס שום דבר. פשוט הציגו את הדרכון שלכם עם ההגעה ותיהנו מחוויית כניסה חלקה.",
      "3_body_korea": "ה- K-ETA שלך מקושר אלקטרונית לדרכון שלך - אין צורך להדפיס שום דבר. פשוט הציגו את הדרכון שלכם עם ההגעה ותיהנו מחוויית כניסה חלקה.",
      "3_body_morocco": "הדפס את ה- eVisa המאושרת שלך והציג אותה עם ההגעה. הכניסה שלך חלקה, ואתה מוכן ליהנות מהטיול שלך במרוקו.",
      "3_body_new_zealand": "ה- NZeTA שלך מקושר אלקטרונית לדרכון שלך - אין צורך להדפיס שום דבר. פשוט הציגו את הדרכון שלכם עם ההגעה ותיהנו מחוויית כניסה חלקה.",
      "3_body_saudi_arabia": "הדפס את ה- eVisa המאושרת שלך והציג אותה עם ההגעה. הכניסה שלך חלקה, ואתה מוכן ליהנות מהטיול שלך.",
      "3_body_sri_lanka": "הדפס את ה- eVisa המאושרת שלך וקח אותה איתך למסע שלך. בבקרת דרכונים תקבל חותמת רשמית בתמורה ל- eVisa שלך, המאפשרת לך להיכנס לסרי לנקה ללא טרחה. זהו זה — תהנו מהטיול שלכם!",
      "3_body_status": "קבל את ה- eVisa שלך בדוא\"ל. הדפיסו אותו, הביאו אותו ועברו את בקרת הדרכונים.",
      "3_body_thailand": "הדפס את ה- eVisa המאושרת שלך והציג אותה עם ההגעה. הכניסה שלך חלקה, ואתה מוכן ליהנות מהטיול שלך לתאילנד.",
      "3_body_togo": "הדפס את ה- eVisa המאושרת שלך והציג אותה עם ההגעה. הכניסה שלך חלקה, ואתה מוכן ליהנות מהטיול שלך לטוגו.",
      "3_body_uk": "ה- eTA שלך מקושר אלקטרונית לדרכון שלך - אין צורך להדפיס דבר. פשוט הציגו את הדרכון שלכם עם ההגעה ותיהנו מחוויית כניסה חלקה.",
      "3_body_usa": "ה- ESTA שלך מקושר אלקטרונית לדרכון שלך - אין צורך להדפיס שום דבר. פשוט הציגו את הדרכון שלכם עם ההגעה ותיהנו מחוויית כניסה חלקה.",
      "3_body_vietnam": "הדפס את ה- eVisa המאושרת שלך והציג אותה עם ההגעה. הכניסה שלך חלקה, ואתה מוכן ליהנות מהטיול שלך בווייטנאם.",
      "3_title_bahrain": "נסיעות לבחריין",
      "3_title_cambodia": "נסיעות לקמבודיה",
      "3_title_canada": "נסיעות לקנדה",
      "3_title_home": "✈️ מדפיסים וטסים",
      "3_title_india": "נסיעות להודו",
      "3_title_indonesia": "נסיעות לאינדונזיה",
      "3_title_israel": "נסיעות לישראל",
      "3_title_korea": "נסיעות לדרום קוריאה",
      "3_title_morocco": "נסיעות למרוקו",
      "3_title_new_zealand": "נסיעות לניו זילנד",
      "3_title_saudi_arabia": "נסיעות לסעודיה",
      "3_title_sri_lanka": "נסיעות לסרי לנקה",
      "3_title_status": "שקיפות שאפשר לסמוך עליה",
      "3_title_thailand": "נסיעות לתאילנד",
      "3_title_togo": "נסיעות לטוגו",
      "3_title_uk": "נסיעות לבריטניה",
      "3_title_usa": "נסיעות לארצות הברית",
      "3_title_vietnam": "נסיעות לווייטנאם",
      cta_country_page: "הפעל יישום eVisa",
      cta_home: "גלו יעדים",
      img_alt: "מחשב נייד פתוח עם כוס קפה על השולחן"
    },
    testimonials: {
      megaphone_img: "איור מגפון",
      read_original: "קרא את הביקורת המקורית",
      title: "מה הלקוחות שלנו אומרים"
    },
    trust: {
      "1_alt": "סמל הגנת נעילה",
      "1_body": "תהליך קל, מהיר ומאובטח. מלאו טופס קצר, ומכאן זה כבר בידיים שלנו: נשלח את הויזה האלקטרונית ישירות לתיבת הדוא\"ל שלכם.",
      "1_body_bahrain": "אנו מגנים על הפרטים האישיים שלך באמצעות הצפנה ברמה הגבוהה ביותר וסטנדרטים בינלאומיים. הנתונים שלך מטופלים בצורה מאובטחת כמו במערכות בנקאיות או ממשלתיות גלובליות.",
      "1_body_cambodia": "אנו מגנים על הפרטים האישיים שלך באמצעות הצפנה ברמה הגבוהה ביותר וסטנדרטים בינלאומיים. הנתונים שלך מטופלים בצורה מאובטחת כמו במערכות בנקאיות או ממשלתיות גלובליות.",
      "1_body_canada": "המידע שלך מוצפן באמצעות SSL ברמה הגבוהה ביותר ועומד בתאימות גלובלית - בדיוק כמו פלטפורמות פיננסיות וממשלתיות גדולות.",
      "1_body_home": "המידע שלך מוצפן באמצעות SSL ברמה הגבוהה ביותר ועומד בתאימות גלובלית - בדיוק כמו פלטפורמות פיננסיות וממשלתיות גדולות.",
      "1_body_india": "אנו מגנים על כל פרט באמצעות הצפנת SSL ותקני אבטחה גלובליים - בדיוק כמו בנקים ואתרים ממשלתיים מובילים.",
      "1_body_indonesia": "אנו מגנים על הפרטים האישיים שלך באמצעות הצפנה ברמה הגבוהה ביותר וסטנדרטים בינלאומיים. הנתונים שלך מטופלים בצורה מאובטחת כמו במערכות בנקאיות או ממשלתיות גלובליות.",
      "1_body_israel": "המידע שלך מוצפן באמצעות SSL ברמה הגבוהה ביותר ועומד בתאימות גלובלית - בדיוק כמו פלטפורמות פיננסיות וממשלתיות גדולות.",
      "1_body_korea": "המידע שלך מוצפן באמצעות SSL ברמה הגבוהה ביותר ועומד בתאימות גלובלית - בדיוק כמו פלטפורמות פיננסיות וממשלתיות גדולות.",
      "1_body_morocco": "אנו מגנים על הפרטים האישיים שלך באמצעות הצפנה ברמה הגבוהה ביותר וסטנדרטים בינלאומיים. הנתונים שלך מטופלים בצורה מאובטחת כמו במערכות בנקאיות או ממשלתיות גלובליות.",
      "1_body_new_zealand": "אנו מגנים על כל פרט באמצעות הצפנת SSL ותקני אבטחה גלובליים - בדיוק כמו בנקים ואתרים ממשלתיים מובילים.",
      "1_body_saudi_arabia": "אנו מגנים על כל פרט באמצעות הצפנת SSL ותקני אבטחה גלובליים - בדיוק כמו בנקים ואתרים ממשלתיים מובילים.",
      "1_body_sri_lanka": "אנו מגנים על כל פרט באמצעות הצפנת SSL ותקני אבטחה גלובליים - בדיוק כמו בנקים ואתרים ממשלתיים מובילים.",
      "1_body_thailand": "אנו מגנים על כל פרט באמצעות הצפנת SSL ותקני אבטחה גלובליים - בדיוק כמו בנקים ואתרים ממשלתיים מובילים.",
      "1_body_togo": "אנו מגנים על הפרטים האישיים שלך באמצעות הצפנה ברמה הגבוהה ביותר וסטנדרטים בינלאומיים. הנתונים שלך מטופלים בצורה מאובטחת כמו במערכות בנקאיות או ממשלתיות גלובליות.",
      "1_body_uk": "המידע שלך מוצפן באמצעות SSL ברמה הגבוהה ביותר ועומד בתאימות גלובלית - בדיוק כמו פלטפורמות פיננסיות וממשלתיות גדולות.",
      "1_body_usa": "אנו מגנים על כל פרט באמצעות הצפנת SSL ותקני אבטחה גלובליים - בדיוק כמו בנקים ואתרים ממשלתיים מובילים.",
      "1_body_vietnam": "אנו מגנים על כל פרט באמצעות הצפנת SSL ותקני אבטחה גלובליים - בדיוק כמו בנקים ואתרים ממשלתיים מובילים.",
      "1_title": "תהליך מאובטח ומהיר",
      "2_alt": "שלט כסף בתוך סמל מגן",
      "2_body": "הגישו בקשה בביטחון מוחלט הודות להתחייבות החזר כספי שלנו. אנו נטפל בכל פרט, ואם בקשתכם תידחה, אנו נגיש בקשה חוזרת ללא עלות, או שנחזיר לכם את כספכם במלואו - בלי בעיות ובלי שאלות נוספות.",
      "2_body_bahrain": "אם הויזה האלקטרונית שלך נדחית, אנו נגיש בקשה חוזרת בחינם או נחזיר את כל התשלום שלך - ללא שאלות.",
      "2_body_cambodia": "אם הויזה האלקטרונית שלך נדחית, אנו נגיש בקשה חוזרת בחינם או נחזיר את כל התשלום שלך - ללא שאלות.",
      "2_body_canada": "אם ה- ETA שלך נדחה, אנו נגיש בקשה חוזרת בחינם או נחזיר את כל התשלום שלך - ללא שאלות.",
      "2_body_home": "אם הבקשה שלך נדחתה, אנו נגיש בקשה חוזרת ללא עלות או נחזיר לך את מלוא ההחזר - במהירות וללא טרחה.",
      "2_body_india": "אם הויזה האלקטרונית שלך נדחית, אנו נגיש בקשה חוזרת בחינם או נחזיר את כל התשלום שלך - ללא שאלות.",
      "2_body_indonesia": "אם הויזה האלקטרונית שלך נדחית, אנו נגיש בקשה חוזרת בחינם או נחזיר את כל התשלום שלך - ללא שאלות.",
      "2_body_israel": "אם ה- ETA-IL שלך נדחה, אנו נגיש בקשה חוזרת בחינם או נחזיר את כל התשלום שלך - ללא שאלות.",
      "2_body_korea": "אם ה- K-ETA שלך נדחה, אנו נגיש בקשה חוזרת בחינם או נחזיר את כל התשלום שלך - ללא שאלות.",
      "2_body_morocco": "אם הויזה האלקטרונית שלך נדחית, אנו נגיש בקשה חוזרת בחינם או נחזיר את כל התשלום שלך - ללא שאלות.",
      "2_body_new_zealand": "אם ה- NZeTA שלך נדחה, אנו נגיש בקשה חוזרת בחינם או נחזיר את כל התשלום שלך - ללא שאלות.",
      "2_body_saudi_arabia": "אם הויזה האלקטרונית שלך נדחית, אנו נגיש בקשה חוזרת בחינם או נחזיר את כל התשלום שלך - ללא שאלות.",
      "2_body_sri_lanka": "אם הויזה האלקטרונית שלך נדחית, אנו נגיש בקשה חוזרת בחינם או נחזיר את כל התשלום שלך - ללא שאלות.",
      "2_body_thailand": "אם הויזה האלקטרונית שלך נדחית, אנו נגיש בקשה חוזרת בחינם או נחזיר את כל התשלום שלך - ללא שאלות.",
      "2_body_togo": "אם הויזה האלקטרונית שלך נדחית, אנו נגיש בקשה חוזרת בחינם או נחזיר את כל התשלום שלך - ללא שאלות.",
      "2_body_uk": "אם ה- ETA שלך בבריטניה נדחה, אנו נגיש בקשה חוזרת בחינם או נחזיר את כל התשלום שלך - ללא שאלות.",
      "2_body_usa": "אם ה- ESTA שלך בארה\"ב נדחה, אנו נגיש בקשה חוזרת בחינם או נחזיר את כל התשלום שלך - ללא שאלות.",
      "2_body_vietnam": "אם הויזה האלקטרונית שלך נדחית, אנו נגיש בקשה חוזרת בחינם או נחזיר את כל התשלום שלך - ללא שאלות.",
      "2_title": "100% אחריות",
      "3_alt": "סמל כרטיס אשראי",
      "3_body": "מאז 2019 הדרכנו עשרות אלפי מטיילים ברחבי העולם, והמומחים שלנו זמינים מסביב לשעון דרך <a href=\"{whatsapp}\" target=\"_blank\">וואטסאפ</a>, <a data-chat-opener>צ'אט</a>, <a href=\"mailto:{email}\" target=\"_blank\">אימייל</a> או <a href=\"tel:{phone}\">טלפון</a> — לעדכונים עקבו אחרינו ב<a href=\"{instagram}\" target=\"_blank\">אינסטגרם</a> וב<a href=\"{facebook}\" target=\"_blank\">פייסבוק</a>.",
      "3_body_bahrain": "המומחים שלנו נמצאים בהישג יד מסביב לשעון. זקוקים לעזרה או יש לכם שאלות? אנחנו כאן כדי להדריך אותך בכל צעד של הדרך.",
      "3_body_cambodia": "המומחים שלנו נמצאים בהישג יד מסביב לשעון. זקוקים לעזרה או יש לכם שאלות? אנחנו כאן כדי להדריך אותך בכל צעד של הדרך.",
      "3_body_canada": "המומחים המסורים שלנו זמינים מסביב לשעון. זקוקים לעזרה או יש לכם שאלות? אנחנו תמיד כאן כדי להדריך אותך.",
      "3_body_home": "המומחים שלנו נמצאים בהישג יד מסביב לשעון. זקוקים לעזרה או יש לכם שאלות? אנחנו כאן כדי להדריך אותך בכל צעד של הדרך.",
      "3_body_india": "הצוות המסור שלנו זמין תמיד. מבקשות דחופות ועד שאלות מהירות, אנו מטפלים בך יום ולילה.",
      "3_body_indonesia": "הצוות המסור שלנו זמין תמיד. מבקשות דחופות ועד שאלות מהירות, אנו מטפלים בך יום ולילה.",
      "3_body_israel": "המומחים המסורים שלנו זמינים מסביב לשעון. זקוקים לעזרה או יש לכם שאלות? אנחנו תמיד כאן כדי להדריך אותך.",
      "3_body_korea": "הצוות המסור שלנו זמין תמיד. מבקשות דחופות ועד שאלות מהירות, אנו מטפלים בך יום ולילה.",
      "3_body_morocco": "המומחים שלנו נמצאים בהישג יד מסביב לשעון. זקוקים לעזרה או יש לכם שאלות? אנחנו כאן כדי להדריך אותך בכל צעד של הדרך.",
      "3_body_new_zealand": "המומחים המסורים שלנו זמינים מסביב לשעון. זקוקים לעזרה או יש לכם שאלות? אנחנו תמיד כאן כדי להדריך אותך.",
      "3_body_saudi_arabia": "הצוות המסור שלנו זמין תמיד. מבקשות דחופות ועד שאלות מהירות, אנו מטפלים בך יום ולילה.",
      "3_body_sri_lanka": "המומחים שלנו נמצאים בהישג יד מסביב לשעון. זקוקים לעזרה או יש לכם שאלות? אנחנו כאן כדי להדריך אותך בכל צעד של הדרך.",
      "3_body_thailand": "הצוות המסור שלנו זמין תמיד. מבקשות דחופות ועד שאלות מהירות, אנו מטפלים בך יום ולילה.",
      "3_body_togo": "המומחים שלנו נמצאים בהישג יד מסביב לשעון. זקוקים לעזרה או יש לכם שאלות? אנחנו כאן כדי להדריך אותך בכל צעד של הדרך.",
      "3_body_uk": "המומחים המסורים שלנו זמינים מסביב לשעון. זקוקים לעזרה או יש לכם שאלות? אנחנו תמיד כאן כדי להדריך אותך.",
      "3_body_usa": "המומחים המסורים שלנו זמינים מסביב לשעון. זקוקים לעזרה או יש לכם שאלות? אנחנו תמיד כאן כדי להדריך אותך.",
      "3_body_vietnam": "הצוות המסור שלנו זמין תמיד. מבקשות דחופות ועד שאלות מהירות, אנו מטפלים בך יום ולילה.",
      "3_title": "תמיכה מקצועית 24/7",
      "3_title_home": "תשלומים מאובטחים עם תאימות PCI DSS",
      title: "למה לסמוך עלינו"
    },
    visa_starting_price_bahrain: "ויזה אלקטרונית בחריין מ- {price}",
    visa_starting_price_cambodia: "קמבודיה eVisa מ- {price}",
    visa_starting_price_canada: "קנדה eTA מ- {price}",
    visa_starting_price_india: "הודה eVisa מ- {price}",
    visa_starting_price_indonesia: "eVisa אינדונזיה מ- {price}",
    visa_starting_price_israel: "ישראל ETA-IL מ- {price}",
    visa_starting_price_korea: "דרום קוריאה K-ETA עבור {price}",
    visa_starting_price_morocco: "מרוקו eVisa מ- {price}",
    visa_starting_price_new_zealand: "ניו זילנד NZeTA מ {price}",
    visa_starting_price_saudi_arabia: "ערב הסעודית eVisa מ {price}",
    visa_starting_price_sri_lanka: "ויזה אלקטרונית לסרי לנקה החל מ {price}",
    visa_starting_price_thailand: "תאילנד eVisa מ- {price}",
    visa_starting_price_togo: "טוגו eVisa מ- {price}",
    visa_starting_price_uk: "ETA בבריטניה עבור {price}",
    visa_starting_price_usa: "ESTA של ארצות הברית מ {price}",
    visa_starting_price_vietnam: "ויזה אלקטרונית בווייטנאם מ {price}"
  },
  parental_info: "מידע על הורים",
  passport: "דרכון",
  passport_biometric_only: "הדרכון חייב להיות דרכון ביומטרי.",
  passport_details: "פרטי דרכון",
  passport_expiry: "תאריך תפוגה של דרכון",
  passport_half_year_valid: "הדרכון חייב להיות בתוקף לפחות 6 חודשים נוספים.",
  passport_issue_date: "תאריך הוצאת דרכון",
  passport_issue_place: "מקום ההנפקה של דרכון",
  passport_number: "מספר דרכון",
  passport_personal_details: "פרטי דרכון ומידע אישי",
  passport_valid_six_months_min: "חייב להיות בתוקף לפחות שישה חודשים נוספים",
  passport_year_valid_two_empty_pages: "הדרכון חייב להיות בתוקף לפחות 6 חודשים נוספים.",
  pay: "לשלם",
  payment: "תשלום",
  payment_methods: "אמצעי תשלום",
  payment_processor_error_alert: "שגיאה בשיטת תשלום זו. אתה יכול לבחור אמצעי תשלום אחר או לנסות שוב.",
  payment_processors: {
    bill_payment: "תשלום על ידי חשבון",
    bit: "ביט",
    credit_card: "כרטיס אשראי/חיוב",
    credit_card_ru: "כרטיס בנקים רוסיים",
    paybox: "פייבוקס",
    paypal: "פייפאל"
  },
  paypal: "פייפאל",
  personal_id_number: "מספר תעודת זהות לאומית",
  phone_number: "מספר טלפון",
  picture: "תמונה",
  pictures: "תמונות",
  popular: "פופולרי",
  previous: "חזרה",
  previous_visa_num: "מספר הויזה הקודם",
  priority: {
    checkbox_1_2_days: "בדוק ✓ כדי לקבל את שלך {docName} תוך 1-2 ימי עסקים.",
    checkbox_3_days: "בדוק ✓ כדי לקבל את שלך {docName} תוך 3 ימי עסקים.",
    checkbox_5_days: "בדוק ✓ כדי לקבל את שלך {docName} תוך 5 ימי עסקים.",
    checkbox_few_hours: "בדוק ✓ כדי לקבל את שלך {docName} בעוד כמה שעות.",
    checkbox_label: "עיבוד מהיר: {n} יום | עיבוד מהיר: {n} ימים",
    checkbox_next_day: "בדוק ✓ כדי להגיע {docName} ליום העסקים הבא.",
    fast_processing: "עיבוד מהיר",
    hint: "בדוק ✓ כדי לקבל את ה- eVisa שלך עד יום העסקים הבא. | בדוק ✓ כדי לקבל את ה- eVisa שלך בימי {n} עסקים.",
    hint_eta: "בדוק ✓ כדי להגיע ליום {docName} העסקים הבא. | בדוק ✓ כדי לקבל את ימי {docName} הע {n} סקים שלך.",
    hint_evisa: "בדוק ✓ כדי לקבל את ה- eVisa שלך עד יום העסקים הבא. | בדוק ✓ כדי לקבל את ה- eVisa שלך בימי {n} עסקים.",
    processing_time: "זמן עיבוד",
    select_1_2_days: "1-2 ימים {price}",
    select_3_days: "3 ימים {price}",
    select_5_days: "5 ימים {price}",
    select_few_hours: "כמה שעות {price}",
    select_next_day: "למחרת {price}",
    select_none: "רגיל, ללא עלות נוספת",
    wait_1_2_days: "1-2 ימים",
    wait_3_days: "3 ימים",
    wait_5_days: "5 ימים",
    wait_few_hours: "כמה שעות",
    wait_next_day: "למחרת"
  },
  privacy_autodelete: "אנו לוקחים את הפרטיות והאבטחה שלך ברצינות רבה. כל המידע באתר שלנו מאובטח בהצפנת SSL ועומד בתקן PCI הבינלאומי עבור{year}. עם קבלת הויזה האלקטרונית, התמונות שלך יימחקו משרתי האתר.",
  privacy_page: {
    meta_desc: "",
    title: "מדיניות פרטיות • ויזנט {currentYear}"
  },
  privacy_policy: "פרטיות",
  privacy_security_importance: "אנו נותנים עדיפות לאבטחת המידע והפרטיות שלך, ומבטיחים שהנתונים שלך יישארו מוגנים בכל עת.",
  product: {
    entries: {
      "double": "חדר זוגי (2)",
      multiple: "מרובה",
      single: "יחיד"
    },
    entries_full: {
      "double": "2 רשומות",
      multiple: "ערכים מרובים",
      single: "כניסה יחידה"
    },
    urgent: "דחוף",
    validity: {
      "15_days": "15 ימים",
      "2_months": "60 ימים",
      "2_weeks": "14 ימים",
      "2_years": "2 שנים",
      "3_months": "90 ימים",
      "3_years": "3 שנים",
      "5_years": "5 שנים",
      "6_months": "180 ימים",
      month: "30 ימים",
      year: "שנה אחת"
    }
  },
  product_variation: {
    alert_title: "תשומת לב!",
    label: {
      fee_60_plus: "דמי ביטוח (גיל 60+)",
      fee_by_nationality: "דמי לאום",
      stay_limit_by_nationality: "מגבלת שהייה",
      validity_6_months_by_nationality: "תוקף ויזה (לאום)"
    },
    note: {
      fee_60_plus: "למועמדים מעל גיל 60 יש דמי ביטוח רפואי גבוהים יותר: {fee}",
      fee_by_nationality: "הנפקת ויזה לאזרחות שבחרת ({ nationality }) דורשת תשלום גבוה יותר: {fee}",
      stay_limit_by_nationality: "הלאום שבחרת זכאי לשהות למשך {limit} ימים לכל היותר.",
      validity_6_months_by_nationality: "הלאום שבחרת זכאי לוויזה של 6 חודשים בלבד."
    }
  },
  products: {
    label: {
      bahrain_2_weeks: "ויזה אלקטרונית, 14 ימים",
      bahrain_3_months: "ויזה אלקטרונית, 3 חודשים",
      bahrain_year: "ויסה אלקטרונית, שנה אחת",
      cambodia_month: "ויזה אלקטרונית, 30 ימים",
      canada_5_years: "eTA, 5 שנים",
      india_business_year: "ויזה עסקית אלקטרונית, שנה",
      india_tourist_5_years: "eVisa לתיירים, 5 שנים",
      india_tourist_month: "ויזה אלקטרונית לתיירים, 30 יום",
      india_tourist_year: "eVisa לתיירים, שנה אחת",
      indonesia_2_months: "60 ימים, כניסה יחידה",
      indonesia_2_years: "שנתיים, מספר כניסות",
      indonesia_5_years: "5 שנים, מספר כניסות",
      indonesia_year: "שנה אחת, מספר כניסות",
      israel_2_years: "אתה-איל, שנתיים",
      korea_3_years: "K-ETA, 3 שנים",
      korea_3_years_30_stay: "K-ETA, 3 שנים",
      morocco_tourist_6_months: "ויזה אלקטרונית לתיירים, 180 ימים",
      new_zealand_2_years: "eTA, שנתיים",
      saudi_arabia_6_months: "eVisa לתיירים, 6 חודשים",
      saudi_arabia_year: "eVisa לתיירים, שנה אחת",
      sri_lanka_month: "ויזה אלקטרונית לתיירים, 30 יום",
      thailand_3_months: "ויזה אלקטרונית, 90 יום, כניסה יחידה",
      thailand_5_years: "DTV, 5 שנים, מספר כניסות",
      thailand_6_months: "ויזה אלקטרונית, 180 ימים, מספר כניסות",
      togo_15_days_multi: "15 ימים, מספר כניסות",
      togo_15_days_single: "15 ימים, כניסה יחידה",
      togo_3_months: "90 יום, מספר כניסות",
      togo_month: "30 יום, מספר כניסות",
      uk_2_years: "ETA בבריטניה, שנתיים",
      usa_2_years: "ESTA, שנתיים",
      vietnam_3_months_multi: "90 יום, מספר כניסות",
      vietnam_3_months_multi_business: "90 יום, עסקים, מספר כניסות",
      vietnam_3_months_single: "90 יום, כניסה יחידה",
      vietnam_3_months_single_business: "90 יום, עסקים, כניסה יחידה"
    },
    "long": {
      bahrain_2_weeks: "ויזה אלקטרונית בחריין, 14 ימים",
      bahrain_3_months: "ויזה אלקטרונית בחריין, 3 חודשים",
      bahrain_year: "ויזה אלקטרונית בחריין, שנה אחת",
      cambodia_month: "ויזה אלקטרונית בקמבודיה, 30 ימים",
      canada_5_years: "קנדה eTA, 5 שנים",
      india_business_year: "ויזה עסקית בהודו, שנה",
      india_tourist_5_years: "ויזה תיירותית בהודו, 5 שנים",
      india_tourist_month: "ויזה תיירותית בהודו, 30 יום",
      india_tourist_year: "ויזה תיירותית בהודו, שנה",
      indonesia_2_months: "ויזה תיירותית באינדונזיה, 60 יום, יחיד",
      indonesia_2_years: "eVisa לתיירים באינדונזיה, שנתיים, רב",
      indonesia_5_years: "eVisa לתיירים באינדונזיה, 5 שנים, רב",
      indonesia_year: "eVisa לתיירים באינדונזיה, שנה אחת, רב",
      israel_2_years: "ישראל ETA-IL, שנתיים",
      korea_3_years: "דרום קוריאה K-ETA, 3 שנים",
      korea_3_years_30_stay: "דרום קוריאה K-ETA, 3 שנים",
      morocco_tourist_6_months: "ויזה תיירותית במרוקו, 180 יום",
      new_zealand_2_years: "ניו זילנד NZeTA, שנתיים",
      saudi_arabia_6_months: "ערב הסעודית eVisa, 6 חודשים",
      saudi_arabia_year: "ויזה אלקטרונית של ערב הסעודית, שנה אחת",
      sri_lanka_month: "ויזה תיירותית לסרי לנקה, 30 יום",
      thailand_3_months: "ויזה אלקטרונית בתאילנד, 90 יום, רווק",
      thailand_5_years: "תאילנד DTV, 5 שנים, רב",
      thailand_6_months: "תאילנד eVisa, 180 ימים, רב",
      togo_15_days_multi: "טוגו eVisa, 15 ימים, רב",
      togo_15_days_single: "טוגו ויזה אלקטרונית, 15 ימים, רווק",
      togo_3_months: "טוגו eVisa, 90 ימים, רב",
      togo_month: "טוגו eVisa, 30 ימים, רב",
      uk_2_years: "ETA בבריטניה, שנתיים",
      usa_2_years: "ESTA בארה\"ב, שנתיים",
      vietnam_3_months_multi: "ויזה אלקטרונית בווייטנאם, 90 ימים, רב",
      vietnam_3_months_multi_business: "ויזה אלקטרונית עסקית בווייטנאם, 90 יום, רב",
      vietnam_3_months_single: "ויזה אלקטרונית בווייטנאם, 90 יום, יחיד",
      vietnam_3_months_single_business: "ויזה אלקטרונית עסקית בווייטנאם, 90 יום, יחיד"
    }
  },
  professional: "מקצועי",
  quantity: "כמות",
  quantity_select: {
    hint_all: "ויזה אחת לכל נוסע, כולל ילדים (גילאי 0-18).",
    hint_range: "אחד לאדם ({min}עד {max} גיל שנה)",
    label: "מספר אשרות"
  },
  redirect_payment_on_click: "לאחר שתלחץ על כפתור 'שלם', תועבר לדף תשלום מאובטח כדי להשלים את התשלום שלך.",
  religion: "דת",
  religion_other: "אחר/אין",
  remove: "הסר",
  resume_form_with_link: "אתה יכול להשתמש בקישור הבא מכל מחשב או טלפון, ולהמשיך למלא את הנקודה שבה הפסקת.",
  resume_saved_form: "המשך הטופס השמור שלך",
  retired: "בגמלאות",
  retry: "נסה שוב",
  review_links: "גלה מה הלקוחות אומרים עלינו ב",
  rules: {
    email_invalid: "כתובת דוא\"ל לא חוקית",
    file_not_supported: "סוג קובץ לא נתמך",
    file_size: "הקובץ חייב להיות קטן ממג {max} ה-בייט",
    latin: "אותיות לטיניות, מקפים וסוגריים בלבד",
    length: "בדיוק {length} דמויות",
    numbers: "מספרים בלבד",
    one_min: "יש לבחור לפחות אפשרות אחת",
    required: "שדה חובה",
    six_months_min: "חייב להיות מעל 6 חודשים",
    too_early: "התאריך מוקדם מדי",
    too_late: "התאריך מאוחר מדי"
  },
  saarc_countries_are: "מדינות SAARC הן",
  safety_box: {
    official_visa: "ויזה רשמית",
    refund: "החזר מלא במקרה של דחייה",
    secure_payment: "תשלום מאובטח",
    ssl: "הצפנת SSL",
    support: "תמיכה 24/7"
  },
  saudi_arabia: "ערב הסעודית",
  saudi_arabia_evisa: "ערב הסעודית eVisa",
  saudi_arabia_page: {
    faq: [
      {
        a: "eVisa היא ויזה אלקטרונית שהונפקה באופן מקוון על ידי ממשלת ערב הסעודית, המאפשרת למטיילים להיכנס למדינה למטרות תיירות או עסקיות.",
        q: "מהי ויזה אלקטרונית?"
      },
      {
        a: "אזרחים ממדינות זכאות יכולים להגיש בקשה לביזה אלקטרונית סעודית, זה כולל: אזרחים אמריקאים, קנדים, אנגלים ואוסטרלים. הרשימה המלאה של המדינות/אזרחים הזכאים זמינה <a data-eligibility-list-opener> כאן. </a>",
        q: "מי זכאי לקבלת ויזה אלקטרונית של ערב הסעודית?"
      },
      {
        a: "ניתן להגיש בקשה לביזה אלקטרונית סעודית דרך אתר Visanet על ידי מילוי טופס הבקשה, העלאת המסמכים הנדרשים (דרכון, תמונה) ותשלום האגרה הרלוונטית.",
        q: "כיצד אוכל להגיש בקשה לביזה אלקטרונית של ערב הסעודית?"
      },
      {
        a: "תזדקק לדרכון תקף בתוקף של שישה חודשים לפחות, תמונה עדכנית בגודל דרכון (כל פורמט יעבוד, נערוך את התמונה בהתאם לדרישות) וכרטיס אשראי/חיוב לתשלום.",
        q: "אילו מסמכים נדרשים לבקשת eVisa?"
      },
      {
        a: "זמן העיבוד של eVisa סעודית הוא בין 1 ל -3 ימים.",
        q: "כמה זמן לוקח לעבד את ה- eVisa?"
      },
      {
        a: "ה- eVisa הסעודית תקף לשנה מיום ההנפקה ומאפשר כניסות מרובות. כל שהייה יכולה להימשך עד 90 יום בתוך תקופה של 180 יום.",
        q: "מהי תקופת התוקף של ה- eVisa?"
      },
      {
        a: "לא, לא ניתן להאריך את ה- eVisa. עליך לעזוב את המדינה לפני שתוקף הוויזה שלך יפוג.",
        q: "האם אוכל להאריך את שהותי בערב הסעודית באמצעות eVisa?"
      },
      {
        a: "האגרה כוללת ביטוח רפואי במהלך שהותכם בערב הסעודית.",
        q: "מהן העמלות עבור ויזה אלקטרונית של ערב הסעודית?"
      },
      {
        a: "כן, מטיילים צריכים להיות מודעים למנהגים ולתקנות של ערב הסעודית, כולל הגבלות על פריטים מסוימים, התנהגות וקוד לבוש. מומלץ לעיין בכללים אלה לפני הנסיעה.",
        q: "האם יש מגבלות נסיעה שאני צריך להיות מודע להן?"
      },
      {
        a: "כן, מחזיקי eVisa לתיירים סעודיים יכולים לבצע אומרה. עם זאת, היא אינה מתירה ביצוע חאג'.",
        q: "האם אוכל לבצע אומרה עם eVisa לתיירים?"
      },
      {
        a: "כן, ביטוח נסיעות נדרש וכבר כלול במחיר שלנו. הביטוח מספק כיסוי למקרי חירום רפואיים במהלך שהותך בערב הסעודית.",
        q: "האם ביטוח נסיעות נדרש עבור eVisa?"
      },
      {
        a: "<p>כן, בעלי eVisa יכולים להיכנס לסעודיה דרך שדות תעופה ומעברי גבול ייעודיים. רשימת נקודות הכניסה היא כדלקמן: נמל התעופה הבינלאומי המלך חאלד, נמל התעופה <ul> <li> הבינלאומי ריאד המלך עבדול-עזיז, נמל התעופה הבינלאומי ג'דה </li> <li> המלך פאהד, נמל התעופה הבינלאומי דמאם מוח </li> <li> מד בן עבדול-עזיז, מדינה </li> <li> </li> </ul> </p>",
        q: "האם יש נקודות כניסה ספציפיות למחזיקי eVisa?"
      },
      {
        a: "לא, ה- eVisa הסעודית מיועד אך ורק לתיירות או ביקורים עסקיים. אם ברצונך לעבוד בערב הסעודית, תצטרך להגיש בקשה לויזת עבודה.",
        q: "האם אוכל לעבוד בערב הסעודית עם ויזה אלקטרונית?"
      }
    ],
    meta_desc: "הגש בקשה לויזה לסעודיה באופן מקוון עם Visanet בשנת 2024. תהליך הגשת בקשה מהיר ומאובטח. קבל את אישור הנסיעה שלך במהירות ובקלות.",
    title: "ויזה אלקטרונית לערב הסעודית - יישום מקוון קל Visanet {currentYear} {'|'}"
  },
  save_form: "שמור טופס",
  seaport: "נמל ים",
  sector: "מגזר",
  sector_hint: "המגזר של העסק שלך, למשל 'טק' או 'מוסיקה'",
  select: "בחר",
  select_education: "בחר באפשרות המתארת בצורה הטובה ביותר את רמת ההשכלה שלך",
  select_from_my_addresses: "בחר מתוך הכתובות שלי",
  select_nationality: "לאום",
  select_occupation: "בחר עיסוק",
  select_payment_method: "בחר אמצעי תשלום:",
  select_seniority_years: "בחר שנים של ותק",
  select_visa_type_bahrain: "בחר את הסוג הרצוי של ויזה אלקטרונית לבחריין",
  select_visa_type_cambodia: "בחר את הסוג הרצוי של eVisa לקמבודיה",
  select_visa_type_canada: "בחר את סוג הוויזה הרצוי לקנדה",
  select_visa_type_india: "בחר את הסוג הרצוי של eVisa להודו",
  select_visa_type_indonesia: "בחר את הסוג הרצוי של eVisa לאינדונזיה",
  select_visa_type_israel: "בחר את סוג הוויזה הרצוי לישראל",
  select_visa_type_korea: "בחר את סוג הוויזה הרצוי לדרום קוריאה",
  select_visa_type_morocco: "בחר את הסוג הרצוי של eVisa למרוקו",
  select_visa_type_new_zealand: "בחר את סוג הויזה הרצוי לניו זילנד",
  select_visa_type_saudi_arabia: "בחר את הסוג הרצוי של eVisa לערב הסעודית",
  select_visa_type_sri_lanka: "בחר את הסוג הרצוי של eVisa לסרי לנקה",
  select_visa_type_thailand: "בחר את סוג הויזה הרצוי לתאילנד",
  select_visa_type_togo: "בחר את הסוג הרצוי של ויזה אלקטרונית לטוגו",
  select_visa_type_uk: "בחר את סוג הוויזה הרצוי לבריטניה",
  select_visa_type_usa: "בחר את סוג הוויזה הרצוי לארה\"ב",
  select_visa_type_vietnam: "בחר את הסוג הרצוי של eVisa לווייטנאם",
  self_employed: "עצמאי",
  send: "שלח",
  send_images_later: "מאוחר יותר",
  send_link: "שלח קישור",
  send_link_to_email: "ניתן לשלוח את הקישור ישירות לדוא\"ל שלך.",
  send_message: "שלח הודעה",
  sent: "נשלח בהצלחה!",
  sex: "מגדר",
  shutdown_sri_lanka: "החל מאוקטובר 2024, אין צורך להגיש בקשה לויזה אלקטרונית לסרי לנקה.",
  six_hours: "6 שעות",
  socials: {
    "2gis": "2גיס",
    easy: "פשוט",
    facebook: "פייסבוק",
    google: "גוגל",
    instagram: "אינסטגרם",
    irecommend: "אני ממליץ",
    otzovik: "אוצוביק",
    telegram: "מברק",
    trustpilot: "טרוסטפיילוט",
    vk: "VK",
    x: "X",
    yandex: "ינדקס"
  },
  spouse_country: "ארץ הלידה של בן הזוג",
  spouse_name: "שם בן הזוג",
  sri_lanka: "סרי לנקה",
  sri_lanka_evisa: "ויזה אלקטרונית של סרי לנקה",
  sri_lanka_page: {
    faq: [
      {
        a: "ויזה אלקטרונית היא אישור מהממשלה המאפשרת כניסה לסרי לנקה ותנועה בתוך המדינה למטרות תיירות. הוויזה האלקטרונית מהווה תחליף מקוון נוח למסמך נייר שהשגרירות מנפיקה לאחר שהגיעה פיזית למשרדיה.",
        q: "מהי ויזה אלקטרונית לסרי לנקה?"
      },
      {
        a: "קרוב לוודאי, כן. המדינות היחידות שאזרחיהן פטורים מהנפקת ויזה בעת הכניסה לסרי לנקה הן: <br> • סיישל <br> • סינגפור <br> • האיים המלדיביים <br> לכן אם אין לך אזרחות של אחת משלוש המדינות שהוזכרו, עליך לקבל ויזה אלקטרונית כדי להיכנס לסרי לנקה.",
        q: "האם אני צריך ויזה אלקטרונית כדי להיכנס לסרי לנקה?"
      },
      {
        a: "1-2 ימים לאחר הגשת הטופס המקוון באתרי האינטרנט שלנו, הוויזה האלקטרונית של סרי לנקה תישלח אליך כמסמך המצורף לכתובת הדוא\"ל שלך. מספר הוויזה יצורף גם להודעה, בעזרתו תקבל חותמת רשמית בדרכון שלך במהלך בדיקות דרכון עם הכניסה לסרי לנקה. <br>בנוסף לויזה, כאשר אתה נוחת בסרי לנקה, תתבקש גם להציג כרטיס טיסה חזרה מהארץ. <br>ייתכן שתתבקש להוכיח יכולת כלכלית ללינה בסרי לנקה במהלך שהותך. ישנן מספר דרכים לעשות זאת: <br> • תדפיס של יתרת החשבון השוטף בחשבון הבנק שלך. <br>• תדפיס של אישור המרת מטבע. <br>• תדפיס המוכיח כי בבעלותך כרטיס אשראי תקף. <br>• מזומן. <br>ברוב המכריע של המקרים, תיירים אינם מתבקשים להוכיח יכולת כלכלית. עם זאת, אנו ממליצים להביא הוכחה כלשהי, ליתר ביטחון.",
        q: "כיצד פועלת הנפקת ויזה אלקטרונית לסרי לנקה?"
      },
      {
        a: "כן. מקסימום פעמיים עם אותה ויזה במסגרת זמן תוקפו.",
        q: "האם אוכל לנסוע שוב לסרי לנקה עם אותה ויזה?"
      },
      {
        a: "כן. הוויזה האלקטרונית של סרי לנקה תקפה למשך 90 יום מרגע הוצאתה. אתה יכול להיכנס לסרי לנקה מתי שתרצה במהלך מסגרת זמן זו. <br>אנא שימו לב כי השהייה במדינה מוגבלת ל-60 יום, בהתאם לסוג הויזה האלקטרונית שתרכשו.",
        q: "האם ניתן להיכנס לסרי לנקה בזמן שונה מזה שצוין בויזה?"
      },
      {
        a: "כן. ילדים זקוקים לויזה אלקטרונית כדי להיכנס לסרי לנקה.",
        q: "האם ילדים זקוקים לויזה כדי להיכנס לסרי לנקה?"
      },
      {
        a: "לא, זה לא נדרש. ניתן להנפיק ויזה אלקטרונית גם אם טרם קנית כרטיס טיסה. <br><b>שימו לב כי עם הנחיתה בסרי לנקה תתבקשו להציג כרטיס טיסה מחוץ למדינה</b>.",
        q: "האם אני צריך לקנות כרטיס טיסה לפני הגשת טופס הויזה?"
      },
      {
        a: "כן. כדי להאריך את תוקפו של אשרת כניסה ושהייה, עליך לפנות למשרדי רשות ההגירה הממוקמים בקולומבו, סרי לנקה.",
        q: "האם ניתן להאריך את הויזה בזמן השהייה בסרי לנקה?"
      },
      {
        a: "למרבה הצער, אין אפשרות כזו. כדי לבצע שינויים, עליך להנפיק ויזה אלקטרונית חדשה. לכן, אנא שימו לב בעת מילוי הטופס שכל הפרטים שתזנו תואמים את הפרטים המצוינים בדרכון.",
        q: "האם ניתן לבקש שינוי בויזה לאחר שהיא נשלחה למייל שלי?"
      },
      {
        a: "<p>אל תהסס לחקור את הב </a> לוג <a href=\"/blog\"> שלנו לקבלת החדשות האחרונות, העדכונים והמדריכים המקיפים לקבלת אשרות לסרי לנקה. </p><p>בנוסף, הצוות שלנו מוכן להציע לך <a href=\"/contact\"> סיוע אנושי חי 24/7</a>. </p><p>תודה לך, צוות ויזנט. </p>",
        q: "יש לי שאלות נוספות"
      }
    ],
    meta_desc: "הגש בקשה לאישור נסיעה אלקטרוני לסרי לנקה באנגלית וקבל אותו תוך יום אחד",
    title: "ויזנט בקשה מקוונת eVisa לסרי לנקה {currentYear} {'|'}"
  },
  stamp: "חותמת",
  status_page: {
    applied: "יישומי",
    applied_desc: "יישמנו בהצלחה את הבקשה הרשמית בשמך. עכשיו אנחנו מחכים לאישור.",
    approval_doc: "מסמך אישור # {n}",
    approved: "מאושר",
    approved_desc: "מזל טוב! הבקשה שלך אושרה רשמית! כרגע אנחנו עוברים על כמה פרטים לפני שנשלח לך את המסמכים ואת כל המידע החשוב.",
    canceled: "בוטל",
    canceled_desc: "בקשה זו בוטלה.",
    check: "בדוק את מצב היישום",
    clock_img: "איור שעון",
    contact_us: "לשאלות דחופות או סיוע, אנא אל תהססו לפנות אלינו באמצעות:",
    current: "סטטוס:",
    email_address: "כתובת דוא\"ל",
    find_application_id: "ניתן למצוא את מזהה הבקשה שלך בדוא\"ל האישור ששלחנו לך לאחר הגשת הבקשה שלך. הקפד להכניס את אותה כתובת דוא\"ל שבה השתמשת במהלך תהליך הגשת הבקשה.",
    find_application_id_title: "ℹ️ היכן למצוא את מזהה היישום שלך?",
    find_here_1: "זמן אישור משוער",
    find_here_2: "התראות על כל המסמכים או השלבים הנוספים הנדרשים",
    find_here_3: "שלב העיבוד הנוכחי",
    find_here_body: "דף זה מספק עדכונים בזמן אמת על התקדמות בקשת הוויזה שלך, כולל:",
    find_here_title: "מה תמצאו כאן",
    future: "בהמתנה",
    future_desc: "אנו דוחים את בקשתך למועד מאוחר יותר, כך שתאריכי תוקף הוויזה שלך יתאימו לתאריכי הביקור שלך.",
    instructions_title: "בדוק את מצב בקשת הויזה שלך",
    intro: "ברוכים הבאים לדף מצב ויזה, שבו תוכל לעקוב אחר התקדמות בקשת הוויזה שלך באמצעות Visanet.",
    man_lays_on_laptop_img: "גבר מניח את ראשו על איור מקלדת מחשב נייד",
    may_download: "תוכל גם להוריד את מסמכי האישור שלך כאן:",
    meta_desc: "דף מצב הוויזה באתר שלנו מאפשר לך לבדוק את הסטטוס העדכני והמעודכן ביותר של בקשת הויזה שלך. כל שעליך לעשות הוא להכניס את מזהה ההזמנה שלך ב- Visanet",
    mistake: "טעות",
    mistake_desc: "מצאנו משהו בעייתי בטופס הבקשה שלך. אנא בדוק את תיבת הדואר הנכנס שלך לפרטים נוספים.",
    need_help_body: "אם אתה נתקל בבעיות כלשהן בגישה לסטטוס שלך או אם יש לך שאלות נוספות, אנא פנה לצוות התמיכה שלנו. אנחנו כאן כדי לעזור לך בכל צעד של הדרך.",
    need_help_title: "זקוק <span class='text-primary'> לעזרה? </span>",
    "new": "חדש",
    new_desc: "קיבלנו את טופס הבקשה שלך וכעת בודקים אותו לפני הגשת בקשה רשמית בשמך.",
    not_found: "לא הצלחנו למצוא את ההזמנה שלך באמצעות הפרטים שסופקו. הקפד להכניס את אותה כתובת דוא\"ל ששימשה בטופס הבקשה שלנו, ואת מזהה הבקשה מהודעת אישור ההזמנה ששלחנו.",
    pending: "בהמתנה",
    pending_desc: "קיבלנו את בקשתך, אך אנו עדיין מחכים למידע נוסף או תמונות ממך. אנא בדוק את הודעת האישור שלנו לקבלת פרטים נוספים.",
    phone: "טלפון:",
    progress_bar_on_card_img: "סרגל התקדמות עם סמלי מטוס ומזוודה בכרטיס כחול",
    rejected: "נדחה",
    rejected_desc: "בקשתך נדחתה. אנא בדוק את תיבת הדואר הנכנס שלך לפרטים נוספים.",
    sent: "ויזה נשלחה",
    sent_desc: "מזל טוב! הבקשה שלך אושרה רשמית! שלחנו את כל הפרטים החשובים בדוא\"ל.",
    success: "עדכון על מצב ההזמנה שלך נשלח לדוא\"ל שלך.",
    title: "בדוק את מצב בקשת הוויזה שלך • Visanet {currentYear}",
    visa_status: "סט <span class='text-primary'> טוס ויזה </span>",
    why_title: "למה לעקוב אחר מצב הוויזה שלך עם Visanet?"
  },
  stay_days: "{limit}ימים לביקור",
  stay_limit: "הישאר מעודכן עד:",
  street_number: "שורת כתובת",
  student: "סטודנט",
  success_page: {
    now_what: "אז מה קורה מנקודה זו ואילך?",
    pay_success: "תודה על התשלום שלך",
    step1_body_bahrain: "אתה צפוי לקבל ויזה אלקטרונית חתומה ישירות לדוא\"ל שלך תוך 3-5 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_cambodia: "אתה צפוי לקבל ויזה אלקטרונית חתומה ישירות לדוא\"ל שלך תוך 3-5 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_canada: "אתה צפוי לקבל eTA חתום ישירות לדוא\"ל שלך תוך 1-2 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_india: "אתה צפוי לקבל ויזה אלקטרונית חתומה ישירות לדוא\"ל שלך תוך 1-3 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_indonesia: "אתה צפוי לקבל ויזה אלקטרונית חתומה ישירות לדוא\"ל שלך תוך 3-5 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_israel: "אתה צפוי לקבל eTA חתום ישירות לדוא\"ל שלך תוך 1-2 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_korea: "אתה צפוי לקבל KETA חתום ישירות לדוא\"ל שלך תוך 1-3 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_morocco: "אתה צפוי לקבל ויזה אלקטרונית חתומה ישירות לדוא\"ל שלך תוך 1-3 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_new_zealand: "אתה צפוי לקבל NZeTA חתום ישירות לדוא\"ל שלך תוך 1-2 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_saudi_arabia: "אתה צפוי לקבל ויזה אלקטרונית חתומה ישירות לדוא\"ל שלך תוך 1-3 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_sri_lanka: "אתה צפוי לקבל ויזה אלקטרונית חתומה ישירות לדוא\"ל שלך תוך 1-2 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_thailand: "אתה צפוי לקבל ויזה אלקטרונית חתומה ישירות לדוא\"ל שלך בקרוב. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_togo: "אתה צפוי לקבל ויזה אלקטרונית חתומה ישירות לדוא\"ל שלך תוך 3-5 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_uk: "אתה צפוי לקבל ETA חתום בבריטניה ישירות לדוא\"ל שלך תוך 1-3 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_usa: "אתה צפוי לקבל ESTA חתום ישירות לדוא\"ל שלך תוך 1-3 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_vietnam: "אתה צפוי לקבל ויזה אלקטרונית חתומה ישירות לדוא\"ל שלך תוך 4-5 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_header: "ויזה אלקטרונית תישלח לדוא\"ל שלך",
    step2_body: "לכל שאלה, הערה או בקשה, אתה תמיד מוזמן <a href=\"/contact\"> לפנות אלינו</a>.",
    step2_header: "דרכים ליצור קשר",
    step3_body: "ותודה שבחרת בויזנט.",
    step3_header: "שיהיה לך מסע נעים",
    under_way_bahrain: "אנו נעבד מייד את בקשתך על סמך הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- eVisa שלך באמצעות רשויות ההגירה של בחריין.",
    under_way_cambodia: "אנו נעבד מייד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- eVisa שלך באמצעות רשויות ההגירה של קמבודיה.",
    under_way_canada: "אנו נעבד מיד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- eTA שלך באמצעות רשויות ההגירה של קנדה.",
    under_way_india: "אנו נעבד מייד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- eVisa שלך באמצעות רשויות ההגירה של הודו.",
    under_way_indonesia: "אנו נעבד מייד את בקשתך על סמך הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- eVisa שלך באמצעות רשויות ההגירה של אינדונזיה.",
    under_way_israel: "אנו נעבד מיד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- eTA שלך באמצעות",
    under_way_korea: "אנו נעבד מייד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- K-ETA שלך באמצעות רשויות ההגירה של דרום קוריאה.",
    under_way_morocco: "אנו נעבד מייד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- eVisa שלך באמצעות רשויות ההגירה של מרוקו.",
    under_way_new_zealand: "אנו נעבד מייד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- eVisa שלך באמצעות רשויות ההגירה של ניו זילנד.",
    under_way_saudi_arabia: "אנו נעבד מייד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- eVisa שלך באמצעות רשויות ההגירה של ערב הסעודית.",
    under_way_sri_lanka: "אנו נעבד מייד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- eVisa שלך באמצעות רשויות ההגירה של סרי לנקה.",
    under_way_thailand: "אנו נעבד מייד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- eVisa שלך באמצעות רשויות ההגירה של תאילנד.",
    under_way_togo: "אנו נעבד מייד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- eVisa שלך באמצעות רשויות ההגירה של טוגו.",
    under_way_uk: "אנו נעבד מיד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- ETA שלך בבריטניה באמצעות רשויות ההגירה של בריטניה.",
    under_way_usa: "אנו נעבד מיד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- ESTA שלך באמצעות רשויות ההגירה של ארצות הברית.",
    under_way_vietnam: "אנו נעבד מייד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- eVisa שלך באמצעות רשויות ההגירה של וייטנאם."
  },
  suggest_later_pic: "תמונות נדרשות לעיבוד בקשתך. אם אתה מעדיף לשלוח אותם מאוחר יותר,",
  support: "תמיכה",
  surname: "שם משפחה",
  tax_id: "פונדק",
  terms_of_use: "תנאים",
  terms_page: {
    meta_desc: "",
    title: "תנאי שימוש • ויזנט {currentYear}"
  },
  thailand: "תאילנד",
  thailand_page: {
    exempt_alert: "⚠ שימו לב: אזרח אמריקאי או <a data-exempt-list-opener> כל אחד מאותם לאומים </a> יכולים לבקר בתאילנד ללא ויזה עד 60 יום. ויזה לטווח קצר מומלצת אם ברצונכם להבטיח את הליך הכניסה המהיר והנוח ביותר בשדה התעופה. <br>📅 אם אתם מתכננים להישאר בתאילנד יותר מ- 60 יום ברציפות, אנו ממליצים להגיש בקשה לויזת DTV לטווח ארוך.",
    exempt_modal_title: "הודעת פטור מ- eVisa",
    faq: [
      {
        a: "ויזת DTV תקפה לחמש שנים מלאות, כאשר כל שהייה בתאילנד מאפשרת עד 180 ימים רצופים.",
        q: "כמה זמן תקפה ויזת DTV?"
      },
      {
        a: "ויזת DTV מאפשרת כניסות ללא הגבלה במהלך תוקפו של חמש שנים.",
        q: "כמה כניסות מותרות עם ויזת DTV?"
      },
      {
        a: "כל שעליך לעשות הוא <a href=\"#form\"> למלא את טופס הב </a> קשה המקוון שלנו, להעלות את המסמכים הדרושים, ואנו נטפל בשאר על ידי הגשת בקשתך למשרד ההגירה התאילנדי. תוך 14-21 ימי עסקים, תקבל את הויזה שלך ישירות בדוא\"ל, מוכנה להדפסה ולשימוש עם הכניסה לתאילנד.",
        q: "כיצד פועל תהליך הגשת בקשה לויזת DTV בוויזנט?"
      },
      {
        a: "כן. אזרחים מארה\"ב, בריטניה, קנדה, אוסטרליה, האיחוד האירופי ורוב המדינות הזכאות האחרות הנכנסות לתאילנד ללא ויזה יכולים להאריך את שהותם למשך 30 יום נוספים במשרד הגירה מקומי. עם ויזת DTV, ניתן להאריך עוד 180 יום; עם זאת, לרוב זה פשוט ומומלץ לצאת לתאילנד לזמן קצר (למשל, לוויי <a href=\"/vietnam\"> טנאם </a> או <a href=\"/cambodia\"> קמבודיה</a>) ולהיכנס מחדש כדי לאפס את קצבת 180 הימים שלך.",
        q: "האם אוכל להאריך את שהותי בתאילנד?"
      },
      {
        a: "אתה יכול להאריך את שהותך במשרדי הגירה גדולים ברחבי תאילנד, כולל: <ul> <li> <b> בנגקוק </b> - משרד ההגירה צ'אנג וואטנה </li> <li> <b> פוקט - משרד ההגירה של פוקט </li> <li> <b> צ'יאנג מאי </b> - משרד ההגירה צ'יאנג מאי פט </li> <li> <b> איה </b> - משרד ההגירה צ'ונבורי </li> <li> <b> קו סמוי </b> - משרד ההגירה של קו </b> סאמוי קראבי </li> <li> <b> </b>- משרד ההגירה קראבי הואה הי </li> <li> <b> ן </b> - משרד ההגירה פראצ'ואפ קירי חאן אודון תאני - משרד ההגירה </li> <li> <b> אודון תאני </b> </li> </ul>",
        q: "היכן אוכל להאריך את שהותי בתאילנד?"
      },
      {
        a: "כן. כל המסמכים המוגשים לרשויות ההגירה התאילנדיות חייבים להיות באנגלית או בתאילנדית. אם המסמכים שלך בשפה אחרת, אנא ספק תרגום מוסמך לאנגלית או תאילנדית.",
        q: "האם המסמכים שלי צריכים להיות באנגלית או בתאילנדית?"
      },
      {
        a: "כן, ויזת DTV מאפשרת כניסה דרך כל שדה תעופה בינלאומי, נמל ימי או מעבר גבול יבשתי רשמי בתאילנד.",
        q: "האם אוכל להיכנס לתאילנד עם ויזת DTV דרך כל שדה תעופה או גבול?"
      },
      {
        a: "ויזה לטווח קצר אינה נדרשת לכניסה ללא ויזה עד 60 יום לאזרחים מארה\"ב, בריטניה, קנדה, אוסטרליה, האיחוד האירופי ולאומים זכאים אחרים. עם זאת, זה יכול להיות מועיל אם אתה מעדיף להימנע מהמתנה בקווי הגירה לשדה התעופה ולהבטיח כניסה מהירה וחלקה לתאילנד.",
        q: "האם יש יתרון לקבל ויזה לטווח קצר אם אני נשאר פחות מ -60 יום?"
      },
      {
        a: "לא. אזרחים ממדינות אלה יכולים להיכנס לתאילנד ללא ויזה לשהייה של עד 60 יום (עם הארכה אופציונלית של 30 יום זמינה מקומית במשרדי ההגירה התאילנדיים). אשרה נחוצה רק לשהיות ארוכות יותר או כדי להבטיח כניסה מהירה וחלקה. <details><summary>רשימה מלאה של לאומים זכאים </summary> אלבניה, אנדורה, אוסטרליה, אוסטריה, בחריין, בלגיה, בהוטן, ברזיל, ברוניי, בולגריה, קמבודיה, קנדה, סין, קולומביה, קרואטיה, קובה, קפריסין, צ'כיה, דנמרק, דומיניקה, הרפובליקה הדומיניקנית, אקוודור, אסטוניה, פיג'י, פינלנד, צרפת, ג'ורג'יה, גרמניה, יוון, גואטמלה, הונג קונג, הונגריה, איסלנד, הודו, אינדונזיה, אירלנד, ישראל, איטליה, ג'מייקה, יפן, ירדן קזחסטן, קוריאה (ROK), קוסובו, כווית, לאוס, לטביה, ליכטנשטיין, ליטא, לוקסמבורג, מקאו, מלזיה, האיים המלדיביים, מלטה, מאוריציוס, מקסיקו, מונקו, מונגוליה, מרוקו, הולנד, ניו זילנד, נורבגיה, עומאן, פנמה, פפואה גינאה החדשה, פרו, פיליפינים, פולין, פורטוגל, קטאר, רומניה, רוסיה, סן מרינו, ערב הסעודית, סינגפור, סלובקיה, סלובניה, ספרד, סרי לנקה, דרום אפריקה, שוודיה, שוויץ, טייוואן, טונגה, טרינידד וטובגו, טורקיה, אוקראינה, איחוד האמירויות הערביות, בריטניה, ארה\"ב, אורוגוואי, אוזבקיסטן, וייטנאם </details>",
        q: "האם אזרחים מארה\"ב, בריטניה, קנדה, אוסטרליה ומדינות האיחוד האירופי זקוקים לויזה לתאילנד?"
      },
      {
        a: "ילדים מארה\"ב, בריטניה, קנדה, אוסטרליה, האיחוד האירופי, ואינם זקוקים לויזה לשהייה עד 60 יום. לשהיות ארוכות יותר נדרשת ויזה נפרדת לכל ילד.",
        q: "האם ילדים זקוקים לויזה לתאילנד?"
      },
      {
        a: "<ul><li>ויזה תיירותית בכניסה יחידה (90 יום) - eVisa תיירו {thailand_3_months_price} </li> <li> תית מרובת כניסות (180 יום) - {thailand_6_months_price} </li> </ul>",
        q: "אילו אשרות לטווח קצר זמינות לתאילנד?"
      },
      {
        a: "עבור אשרת DTV לטווח ארוך, אנו ממליצים להגיש בקשה לפחות 3-4 שבועות לפני מועד הנסיעה המתוכנן שלך כדי להבטיח עיבוד חלק ומתוזמן. עבור ה- eVisa לטווח הקצר, שבועיים מספיקים.",
        q: "כמה זמן מראש עלי להגיש בקשה לויזה?"
      },
      {
        a: "אנחנו תמיד זמינים דרך <a href=\"{whatsapp}\"> WhatsApp</a>, צ' <a data-chat-opener> אט מקוון </a></a>, <a href=\"mailto:{email}\"> דוא\"ל או <a href=\"tel:{phone}\"> טלפון</a>. יש לך שאלות נוספות? אל תהססו לפנות אלינו - תאילנד מחכה לכם, ואנחנו כאן כדי להפוך את הנסיעה שלכם לקלה וללא מתח!",
        q: "כיצד אוכל לקבל עזרה נוספת או הדרכה אישית?"
      }
    ],
    meta_desc: "הגש בקשה לויזה אלקטרונית רשמית לתאילנד באנגלית. קבל ויזה מבלי לבקר בשגרירות, תהליך מהיר ונוח",
    title: "ויזה אלקטרונית לתאילנד - יישום מקוון קל Visanet {currentYear} {'|'}"
  },
  togo: "טוגו",
  togo_page: {
    meta_desc: "הגש בקשה לויזה אלקטרונית רשמית לטוגו באנגלית. קבל ויזה מבלי לבקר בשגרירות, תהליך מהיר ונוח",
    title: "ויזה אלקטרונית לטוגו - יישום מקוון קל ויזנט {currentYear} {'|'}"
  },
  total_price: "מחיר כולל",
  transfer_payment: "תשלום על ידי חשבון",
  uk: "בריטניה",
  uk_evisa: "בריטניה ו",
  uk_page: {
    faq: [
      {
        a: "ה <strong> - ETA בבריטניה (אישור נסיעה אלקטרוני) </strong> הוא ויתור אלקטרוני על ויזה הנדרש למטיילים המבקרים בבריטניה 🇬🇧. <br>הוא משמש כאישור רשמי מרשויות ההגירה בבריטניה, ומאפשר לך להיכנס לאנגליה, סקוטלנד, ויילס וצפון אירלנד ללא צורך בויזה מסורתית.",
        q: "מהו ה- ETA בבריטניה?"
      },
      {
        a: "מטיילים ממדינות זכאות יכולים להגיש בקשה לקבלת ETA בבריטניה באופן מקוון. תוכל לצפות ברשימת המדינות הזכאות <a data-eligibility-list-opener> כאן</a>.",
        q: "מי זכאי להגיש בקשה ל- ETA בבריטניה?"
      },
      {
        a: "ℹ הגשת בקשה ל- ETA בבריטניה היא פשוטה: <br> <ol> <li> מלא את טופס הבקשה המקוון. </li><li>העלה את הדרכון שלך ותמונה אחרונה. </li><li>שלם את האגרה והגיש את בקשתך. </li></ol>לאחר אישור, ה- ETA שלך בבריטניה יישלח ישירות לדוא\"ל שלך תוך 1-3 ימים.",
        q: "כיצד פועל תהליך הגשת הבקשה ל- ETA בבריטניה?"
      },
      {
        a: "ה- ETA בבריטניה תקף לשנ <strong> תיים </strong> או עד שתוקף הדרכון שלך יפוג, המוקדם מביניהם.",
        q: "כמה זמן תקף ה- ETA בבריטניה?"
      },
      {
        a: "ה- ETA בבריטניה מאפשר שהייה של עד <strong> 6 חודשים לכל ביקור</strong>.",
        q: "כמה זמן אוכל להישאר בבריטניה עם ETA?"
      },
      {
        a: "דמי ה- ETA בבריטניה הם{price}. זה כולל עמלות ממשלתיות ועיבוד באמצעות המערכת המאובטחת שלנו.",
        q: "כמה עולה ETA בבריטניה?"
      },
      {
        a: "לא, אתה יכול להגיש בקשה ל- ETA בבריטניה גם אם עדיין לא הזמנת את הטיסה שלך ✈️",
        q: "האם עלי להזמין את הטיסה שלי לפני הגשת בקשה ל- ETA בבריטניה?"
      },
      {
        a: "לא, אם כבר יש לך ויזה תקפה לבריטניה, אתה יכול להשתמש בה לטיול שלך. ה- ETA נדרש רק למי שאין לו ויזה פעילה בבריטניה.",
        q: "יש לי כבר ויזה תקפה לבריטניה. האם אני עדיין צריך ETA?"
      },
      {
        a: "כן, גם אם אתה עובר דרך בריטניה בדרכך ליעד אחר, תזדקק ל- ETA תקף בבריטניה.",
        q: "האם אני צריך ETA בבריטניה למעבר דרך בריטניה?"
      },
      {
        a: "ה- ETA בבריטניה הוא אלטרנטיבה מהירה ונוחה יותר לויזה מסורתית. זה דיגיטלי לחלוטין, כלומר אינך צריך לבקר בשגרירות או לשלוח מסמכים פיזיים. התהליך אורך בדרך כלל 1-3 ימים בלבד, בהשוואה לשבועות עבור ויזה רגילה.",
        q: "מה ההבדל בין ETA בבריטניה לבין ויזה מסורתית?"
      },
      {
        a: "כן, כל הנוסעים, כולל ילדים ותינוקות (בגילאי 0-18), דורשים ETA בבריטניה כדי להיכנס לבריטניה. אתה יכול לכלול ילדים ביישום שלך לנוחות נוספת.",
        q: "האם ילדים זקוקים ל- ETA בבריטניה?"
      }
    ],
    meta_desc: "הגש בקשה ל- ETA שלך בבריטניה באופן מקוון עם Visanet בשנת 2024. תהליך הגשת בקשה מהיר ומאובטח. קבל את אישור הנסיעה שלך במהירות ובקלות.",
    title: "ETA בבריטניה - ויזת בקשה לויזה מקו {currentYear} {'|'} ונת"
  },
  underage: "קטינים",
  unemployed: "מובטלים",
  unexpected_payment_error: "אירעה שגיאה בלתי צפויה. אנא נסה שוב או צור איתנו קשר לקבלת עזרה",
  upload_images_now: "העלה כאן",
  urgent_visa_fast_service: "ויזה דחופה - עיבוד מהיר",
  usa: "\"ארה\"\"ב\"",
  usa_evisa: "ESTA של ארצות הברית",
  usa_page: {
    faq: [
      {
        a: "<p>לאחרונה מדינות רבות נכנסו לרשימת המדינות הפטורות מוויזה לארה\"ב. למרות שזה אומר שהכניסה היא הרבה יותר פשוטה, זה עדיין לא אומר שאין צורך בהיתר כניסה. <br><br>כאן היתר הכניסה החדש של ארצות הברית, ה- <strong> E </strong> lectronic <strong> S </strong> system for <strong> T </strong> ravel <strong> A </strong> uthorization, או בקיצור <strong> ESTA</strong>, בדומה לוויזה אלקטרונית, הוא מסמך מטעם רשויות ההגירה של ארצות הברית שמותר לך להיכנס לגבולות המדינה. עם ESTA לארה\"ב תקבל אישור ממשלתי לטוס ולבקר בארצות הברית. </p>",
        q: "מהי אשרת כניסה של ESTA לארה\"ב?"
      },
      {
        a: "<p>אם אתה רוצה להיכנס לארה\"ב באמצעות דרכון תואם ESTA, התשובה היא כן. בעבר היית צריך לקבל ויזה רגילה (פיזית), שכללה עלות גבוהה יותר, הגעה לקונסוליה, ויש לך סיכוי אמיתי מאוד שהבקשה תידחה לחלוטין. <br>היום הדברים פשוטים יותר, והכל יכול להיעשות באמצעות טופס מקוון קצר ופשוט. </p>",
        q: "האם אני צריך ESTA כדי להיכנס לארצות הברית?"
      },
      {
        a: "מטיילים ממדינות זכאות יכולים להגיש בקשה ל-ESTA בארה\"ב באופן מקוון. תוכל לבדוק את רשימת המדינות הזכאות <a data-eligibility-list-opener> כאן</a>.",
        q: "מי זכאי להגיש בקשה ל- ESTA בארה\"ב?"
      },
      {
        a: "יום או יומיים לאחר הגשת הטופס המקוון באתר האינטרנט שלנו, אישור ה- ESTA לארצות הברית יישלח כמסמך מצורף לדוא\"ל שלך. מספר האישור יצורף גם להודעה, דרכה תקבל חותמת רשמית בדרכון שלך כשתגיע לבקרת הגבול בעת כניסתך לארה\"ב.",
        q: "כיצד פועל תהליך ה- ESTA?"
      },
      {
        a: "אישור הויזה האמריקני (ESTA) תקף לשנתיים או עד שתוקף הדרכון שלך יפוג, המוקדם מביניהם.",
        q: "כמה זמן תקף ה- ESTA?"
      },
      {
        a: "לאחר שנכנסת לארה\"ב באמצעות ESTA, אתה רשאי להישאר עד 90 יום לכל היותר.",
        q: "מהי מגבלת השהייה המקסימלית בארה\"ב עם ESTA?"
      },
      {
        a: "עלות הוועדה הממשלתית היא 21 דולר. אתה יכול להאיץ את התהליך באמצעות הטופס הפשוט שלנו כאן באתר, במחיר הטוב ביותר.",
        q: "כמה עולה ESTA?"
      },
      {
        a: "אורך התהליך תלוי באופן שמילאת את הפרטים האישיים שלך. ניתן לעשות זאת באמצעות האתר הרשמי של ESTA, שאינו ידידותי למשתמש במיוחד, ואינו כולל תמיכה או עזרה מכל סוג שהוא. זה עשוי להאריך באופן משמעותי את ההליך עבורך. עם זאת, אתה יכול למקם את היישום דרכנו, ממש כאן באתר. האישור מגיע תוך שלושה ימים.",
        q: "כמה זמן לוקח להנפיק ESTA?"
      },
      {
        a: "כן. אחד התנאים החובה לקבלת היתר הכניסה (ESTA) לארצות הברית הוא דרכון ביומטרי.",
        q: "האם אני צריך דרכון ביומטרי כדי לקבל ויזה באמצעות ESTA?"
      },
      {
        a: "לא, זה לא נדרש. ניתן להנפיק אשרת כניסה גם אם טרם קנית כרטיס טיסה.",
        q: "האם עלי לרכוש כרטיסי טיסה לפני הגשת בקשה ל- ESTA?"
      },
      {
        a: "כן. תוכנית הפטור מוויזה אינה מבטלת אשרות קיימות כמו ויזה פיזית למשך 10 שנים, אלא פועלת לצידן.",
        q: "יש לי כבר ויזה תקפה. אני יכול פשוט להשתמש בו?"
      },
      {
        a: "גם הוויזה המסורתית וגם הוויזה האלקטרונית הם מסמכים שמטרתם לאשר את כניסתך והשהייה בארה\"ב. הויזה האלקטרונית (אישור כניסה אלקטרונית ESTA) הומצאה על מנת להקל על חייכם - אין צורך לשלוח מסמכים פיזית בדואר, להגיע לשגרירות ולחכות שבועות לתשובה ולקבל את הדרכון בחזרה - באתרים שלנו התהליך כולו מתבצע באופן מקוון, באנגלית וללא צורך לצאת מהבית, תוך 1-3 ימים בלבד.",
        q: "מה ההבדל בין ויזה רגילה לויזה אלקטרונית?"
      },
      {
        a: "<p>אל תהסס לחקור את </a> הבלוג <a href=\"/blog\"> שלנו לקבלת החדשות האחרונות, העדכונים והמדריכים המקיפים להשגת ETA לארה\"ב. </p><p>בנוסף, הצוות שלנו מוכן להציע לך <a href=\"/contact\"> סיוע אנושי חי 24/7</a>. </p><p>תודה לך, צוות ויזנט. </p>",
        q: "יש לי שאלות נוספות"
      }
    ],
    meta_desc: "הגש בקשה ל- ESTA שלך לארה\"ב באופן מקוון עם Visanet בשנת 2024. תהליך הגשת בקשה מהיר ומאובטח. קבל את אישור הנסיעה שלך במהירות ובקלות.",
    title: "ESTA לארה\"ב - ויזנט לבקשת ויזה מקו {currentYear} {'|'} ונת"
  },
  use_coupon: "קופון",
  valid_for: "תקף ל:",
  validity_range_bahrain: "14+ ימים",
  validity_range_cambodia: "30 ימים",
  validity_range_canada: "5 שנים",
  validity_range_india: "30+ ימים",
  validity_range_indonesia: "60+ ימים",
  validity_range_israel: "2 שנים",
  validity_range_korea: "3 שנים",
  validity_range_morocco: "180 ימים",
  validity_range_new_zealand: "2 שנים",
  validity_range_saudi_arabia: "365 ימים",
  validity_range_sri_lanka: "החל מ 30 יום",
  validity_range_thailand: "90+ ימים",
  validity_range_togo: "15+ ימים",
  validity_range_uk: "2 שנים",
  validity_range_usa: "2 שנים",
  validity_range_vietnam: "90 ימים",
  vietnam: "וייטנאם",
  vietnam_evisa: "ויזה אלקטרונית בווייטנאם",
  vietnam_holiday_alert: {
    body: "מחלקת ההגירה בווייטנאם תהיה סגורה בין 30 באפריל ל -5 במאי 2025 לחג לאומי. לא יונפקו ויזות במהלך תקופה זו. אנא תכנן בהתאם. תודה לך!",
    title: "הודעה: סגירת חג"
  },
  vietnam_page: {
    faq: [
      {
        a: "ממשלת וייטנאם הציגה מערכת ויזה אלקטרונית פיילוט לתושבי <a href=\"https://evisa.xuatnhapcanh.gov.vn/documents/20181/117155/Vietnam-Evisa-nation-list.pdf/21e0f88f-d8a0-48b8-bfdb-a0f82b0853e2\" target=\"_blank\"> 80 מדינות</a>. כל אדם המחזיק בדרכון מאחת המדינות הללו רשאי להגיש בקשה לויזה אלקטרונית לווייטנאם.",
        q: "אילו אנשים יכולים להגיש בקשה לויזה אלקטרונית?"
      },
      {
        a: "עם קבלת הבקשה והתשלום המלאים, מחלקת ההגירה בווייטנאם בדרך כלל מעבדת ויזה אלקטרונית תוך 3 ימי עסקים.",
        q: "מהו זמן העיבוד של ויזה אלקטרונית בווייטנאם?"
      },
      {
        a: "ויזה אלקטרונית היא ויזה לכניסה יחידה או רב-כניסה שתוקפה למשך 90 יום לכל היותר.",
        q: "מהו משך תוקפו של ויזה אלקטרונית?"
      },
      {
        a: "כדי להיות זכאי לוויזה אלקטרונית, תאריך התפוגה של הויזה חייב להיות לפחות 90 יום לפני תאריך התפוגה של הדרכון, כפי שנקבע בחוק וייטנאמי.",
        q: "מהו תאריך התפוגה המינימלי של הדרכון הנדרש להגשת בקשה לויזה אלקטרונית?"
      },
      {
        a: "לאחר קבלת ויזה אלקטרונית תקפה בווייטנאם, אינך נדרש לעמוד בתור בדלפקי הוויזה להגעה. יש לך אפשרות להציג את הויזה האלקטרונית והדרכון המודפסים שלך ישירות בדלפק ההגירה.",
        q: "האם יש צורך לחכות בתור בדלפק הוויזה להגעה בווייטנאם?"
      },
      {
        a: "בדרך כלל, זמן העיבוד עבור ויזה אלקטרונית בווייטנאם הוא 2-3 ימים. עם זאת, מומלץ להגיש את בקשתך לפחות 10 עד 14 ימים לפני הגעתך המיועדת כדי לאפשר עיכובים פוטנציאליים. מניסיוננו, ייתכן שיחלפו עד שמונה ימים כדי לקבל תוצאות, בגלל חגים. לכן חשוב לתכנן בהתאם.",
        q: "מהו פרק הזמן המומלץ להגשת בקשה לוויזה האלקטרונית של וייטנאם?"
      },
      {
        a: "בהתאם לתקנות הוויזה האלקטרונית של וייטנאם, אתה רשאי להיכנס למדינה רק דרך נמל הכניסה שבחרת במהלך תהליך הגשת הבקשה, אשר יפורט גם במסמך הויזה שלך. אמנם יתכנו מקרים שבהם אתה יכול להיכנס דרך שדה תעופה אחר מזה הרשום בויזה האלקטרונית שלך לווייטנאם, אך מומלץ להימנע מלעשות זאת. חברות תעופה עשויות לסרב לתת לך לעלות על הטיסה שלך, וזו הבעיה הנפוצה ביותר. אם תצליחו לעלות, לקצין ההגירה ביעד ההגעה שלכם תהיה המילה האחרונה אם מותר לכם להיכנס או לא. כדי למזער את הסיכון לבעיות, אנו ממליצים לדבוק בשדה התעופה או בגבול היבשתי שבחרת. במקרה שתוכניות הנסיעה שלך ישתנו באופן בלתי צפוי, עדיף לבחור בנמל התעופה הו צ'י מין סיטי, האנוי או דה נאנג כנמל הכניסה שלך, מכיוון שהם מקבלים נפח גבוה יותר של טיסות בינלאומיות, מה שנותן לך סיכוי טוב יותר להיכנס לשם, אפילו ברגע האחרון.",
        q: "האם ניתן להיכנס לווייטנאם דרך נמל כניסה שונה מזה שצוין בויזה האלקטרונית?"
      },
      {
        a: "ניתן להשתמש בויזה האלקטרונית של וייטנאם כדי להיכנס למדינה דרך <a href=\"https://evisa.xuatnhapcanh.gov.vn/documents/20181/117155/List-of-evisa-port.pdf/c774e24b-1ab8-4fb6-9ac1-dcdfaccecf8e\" target=\"_blank\"> 33 מחסומים בינלאומיים שונים</a>, הכוללים שדות תעופה, גבולות יבשתיים ונמלי ים.",
        q: "מהן נקודות הכניסה והיציאה הזמינות בהן ניתן להשתמש בויזה האלקטרונית של וייטנאם?"
      },
      {
        a: "דמי העיבוד בסך 25 דולר עבור ויזה אלקטרונית בווייטנאם אינם ניתנים להחזר ולא ניתן להחזיר אותם בשום פנים ואופן, ללא קשר לתוצאות הבקשה.",
        q: "האם ניתן להחזיר את דמי הויזה האלקטרונית של וייטנאם?"
      },
      {
        a: "כן, למרות הגשת בקשה לויזה אלקטרונית של וייטנאם באופן מקוון לחלוטין, חובה להדפיס עותק פיזי ולהציג אותו עם ההגעה לווייטנאם.",
        q: "האם יש צורך להדפיס את הוויזה האלקטרונית של וייטנאם?"
      },
      {
        a: "אם טופס בקשת הוויזה האלקטרונית שלך בווייטנאם אינו שלם או מכיל מידע לא מדויק, מחלקת ההגירה עשויה לבקש ממך מידע נוסף. במקרים נדירים, הם עשויים גם לדחות את בקשתך.",
        q: "מה קורה אם הכנסתי מידע שגוי או לא חוקי בטופס בקשת הוויזה האלקטרונית של וייטנאם?"
      },
      {
        a: "כדי להיכנס לווייטנאם עם הוויזה האלקטרונית של וייטנאם, עליך להציג עותק מודפס של מסמך הוויזה האלקטרונית (מודפס מתוך קובץ PDF - תקבל קובץ זה בדוא\"ל האישור שאנו שולחים לך) ואת הדרכון שלך.",
        q: "אילו מסמכים נדרשים להציג עם ההגעה לווייטנאם עם הוויזה האלקטרונית של וייטנאם?"
      },
      {
        a: "ניתן להגיע מאוחר יותר מתאריך הכניסה המצוין בבקשת הוויזה האלקטרונית שלך בווייטנאם, אך אינך יכול להגיע מוקדם יותר. חשוב לציין שתאריך הכניסה שתציין בבקשתך נחשב לתאריך ההתחלה של תקופת תוקפו של הויזה שלך, גם אם הויזה האלקטרונית מגיעה מאוחר מהצפוי.",
        q: "האם מותר להגיע לווייטנאם בתאריכים שונים מאלה המפורטים בויזה האלקטרונית?"
      },
      {
        a: "<p>אל תהסס לחקור את הב </a> לוג <a href=\"/blog\"> שלנו לקבלת החדשות האחרונות, העדכונים והמדריכים המקיפים לקבלת אשרות לווייטנאם. </p><p>בנוסף, הצוות שלנו מוכן להציע לך <a href=\"/contact\"> סיוע אנושי חי 24/7</a>. </p><p>תודה לך, צוות ויזנט. </p>",
        q: "יש לי שאלות נוספות"
      }
    ],
    meta_desc: "הגש בקשה לויזה אלקטרונית רשמית לווייטנאם באנגלית. קבל ויזה מבלי לבקר בשגרירות, תהליך מהיר ונוח",
    title: "ויזה אלקטרונית לווייטנאם - יישום מקוון קל Visanet {currentYear} {'|'}"
  },
  visa_example_bahrain: "ראה דוגמה ל- eVisa",
  visa_example_cambodia: "ראה דוגמה ל- eVisa",
  visa_example_canada: "ראה דוגמה eTA",
  visa_example_india: "ראה דוגמה ל- eVisa",
  visa_example_indonesia: "ראה דוגמה ל- eVisa",
  visa_example_israel: "ראה דוגמה של ETA-IL",
  visa_example_korea: "ראה דוגמה K-ETA",
  visa_example_morocco: "ראה דוגמה ל- eVisa",
  visa_example_new_zealand: "ראה דוגמה של NZeTA",
  visa_example_saudi_arabia: "ראה דוגמה ל- eVisa",
  visa_example_sri_lanka: "ראה דוגמה ל- eVisa",
  visa_example_thailand: "ראה דוגמה ל- eVisa",
  visa_example_togo: "ראה דוגמה ל- eVisa",
  visa_example_uk: "ראה דוגמה ETA בבריטניה",
  visa_example_usa: "ראה דוגמה ל- ESTA",
  visa_example_vietnam: "ראה דוגמה ל- eVisa",
  visa_form_resume_link: "קישור להמשך טופס הויזה האלקטרונית",
  visa_ready_within: "זמן אישור:",
  visa_ready_within_priority: "זמן אישור:",
  visa_rejection_or_expel: "כולל דחיית ויזה או גירוש ממדינה.",
  visa_select: "בחירת ויזה",
  visa_status: "סטטוס",
  visa_to_bahrain: "ויזה לבחריין",
  visa_to_cambodia: "ויזה לקמבודיה",
  visa_to_canada: "ויזה לקנדה ETA",
  visa_to_india: "ויזה להודו",
  visa_to_indonesia: "ויזה לאינדונזיה",
  visa_to_israel: "ויזה לישראל ETAIL",
  visa_to_korea: "ויזה לדרום קוריאה KETA",
  visa_to_morocco: "ויזה למרוקו",
  visa_to_new_zealand: "ויזה לניו זילנד NZeTA",
  visa_to_saudi_arabia: "ויזה לסעודיה",
  visa_to_sri_lanka: "ויזה לסרי לנקה",
  visa_to_thailand: "ויזה לתאילנד",
  visa_to_togo: "ויזה לטוגו",
  visa_to_uk: "ויזה ל- ETA בבריטניה",
  visa_to_usa: "ויזה ל- ESTA בארה\"ב",
  visa_to_vietnam: "ויזה לווייטנאם",
  visa_type_info: "מידע על ויזה",
  visit_details: "פרטי ביקור",
  visited_vietnam_past_10_years: "ביקרת בווייטנאם בעשר השנים האחרונות?",
  waiting_business_days: "יום עסקים אחד | {days} ימי עסקים",
  waiting_business_days_nominative: "יום עסקים אחד | {days} ימי עסקים | {days} ימי עסקים",
  waiting_days: {
    bahrain: "3-5 ימים",
    cambodia: "3-5 ימים",
    canada: "1-2 ימים",
    india: "1-3 ימים",
    indonesia: "5 ימים",
    israel: "1-2 ימים",
    korea: "1-3 ימים",
    morocco: "1-3 ימים",
    new_zealand: "1-2 ימים",
    saudi_arabia: "1-3 ימים",
    sri_lanka: "1-2 ימים",
    thailand: "3-21 ימים",
    togo: "1-3 ימים",
    uk: "1-3 ימים",
    usa: "1-3 ימים",
    vietnam: "1-7 ימים"
  },
  waiting_days_nominative: "יום אחד | {days} ימים | {days} ימים",
  want_kids_visa: "אנחנו צריכים גם ויזות לילדים",
  we_are_pci_compliant: "התשלומים באתר שלנו מוגנים בצורה מאובטחת באמצעות הצפנת SSL ותואמים באופן מלא לתק {year} ני PCI הבינלאומיים.",
  website: "אתר אינטרנט",
  website_hint: "כתובת האתר של העסק שלך. אופציונלי.",
  what_is_said_about_us: "מה אנשים אומרים עלינו?",
  whatsapp: "וואטסאפ",
  whatsapp_images_continue: "אנא שלח את התמונות שלך באמצעות WhatsApp בכתובת <a href=\"{url}\" target=\"_blank\"> {phone}</a>. <br>אתה יכול להמשיך לאחר מכן.",
  when_was_visit: "מתי היה הביקור האחרון שלך?",
  where_passport_issue_place: "ציין אם הנפקת את הדרכון בישראל או מחוצה לו <br> הסניף מצוין בסעיף 'סמכות קצין דרכונים'",
  where_stayed_in_india: "איפה היית בהודו?",
  which_countries_you_visited: "באילו מדינות ביקרת?",
  which_country_date: "כלול פרטים כגון המדינה, התאריך והנסיבות.",
  year: "שנה",
  yes: "הן"
};
